<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="orderHomepage-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            订单信息
          </div>
          <div v-loading="loading" class="card-content">
            <div class="order-info">
              <span class="tit">订单号：</span>
              <span>{{ orderInfo.ordernum }}</span>
              <span class="tit mf">生产单号：</span>
              <span v-if="orderInfo.produnum!==null&&orderInfo.produnum!==''&&orderInfo.produnum!==undefined" style="color:#409EFF;font-weight: 500">{{ orderInfo.produnum }}</span>
              <span v-if="orderInfo.produnum===null||orderInfo.produnum===''||orderInfo.produnum===undefined" style="color:#999999;font-weight: 500">N/A</span>
              <span class="tit mf">订单类型：</span>
              <span v-if="orderInfo.type===0">正单</span>
              <span v-if="orderInfo.type===1">客改单</span>
              <span v-if="orderInfo.type===2">增补单</span>
              <span v-if="orderInfo.type===3">色板单</span>
              <span v-if="orderInfo.type===4">售后单</span>
              <span class="tit mf">订单性质：</span>
              <span v-if="orderInfo.nature===0">家装</span>
              <span v-if="orderInfo.nature===1">展厅</span>
              <span v-if="orderInfo.nature===2">工程</span>
              <span v-if="orderInfo.type!==0" class="tit mf">原正单号：</span>
              <span v-if="orderInfo.type!==0&&(orderInfo.oldorderid===null||orderInfo.oldorderid===''||orderInfo.oldorderid===undefined)">{{ orderInfo.beforenum }} <el-tag v-if="orderInfo.beforeyear!==null&&orderInfo.beforeyear!==''&&orderInfo.beforeyear!==undefined" size="mini" type="warning" :disable-transitions="true">{{ orderInfo.beforeyear }}年</el-tag></span>
              <span v-if="orderInfo.type!==0&&orderInfo.oldorderid!==null&&orderInfo.oldorderid!==''&&orderInfo.oldorderid!==undefined"><router-link :to="'/work/order/'+orderInfo.oldorderid" style="font-size: 13px;color:#409EFF;"><i class="el-icon-document" /> {{ orderInfo.beforenum }}</router-link> <el-tag v-if="orderInfo.beforeyear!==null&&orderInfo.beforeyear!==''&&orderInfo.beforeyear!==undefined" size="mini" type="warning" :disable-transitions="true">{{ orderInfo.beforeyear }}年</el-tag></span>
              <span v-if="orderInfo.type===3&&(orderInfo.oldorderid===null||orderInfo.oldorderid===''||orderInfo.oldorderid===undefined)">N/A</span>

              <span v-if="orderInfo.type!==0 && orderInfo.type!==3 && orderInfo.oldDesigner" class="tit mf">原正单拆单设计师：</span>
              <span v-if="orderInfo.type!==0 && orderInfo.type!==3 && orderInfo.oldDesigner">{{ orderInfo.oldDesigner }}</span>
            </div>
            <div class="order-info">
              <span class="tit">经销商：</span>
              <span :style="orderInfo.all_name && orderInfo.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                {{ orderInfo.all_name }}
              </span>
              <span class="tit mf">客户名称：</span>
              <span>{{ orderInfo.custname }}</span>
              <span class="tit mf">客户电话：</span>
              <span>{{ orderInfo.custtel }}</span>
              <span class="tit mf">详细地址：</span>
              <span>{{ orderInfo.address }}</span>
            </div>
            <div class="order-info">
              <span class="tit">设计师：</span>
              <span>{{ orderInfo.designer }}</span>
              <span class="tit mf">设计师电话：</span>
              <span>{{ orderInfo.designerTel }}</span>
              <span class="tit mf">品牌：</span>
              <span>{{ orderInfo.brand_name }}</span>
              <!-- <span class="tit mf">南北工艺：</span>
              <span>{{ orderInfo.craft == 1 ? '南' : (orderInfo.craft == 2 ? '北' : '-') }}</span> -->
              <span class="tit mf">色板来源：</span>
              <span>{{ orderInfo.source }}</span>
              <!--              <span v-if="orderInfo.source===0">厂部标准色板</span>-->
              <!--              <span v-if="orderInfo.source===1" style="color:#F56C6C">客户提供色板</span>-->
              <!--              <span v-if="orderInfo.source===2" style="color:#F56C6C">厂部定制色板</span>-->
              <span class="tit mf">料单总平方数：</span>
              <span>{{ orderInfo.pf ? Math.round(orderInfo.pf * 100) / 100 + ' ㎡': '--' }}</span>
              <span class="tit mf">是否冲单：</span>
              <span>{{ orderInfo.cd == 2 ? '历史冲单' : (orderInfo.cd == 1 ? '是' : '否') }}</span>
              <template v-if="orderInfo.type == 4">
                <span class="tit mf">是否需要收款：</span>
                <span>{{ orderInfo.fk == 1 ? '不需要' : '需要' }}</span>
              </template>
            </div>
            <div class="order-info">
              <span v-if="roleInfo.money===1" class="tit">预估价格：</span>
              <span v-if="roleInfo.money===1&&orderInfo.estimated!==null&&orderInfo.estimated!==undefined&&orderInfo.estimated!=0">{{ orderInfo.estimated }} 元</span>
              <span v-if="roleInfo.money===1&&(orderInfo.estimated===null||orderInfo.estimated===undefined||orderInfo.estimated<=0)">未填写</span>
              <span :class="roleInfo.money===1?'tit mf':'tit'">下单日期：</span>
              <span>{{ orderInfo.time }}</span>
              <span class="tit mf">期望交期：</span>
              <span>{{ orderInfo.exptime }}</span>
              <span class="tit mf">计划交期：</span>
              <span>{{ orderInfo.plannedAdd }}</span>
              <span class="tit mf">订单所属：</span>
              <span>{{ orderInfo.group_name }}</span>
              <span class="tit mf">区域经理：</span>
              <span>{{ allInfo.area ? allInfo.area.dName : '--' }}</span>
              <span class="tit mf">跟单客服：</span>
              <span>{{ allInfo.serve ? allInfo.serve.dName : '--' }}</span>
            </div>
            <div class="menu-list">
              <div v-if="roleInfo.jd===1 && orderInfo.mark>0 && orderInfo.mark<13" class="menu-item" @click="editOrderInfo">
                <div class="menu-item-img"><svg-icon icon-class="edit_order" /></div>
                <div class="menu-item-name" style="color:#409EFF">修改订单</div>
              </div>
              <div v-if="afterInfo!==null&&afterInfo!==undefined&&orderInfo.mark>3&&roleInfo.shcl===1" class="menu-item" @click="operAfter">
                <div class="menu-item-img"><svg-icon icon-class="edit_after" /></div>
                <div class="menu-item-name" style="color:#67C23A">售后修改</div>
              </div>
              <div v-if="orderInfo.mark>12&&roleInfo.fldy===1" class="menu-item" @click="goToDyAndTm(0)">
                <div class="menu-item-img"><svg-icon icon-class="edit_print" /></div>
                <div class="menu-item-name" style="color:#E6A23C">料单打印</div>
              </div>
              <div v-if="orderInfo.mark>12&&roleInfo.bjtm===1" class="menu-item" @click="goToDyAndTm(1)">
                <div class="menu-item-img"><svg-icon icon-class="edit_qcode" /></div>
                <div class="menu-item-name" style="color:#F56C6C">部件条码</div>
              </div>
              <div v-if="orderInfo.mark>12&&roleInfo.pjdy===1" class="menu-item" @click="goToDyAndTm(2)">
                <div class="menu-item-img"><svg-icon icon-class="edit_pjprint" /></div>
                <div class="menu-item-name" style="color:#909399">配件打印</div>
              </div>
              <div v-if="roleInfo.scldbg===1 && orderInfo.mark>7" class="menu-item" @click="goToDyAndTm(3)">
                <div class="menu-item-img"><svg-icon icon-class="edit_ldbg" /></div>
                <div class="menu-item-name" style="color:#409EFF">料单变更</div>
              </div>
              <div v-if="roleInfo.jd===1 && orderInfo.mark>1" class="menu-item" @click="tempDiscount">
                <div class="menu-item-img"><svg-icon icon-class="edit_temp" /></div>
                <div class="menu-item-name" style="color:#E6A23C">临时折扣</div>
                <div v-if="tempDiscountTurnCount>0" class="el-badge__content el-badge__content--undefined is-fixed menu-badge hide-badge">{{ tempDiscountTurnCount }}</div>
              </div>
              <div v-if="orderInfo.mark>6&&roleInfo.money===1" class="menu-item" @click="getOrderCollectRecord">
                <div class="menu-item-img"><svg-icon icon-class="edit_pay" /></div>
                <div class="menu-item-name" style="color:#F56C6C">订单收款</div>
                <div v-if="orderCollectTrunCount>0" class="el-badge__content el-badge__content--undefined is-fixed menu-badge hide-badge">{{ orderCollectTrunCount }}</div>
              </div>
              <div v-if="orderInfo.mark >= 7 && orderInfo.mark < 10" class="menu-item" @click="splitChange">
                <div class="menu-item-img"><svg-icon icon-class="edit_change" /></div>
                <div class="menu-item-name" style="color:#67C23A">拆单调整</div>
              </div>
              <div v-if="orderInfo.mark>8" class="menu-item" @click="openChangeList">
                <div class="menu-item-img"><svg-icon icon-class="edit_change" /></div>
                <div class="menu-item-name" style="color:#67C23A">更改单</div>
                <div v-if="orderChangeCount>0" class="el-badge__content el-badge__content--success is-fixed">{{ orderChangeCount }}</div>
              </div>
              <div v-if="roleInfo.ddcg===1 && orderInfo.mark>0" class="menu-item" @click="listOrderProcure">
                <div class="menu-item-img"><svg-icon icon-class="edit_pay" /></div>
                <div class="menu-item-name" style="color:#F56C6C">订单采购</div>
              </div>
              <div v-if="orderInfo.mark>12" class="menu-item" @click="openDetails(orderInfo)">
                <div class="menu-item-img"><svg-icon icon-class="edit_pjprint" /></div>
                <div class="menu-item-name" style="color:#909399">打包详细</div>
              </div>
              <div v-if="roleInfo.money===1 && orderInfo.mark < 99" class="menu-item" @click="finish(orderInfo)">
                <div class="menu-item-img"><svg-icon icon-class="edit_change" /></div>
                <div class="menu-item-name" style="color:#67C23A">订单完成</div>
              </div>
              <div v-if="orderInfo.mark == 13 && (offerInfo ? offerInfo.balance <= 0 : true)" class="menu-item" @click="applyOut(orderInfo)">
                <div class="menu-item-img"><svg-icon icon-class="edit_change" /></div>
                <div class="menu-item-name" style="color:#67C23A">出库申请</div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <!-- 厂部标准色板 -->
      <el-col v-if="swatchs.length > 0" class="card mt">
        <div class="card-body" style="padding-top: 20px; padding-bottom: 20px;">
          <div class="card-title" style="margin-bottom: 0;">
            <!-- <div class="card-title" style="float: left;">厂部标准色板</div> -->
            <!-- <el-button size="mini" type="success" style="float: right;" @click="addSwatch(scope.row)">
              <i class="el-icon-plus" style="margin-right: 4px;" />添加色板
            </el-button> -->
            <el-collapse>
              <el-collapse-item title="厂部标准色板" name="swatchs">
                <template slot="title">
                  <div class="card-title" style="margin-bottom: 0; margin-right: 8px;">厂部标准色板</div>
                  <el-tooltip content="点此展开色板列表" placement="top">
                    <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                  </el-tooltip>
                </template>
                <el-table
                  stripe
                  size="small"
                  :data="swatchs"
                  style="width: 100%"
                >
                  <el-table-column
                    label="色板"
                    align="center"
                    width="100"
                  >
                    <template slot-scope="scope">
                      <el-image
                        :src="scope.row.img_url"
                        fit="cover"
                        style="width: 40px;height: 60px;"
                        :preview-src-list="[scope.row.img_url]"
                      >
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column prop="code" label="色板编号" min-width="140"></el-table-column>
                  <el-table-column prop="name" label="名称" min-width="140"></el-table-column>
                  <el-table-column prop="brand_name" label="品牌" min-width="100"></el-table-column>
                  <el-table-column prop="series_name" label="系列" min-width="100"></el-table-column>
                  <!-- <el-table-column label="操作" align="center" width="140" fixed="right">
                    <template slot-scope="scope">
                      <el-button size="mini" type="danger" @click="delSwatch(scope.row)">
                        <i class="el-icon-delete" style="margin-right: 4px;" />删除
                      </el-button>
                    </template>
                  </el-table-column> -->
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </el-col>
      <!-- 客供物料表格strat-->
      <el-col v-if="ocms.length>0" class="card mt">
        <div class="card-body">
          <div class="card-title">
            <div class="card-title">
              客供物料
            </div>
            <el-table
              stripe
              size="small"
              :data="ocms"
              style="width: 100%"
            >
              <el-table-column
                prop="cmname"
                label="物料名称"
                fixed
                width="140"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.cmname===''?'N/A':scope.row.cmname }}
                </template>
              </el-table-column>
              <el-table-column
                prop="explain"
                label="物料说明"
                min-width="160"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.explain===''?'N/A':scope.row.explain }}
                </template>
              </el-table-column>
              <el-table-column
                label="退还类型"
                align="center"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.cmtype===0?'无需退还':'需要退还' }}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="物流单号"
                width="140"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.transpnum===''?'N/A':scope.row.transpnum }}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="物流名称"
                width="140"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.transpName===''?'N/A':scope.row.transpName }}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="发货时间"
                width="140"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.hairTime===''?'N/A':scope.row.hairTime }}
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="状态"
                width="110"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.hairTime===''" :disable-transitions="true" size="mini" type="danger">未发货</el-tag>
                  <el-tag v-if="scope.row.hairTime!==''&&scope.row.serviceTime===''" :disable-transitions="true" size="mini" class="tcf-tag-4">客服待收货</el-tag>
                  <el-tag v-if="scope.row.serviceTime!==''&&scope.row.pmcTime===''" :disable-transitions="true" size="mini" class="tcf-tag-6">PMC待收货</el-tag>
                  <el-tag v-if="scope.row.pmcTime!==''&&scope.row.workshopTime===''" :disable-transitions="true" size="mini" class="tcf-tag-7">车间待收货</el-tag>
                  <el-tag v-if="scope.row.cmtype===1&&scope.row.workshopTime!==''&&scope.row.returnWorkshopTime===''" :disable-transitions="true" size="mini" class="tcf-tag-2">车间待返还</el-tag>
                  <el-tag v-if="scope.row.cmtype===0&&scope.row.workshopTime!==''&&scope.row.returnWorkshopTime===''" :disable-transitions="true" size="mini" class="tcf-tag-2">车间已接收</el-tag>
                  <el-tag v-if="scope.row.returnWorkshopTime!==''&&scope.row.returnPmcTime===''" :disable-transitions="true" size="mini" type="warning">PMC待返还</el-tag>
                  <el-tag v-if="scope.row.returnPmcTime!==''&&scope.row.returnServiceTime===''" :disable-transitions="true" size="mini" class="tcf-tag-10">客服待返还</el-tag>
                  <el-tag v-if="scope.row.returnServiceTime!==''&&scope.row.returnHairTime===''" :disable-transitions="true" size="mini" class="tcf-tag-10">客户待收货</el-tag>
                  <el-tag v-if="scope.row.returnHairTime!==''" :disable-transitions="true" size="mini">已退还</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="140" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" @click="materialDetails(scope.row)"><i class="el-icon-search" />查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
      <!--      客供物料表格end-->
      <el-col v-if="(orderInfo.mark>3&&afterInfo!==null&&afterInfo!==undefined)||(orderInfo.mark>6&&splitInfo!==null&&splitInfo!==undefined)||(orderInfo.mark>8&&offerInfo!==null&&offerInfo!==undefined)" class="card mt">
        <div class="card-body" style="padding: 1.88rem 0.9rem;">
          <el-row>
            <el-col v-if="afterInfo!==null&&afterInfo!==undefined&&orderInfo.mark>3" :span="8" style="padding:0 0.9rem">
              <div class="card-title">
                售后信息
                <el-button style="float: right" type="text" size="mini" @click="viewAfterDetail">售后详情 <i class="el-icon-arrow-right" /></el-button>
              </div>
              <div class="card-content">
                <div class="order-info info-ellipsis">
                  <span class="tit">处理人：</span>
                  <span>{{ afterInfo.treat_user }}</span>
                </div>
                <div class="order-info info-ellipsis">
                  <span class="tit">处理时间：</span>
                  <span>{{ afterInfo.treat_time }}</span>
                </div>
                <div class="order-info" style="padding-left: 60px; min-height: 50px;">
                  <el-tooltip v-if="afterInfo.img_url" effect="dark" content="判定单" placement="top">
                    <el-image
                      style="width: 50px; height: 50px;position: absolute;top: 0;left: 0;border:1px dashed #f5f7fa"
                      :src="afterInfo.img_url"
                      :preview-src-list="[afterInfo.img_url]"
                      fit="cover"
                    />
                  </el-tooltip>
                  <el-tooltip v-if="afterInfo.fileid" effect="dark" content="返修单" placement="top">
                    <div class="file-item" @click="downFile(afterInfo.fileid,0)">
                      <i class="el-icon-document" />
                      <div class="file-name">
                        {{ afterInfo.file_name }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
                <div v-if="afterInfo.remark!==null&&afterInfo.remark!==''&&afterInfo.remark!==undefined" class="order-info">
                  <span class="tit">备注：</span>
                  <span>{{ afterInfo.remark }}</span>
                </div>
              </div>
            </el-col>
            <el-col v-if="splitInfo!==null&&splitInfo!==undefined&&orderInfo.mark>6" :span="8" style="padding:0 0.9rem;">
              <div class="card-title">
                拆单信息
              </div>
              <div class="card-content">
                <div class="order-info info-ellipsis">
                  <span class="tit">拆单人员：</span>
                  <span>{{ splitInfo.splitname }}</span>
                </div>
                <div class="order-info info-ellipsis">
                  <span class="tit">拆单时间：</span>
                  <span>{{ splitInfo.splittime }}</span>
                </div>
                <div class="order-info info-ellipsis">
                  <span class="tit">拆单结果：</span>
                  <el-tooltip effect="dark" content="点击查看拆单详情" placement="top">
                    <span class="link" @click="getMaterialDetail"><i class="el-icon-document" /> {{ splitInfo.splitfilename }}</span>
                  </el-tooltip>
                </div>
                <div class="order-info info-ellipsis">
                  <span class="tit">生产料单：</span>
                  <span class="link" @click="downFile(splitInfo.splitfileid,1)"><i class="el-icon-download" /> 下载生产料单</span>
                </div>
              </div>
            </el-col>
            <el-col v-if="offerInfo!==null&&offerInfo!==undefined&&orderInfo.mark>8" :span="8" style="padding:0 0.9rem">
              <div class="card-title">
                报价信息
                <el-button style="float: right" type="text" size="mini" @click="viewOfferDetail">报价详情 <i class="el-icon-arrow-right" /></el-button>
              </div>
              <div class="card-content">
                <div class="order-info">
                  <span class="tit">总货款：</span>
                  <span class="price">{{ offerInfo.amount }}</span>
                  <s v-if="offerInfo.amount!==offerInfo.totalprice" style="font-size: 13px;color:#999;margin-left: 10px">{{ offerInfo.totalprice }}</s>
                  <el-tag v-if="offerInfo.discount>0" type="danger" size="mini" style="margin-left: 10px">{{ offerInfo.discount }} 折</el-tag>
                </div>
                <div class="order-info">
                  <span class="tit">已收款：</span>
                  <span class="price">{{ offerInfo.paidfor }}</span>
                  <span class="tit mf">余款：</span>
                  <span class="price">{{ offerInfo.balance }}</span>
                  <el-tag v-if="offerInfo.balance<=0" size="mini" style="margin-left: 10px">已结清</el-tag>
                </div>
                <div class="order-info info-ellipsis">
                  <span class="tit">报价单：</span>
                  <el-tooltip effect="dark" :content="offerInfo.file_name" placement="top">
                    <span class="link" @click="downFile(offerInfo.fileid,0)"><i class="el-icon-download" /> {{ offerInfo.file_name }}</span>
                  </el-tooltip>
                </div>
                <div v-if="offerInfo.remark!==null&&offerInfo.remark!==''&&offerInfo.remark!==undefined" class="order-info">
                  <span class="tit">备注：</span>
                  <span>{{ offerInfo.remark }}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <!--      客供物料详情-->
      <el-dialog
        :title="materialDetailsTitle"
        :visible.sync="materialDetailsVisible"
        width="720px"
        top="10vh"
        :destroy-on-close="true"
        :lock-scroll="true"
        :append-to-body="true"
      >
        <el-row v-loading="viewOrderChangeLoading">
          <el-col :span="14">
            <table class="tcf-detail-table">
              <tr>
                <th style="width: 120px">物料名称</th>
                <td>{{ ocm.cmname }}</td>
                <th>返还类型</th>
                <td>
                  <template>
                    {{ ocm.cmtype===0?'无需返还':'需要返还' }}
                  </template>
                </td>
              </tr>
              <tr>
                <th>物料说明</th>
                <td colspan="3">{{ ocm.explain }}</td>
              </tr>
              <tr>
                <th>物料发货人</th>
                <td>{{ ocm.personName }}</td>
                <th>联系电话</th>
                <td>{{ ocm.personTel }}</td>
              </tr>
              <tr>
                <th>物流单号</th>
                <td colspan="3">{{ ocm.transpnum }}</td>
              </tr>
              <tr>
                <th>物流公司</th>
                <td colspan="3">{{ ocm.transpName }}</td>
              </tr>
              <tr v-if="ocm.cmtype">
                <th>退还接收人</th>
                <td>{{ ocm.rpersonName }}</td>
                <th>联系电话</th>
                <td>{{ ocm.rpersonTel }}</td>
              </tr>
              <tr v-if="ocm.cmtype">
                <th>退还物流单号</th>
                <td colspan="3">{{ ocm.returnTranspnum }}</td>
              </tr>
              <tr v-if="ocm.cmtype">
                <th>退还物流公司</th>
                <td colspan="3">{{ ocm.returnTranspname }}</td>
              </tr>
            </table>
          </el-col>
          <!--          物料追踪-->
          <el-col :span="10">
            <el-timeline>
              <el-timeline-item
                :type="ocm.hairTime!==''?'primary':''"
                :timestamp="ocm.hairTime!==''?ocm.hairTime:''"
              >
                物料发货
                <div v-if="ocm.hairTime!==''" style="margin-top: 6px; font-size: 12px;">{{ ocm.personName }}<el-tag size="mini" :type="ocm.hairTime!==''?'':'primary'" style="margin-left: 6px">经销商</el-tag></div>
                <div v-if="ocm.hairTime==''"><el-tag size="mini" :type="ocm.hairTime!==''?'':'danger'" style="margin-left: 6px">客户未发货</el-tag></div>
                <div v-if="ocm.hairTime==''&&roleInfo.jd===1" style="margin-top: 10px">
                  <el-button size="small" type="primary" @click="serviceReturn(0)">代为发货</el-button>
                </div>
              </el-timeline-item>
              <el-timeline-item
                :type="ocm.serviceTime!==''?'primary':''"
                :timestamp="ocm.serviceTime!==''?ocm.serviceTime:''"
              >
                客服接收
                <div v-if="ocm.hairTime!==''&&ocm.serviceTime==''&&roleInfo.jd===1" style="margin-top: 10px">
                  <el-button size="small" type="primary" @click="serviceReturn(1)">客服接收</el-button>
                </div>
                <div v-if="ocm.serviceTime!==''" style="margin-top: 6px; font-size: 12px;">{{ ocm.serviceName }}<el-tag size="mini" type="warning" style="margin-left: 6px">{{ ocm.servicePositionName }}</el-tag></div>
              </el-timeline-item>
              <el-timeline-item
                :type="ocm.pmcTime!==''?'primary':''"
                :timestamp="ocm.pmcTime!==''?ocm.pmcTime:''"
              >
                PMC接收
                <div v-if="ocm.serviceTime!==''&&ocm.pmcTime==''&&roleInfo.gcfp===1" style="margin-top: 10px">
                  <el-button size="small" type="primary" @click="serviceReturn(2)">PMC接收</el-button>
                </div>
                <div v-if="ocm.pmcTime!==''" style="margin-top: 6px; font-size: 12px;">{{ ocm.pmcName }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ ocm.pmcPositionName }}</el-tag></div>
              </el-timeline-item>
              <el-timeline-item
                :type="ocm.workshopTime!==''?'primary':''"
                :timestamp="ocm.workshopTime!==''?ocm.workshopTime:''"
              >
                车间接收
                <div v-if="ocm.pmcTime!==''&&ocm.workshopTime==''&&roleInfo.gcjd===1" style="margin-top: 10px">
                  <el-button size="small" type="primary" @click="serviceReturn(3)">车间接收</el-button>
                </div>
                <div v-if="ocm.workshopTime!==''" style="margin-top: 6px; font-size: 12px;">{{ ocm.plantName }}<el-tag size="mini" type="warning" style="margin-left: 6px">{{ ocm.plantPositionName }}</el-tag></div>
              </el-timeline-item>
              <el-timeline-item
                v-if="ocm.cmtype===1"
                :type="ocm.returnWorkshopTime!==''?'primary':''"
                :timestamp="ocm.returnWorkshopTime!==''?ocm.returnWorkshopTime:''"
              >
                车间退还
                <div v-if="ocm.workshopTime!==''&&ocm.returnWorkshopTime==''&&roleInfo.gcjd===1" style="margin-top: 10px">
                  <el-button size="small" type="primary" @click="serviceReturn(4)">车间退还</el-button>
                </div>
                <div v-if="ocm.returnWorkshopTime!==''" style="margin-top: 6px; font-size: 12px;">{{ ocm.rplantName }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ ocm.rplantPositionName }}</el-tag></div>
              </el-timeline-item>
              <el-timeline-item
                v-if="ocm.cmtype===1"
                :type="ocm.returnPmcTime!==''?'primary':''"
                :timestamp="ocm.returnPmcTime!==''?ocm.returnPmcTime:''"
              >
                PMC退还
                <div v-if="ocm.returnWorkshopTime!==''&&ocm.returnPmcTime==''&&roleInfo.gcfp===1" style="margin-top: 10px">
                  <el-button size="small" type="primary" @click="serviceReturn(5)">PMC退还</el-button>
                </div>
                <div v-if="ocm.returnPmcTime!==''" style="margin-top: 6px; font-size: 12px;">{{ ocm.rpmcName }}<el-tag size="mini" type="warning" style="margin-left: 6px">{{ ocm.rpmcPositionName }}</el-tag></div>
              </el-timeline-item>
              <el-timeline-item
                v-if="ocm.cmtype===1"
                :type="ocm.returnServiceTime!==''?'primary':''"
                :timestamp="ocm.returnServiceTime!==''?ocm.returnServiceTime:''"
              >
                客服退还
                <div v-if="ocm.returnPmcTime!==''&&ocm.returnServiceTime==''&&roleInfo.jd===1" style="margin-top: 10px">
                  <el-button size="small" type="primary" @click="serviceReturn(6)">客服退还</el-button>
                </div>
                <div v-if="ocm.returnServiceTime!==''" style="margin-top: 6px; font-size: 12px;">{{ ocm.rserviceName }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ ocm.rservicePositionName }}</el-tag></div>
              </el-timeline-item>
              <el-timeline-item
                v-if="ocm.cmtype===1"
                :type="ocm.returnHairTime!==''?'primary':''"
                :timestamp="ocm.returnHairTime!==''?ocm.returnHairTime:''"
              >
                客户接收
                <div v-if="ocm.returnHairTime!==''" style="margin-top: 6px; font-size: 12px;">{{ ocm.rpersonName }}<el-tag size="mini" type="primary" style="margin-left: 6px">经销商</el-tag></div>
              </el-timeline-item>
              <el-timeline-item
                v-if="ocm.cmtype===0"
                :type="ocm.workshopTime!==''?'primary':''"
              >
                完成
              </el-timeline-item>
              <el-timeline-item
                v-if="ocm.cmtype===1"
                :type="ocm.returnHairTime!==''?'primary':''"
              >
                完成
              </el-timeline-item>
            </el-timeline>
          </el-col>
          <!--          物料追踪结束-->
          <el-dialog
            :title="serviceReturnTitle"
            :visible.sync="serviceReturnVisible"
            width="40%"
            :destroy-on-close="true"
            :lock-scroll="true"
            :append-to-body="true"
          >
            <el-form ref="serviceReturnForm" :model="serviceReturnForm" label-position="right" label-width="90px" size="small" :rules="serviceReturnFormRules">
              <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
                <i class="el-icon-info" /> 温馨提示：信息提交后将无法修改，请确认信息无误后再提交
              </div>
              <el-form-item v-if="n === 6|| n === 0" label="物流单号" prop="returnTranspnum">
                <el-input v-model="serviceReturnForm.returnTranspnum" maxlength="20" show-word-limit />
              </el-form-item>
              <el-form-item v-if="n === 6|| n === 0" label="物流名称" prop="returnTranspname">
                <el-input v-model="serviceReturnForm.returnTranspname" maxlength="10" show-word-limit />
              </el-form-item>
              <el-form-item :label="n === 0?'发货日期':'日期'" prop="time">
                <el-date-picker
                  v-model="serviceReturnForm.time"
                  type="date"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                />
              </el-form-item>
              <el-form-item style="text-align: right;">
                <el-button type="primary" :loading="dynamicloading" @click="serviceReturnSubmit(ocm)">立即提交</el-button>
                <el-button @click="serviceReturnVisible=false">取消</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </el-row>
      </el-dialog>
      <!--      客供物料详情end-->
      <el-col class="card mt">
        <div class="card-body">
          <div class="card-title">
            <div>
              订单跟踪
              <el-select v-if="isMultiFactory && (this.user.dGroupid === 1 || this.user.dGroupid === 2)" v-model="selectFactory" style="width: 100px;margin-left: 10px;" size="mini" clearable placeholder="请选择" @change="changeFactory">
                <el-option
                  v-for="(item,index) in multiGroupList"
                  :key="index"
                  :label="item.dAbbname"
                  :value="item.dGroupid"
                />
              </el-select>
              <span v-if="isMultiFactory && (this.user.dGroupid === 1 || this.user.dGroupid === 2)" style="width:20%;color:#F56C6C;font-size: 13px">可选择其他工厂查看具体进度</span>
            </div>
            <el-button style="float: right" size="small" icon="el-icon-plus" @click="addDynamic(null)">添加动态</el-button>
          </div>
          <div class="card-content">
            <el-row>
              <el-col v-loading="trackLoading" :span="7">
                <el-timeline style="padding: 10px" class="order-track">
                  <el-timeline-item v-if="orderInfo.mark>1&&orderInfo.mark<99" timestamp="">
                    <div v-if="orderInfo.mark===2">待接单</div>
                    <div v-if="orderInfo.mark===3">售后待处理</div>
                    <div v-if="orderInfo.mark===4">技术评估</div>
                    <div v-if="orderInfo.mark===5">拆单分配</div>
                    <div v-if="orderInfo.mark===6&&(splitInfo.splittime===null||splitInfo.splittime===''||splitInfo.splittime===undefined)">待拆单</div>
                    <!-- <div v-if="orderInfo.mark===6&&(splitInfo.splittime===null||splitInfo.splittime===''||splitInfo.splittime===undefined)">
                      <span v-if="orderInfo.splitStatus == 0">拆单-未开始</span>
                      <span v-if="orderInfo.splitStatus == 1">拆单-进行中</span>
                      <span v-if="orderInfo.splitStatus == 2">拆单-已暂停</span>
                      <span v-if="orderInfo.splitStatus == 3">拆单-待拆单员确认</span>
                      <span v-if="orderInfo.splitStatus == 4">拆单-已完成</span>
                    </div> -->
                    <div v-if="orderInfo.mark===6&&splitInfo.splittime!==null&&splitInfo.splittime!==''&&splitInfo.splittime!==undefined">拆单待审核</div>
                    <div v-if="orderInfo.mark===7">订单确认</div>
                    <div v-if="orderInfo.mark===8">待报价</div>
                    <div v-if="orderInfo.mark===9&&orderChangeUndoneCount<=0">预付款</div>
                    <div v-if="orderInfo.mark===10&&orderChangeUndoneCount<=0">工厂分派</div>
                    <div v-if="orderInfo.mark===11&&orderChangeUndoneCount<=0">工厂待接单</div>
                    <div v-if="orderInfo.mark===12&&orderChangeUndoneCount<=0">待排产</div>
                    <div v-if="orderInfo.mark===13&&orderChangeUndoneCount<=0">订单生产中</div>
                    <div v-if="orderInfo.mark>8&&orderChangeUndoneCount>0" style="color: #F56C6C">有 <b>{{ orderChangeUndoneCount }}</b> 项变更</div>
                    <div style="margin-top: 10px">
                      <el-button v-if="orderInfo.mark===2&&roleInfo.jd===1" size="small" type="primary" @click="jdbtn">立即接单</el-button>
                      <!--<el-button v-if="orderInfo.mark===3&&roleInfo.jd===1" size="small" @click="gotoShsq">售后申请</el-button>-->
                      <el-button v-if="orderInfo.mark===3&&roleInfo.shcl===1" size="small" type="primary" @click="gotoShcl">立即处理</el-button>
                      <el-button v-if="orderInfo.mark===4&&roleInfo.jspg===1" size="small" type="primary" @click="jspgBtn">立即评估</el-button>
                      <el-button v-if="orderInfo.mark===5&&roleInfo.cdfp===1" size="small" type="primary" @click="cdfpBtn">立即分配</el-button>
                      <el-button v-if="orderInfo.mark===6&&roleInfo.cd===1&&(splitInfo.splittime===null||splitInfo.splittime===''||splitInfo.splittime===undefined)" size="small" type="primary" @click="cdBtn">立即拆单</el-button>
                      <!-- <el-button v-if="orderInfo.mark===6&&orderInfo.splitStatus == 2" size="small" type="primary" @click="sqjxCdBtn">申请继续拆单</el-button>
                      <!- 只有拆单员本人可见 ->
                      <template v-if="orderInfo.mark===6 && roleInfo.cd===1 && splitInfo.splitid == user.dUserid">
                        <el-button v-if="orderInfo.splitStatus == 3" size="small" type="success" @click="startCdBtn">继续拆单</el-button>
                        <el-button v-if="orderInfo.splitStatus == 1" size="small" type="warning" :disabled="nextOrdersLoading" @click="pauseCdBtn">暂停拆单</el-button>
                        <el-button v-if="orderInfo.splitStatus == 1 && (splitInfo.splittime===null||splitInfo.splittime===''||splitInfo.splittime===undefined)" size="small" type="primary" :disabled="nextOrdersLoading" @click="cdBtn">拆单完成</el-button>
                      </template> -->
                      <!-- <div v-if="orderInfo.mark===6" class="view-info" style="margin-top: 15px;">
                        <div class="tit">
                          拆单耗时：
                          <span v-if="orderInfo.splitTake" style="color: #409EFF;">{{ tranfromSec(orderInfo.splitTake) }}</span>
                          <span v-else>--</span>
                        </div>
                        <div class="tit">
                          暂停时长：
                          <span v-if="orderInfo.splitPauseTake" style="color: #E6A23C;">{{ tranfromSec(orderInfo.splitPauseTake) }}</span>
                          <span v-else>--</span>
                        </div>
                      </div> -->
                      <el-tooltip v-if="orderInfo.mark===7&&roleInfo.ddqr===1" content="仅非正单订单可代为确认" placement="top">
                        <el-button v-if="orderInfo.type!==0&&orderInfo.mark===7&&roleInfo.ddqr===1" size="small" type="primary" @click="ddqrBtn">代为确认</el-button>
                        <el-button v-if="orderInfo.type===0&&orderInfo.mark===7&&roleInfo.ddqr===1" size="small" type="primary" @click="ddqrBtn">订单驳回</el-button>
                      </el-tooltip>
                      <el-button v-if="orderInfo.mark===8&&roleInfo.dbj===1" size="small" type="primary" @click="dbjBtn">订单报价</el-button>
                      <el-button v-if="orderInfo.mark===9&&roleInfo.yfk===1&&orderChangeUndoneCount<=0" size="small" type="primary" @click="yfkBtn">代为预付</el-button>
                      <el-button v-if="orderInfo.mark===9&&roleInfo.yfk===1" size="small" type="warning" @click="yfkPassBtn">跳过预付</el-button>
                      <!--                      <el-button v-if="orderInfo.mark===10&&roleInfo.gcfp===1&&orderChangeUndoneCount<=0" size="small" type="primary" @click="gcfpBtn">立即分派</el-button>-->
                      <!--                      <el-button v-if="orderInfo.mark===11&&roleInfo.gcjd===1&&orderChangeUndoneCount<=0" size="small" type="primary" @click="gcjdBtn">立即接单</el-button>-->
                      <!--                      <el-button v-if="orderInfo.mark===12&&roleInfo.ddpc===1&&orderChangeUndoneCount<=0" size="small" type="primary" @click="ddpcBtn">订单排产</el-button>-->
                      <el-button v-if="orderInfo.mark>8&&orderChangeUndoneCount>0" size="small" type="primary" @click="openChangeList">查看更改单</el-button>
                    </div>
                  </el-timeline-item>
                  <el-timeline-item v-if="orderInfo.mark==99" timestamp="" size="large" type="primary">
                    <div>订单已取消</div>
                  </el-timeline-item>
                  <el-timeline-item v-if="orderInfo.mark==0" timestamp="" size="large" type="primary">
                    <div>订单已作废</div>
                  </el-timeline-item>
                  <el-timeline-item
                    v-for="(t, index) in trackActivities"
                    v-if="t.time"
                    :key="index"
                    type="primary"
                    size="large"
                    :timestamp="t.time"
                  >
                    {{ t.name }}
                    <div v-if="t.username!==null&&t.username!==''&&t.username!==undefined" style="margin-top: 6px;font-size: 12px;">
                      {{ t.username }}
                      <el-tag v-if="t.position!==null&&t.position!==''&&t.position!==undefined" size="mini" :type="t.color===0?'':t.color===1?'success':t.color===2?'danger':t.color===3?'warning':''" style="margin-left: 6px">
                        {{ t.position }}
                      </el-tag>
                    </div>
                    <div v-if="t.remark!==null&&t.remark!==''&&t.remark!==undefined" style="margin-top: 6px;font-size: 12px;color:#999">{{ t.remark }}</div>
                    <!-- <div v-if="t.name == '拆单'" class="view-info" style="margin-top: 8px; font-size: 13px;">
                      <div class="tit">
                        拆单耗时：
                        <span v-if="orderInfo.splitTake" style="color: #409EFF;">{{ tranfromSec(orderInfo.splitTake) }}</span>
                        <span v-else>--</span>
                      </div>
                      <div class="tit">
                        暂停时长：
                        <span v-if="orderInfo.splitPauseTake" style="color: #E6A23C;">{{ tranfromSec(orderInfo.splitPauseTake) }}</span>
                        <span v-else>--</span>
                      </div>
                    </div> -->
                  </el-timeline-item>
                </el-timeline>
              </el-col>
              <el-col v-loading="dynamicLoading" :span="17">
                <div v-if="total===0&&trackLoading===false" class="order-dynamic-not">
                  暂无订单动态数据
                </div>
                <div v-for="d in orderDynamic" class="order-dynamic-item">
                  <div class="photo">
                    <el-avatar shape="square" :size="50" :src="d.user_avatar" style="cursor: pointer;" @click.native="getUserDetail(d.user_id,d.user_type)" />
                  </div>
                  <div class="info">
                    <div class="username"><span style="cursor: pointer;" @click="getUserDetail(d.user_id,d.user_type)">{{ d.all_name }}</span><el-tag v-if="d.position_name!==null&&d.position_name!==''&&d.position_name!==undefined" :type="d.color===0?'':d.color===1?'success':d.color===2?'warning':''" size="mini">{{ d.position_name }}</el-tag></div>
                    <div class="time">
                      <span v-if="d.ispub===1" style="color:#f56c6c;margin-right: 10px">
                        <i class="el-icon-lock" /> 仅组织员工可见，经销商无法查看
                      </span>
                      <!--                      <el-button v-if="d.user_id===user.dUserid && orderInfo.mark!==100 && d.user_type===1" style="margin-right: 10px;" size="mini" type="text" @click="addDynamic(d)">编辑</el-button>-->
                      <!--                      <el-button v-if="d.user_id===user.dUserid && orderInfo.mark!==100 && d.user_type===1" style="margin-right: 20px;" size="mini" type="text" @click="deleteDynamic(d)">删除</el-button>-->
                      <i class="el-icon-time" />
                      {{ d.time }}
                    </div>
                    <div class="content">
                      <el-tag v-if="d.content_type===1" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">接单驳回</el-tag>
                      <el-tag v-if="d.content_type===2" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">售后驳回</el-tag>
                      <el-tag v-if="d.content_type===3" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">技术评估驳回</el-tag>
                      <el-tag v-if="d.content_type===4" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">订单确认驳回</el-tag>
                      <el-tag v-if="d.content_type===5" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">报价驳回</el-tag>
                      <el-tag v-if="d.content_type===6" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">预付款驳回</el-tag>
                      <el-tag v-if="d.content_type===7" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">工厂接单驳回</el-tag>
                      <el-tag v-if="d.content_type===8" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">审单驳回</el-tag>
                      <el-tag v-if="d.content_type===9" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">方案驳回</el-tag>
                      <el-tag v-if="d.content_type===10" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="success">订单完成</el-tag>
                      <el-tag v-if="d.content_type===99" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">订单跳过预付款</el-tag>
                      <!-- <el-tag v-if="d.content_type===100" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="primary">开始拆单</el-tag>
                      <el-tag v-if="d.content_type===101" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="warning">暂停拆单</el-tag>
                      <el-tag v-if="d.content_type===102" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="primary">申请继续拆单</el-tag>
                      <el-tag v-if="d.content_type===103" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="warning">申请拆单调整</el-tag>
                      <el-tag v-if="d.content_type===104" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="primary">继续开始拆单</el-tag>
                      <el-tag v-if="d.content_type===105" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="primary">系统自动安排开始拆单</el-tag> -->
                      {{ d.content }}
                    </div>
                    <div class="files">
                      <div v-for="f in d.fileList" class="file-item" @click="downFile(f.fileid,0)">
                        <i class="el-icon-document" />
                        <div class="file-name">
                          {{ f.file_name }}.{{ f.file_type }}
                        </div>
                        <!--                        <div class="lessonplay">-->
                        <!--                            <span @click="downFile(f.fileid,0)"><i class="el-icon-download" /> 下载</span>-->
                        <!--                            <span @click="viewCad(f.fileid)" v-if="f.file_type==='dwg'"><i class="el-icon-view" /> 预览</span>-->
                        <!--                        </div>-->
                      </div>
                    </div>
                    <div class="imgs">
                      <el-image
                        v-for="img in d.imgList"
                        fit="cover"
                        class="dynamic-img"
                        :src="img"
                        :preview-src-list="d.imgList"
                      />
                    </div>
                  </div>
                </div>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dynamicForm.title"
      :visible.sync="dynamicVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="dynamicForm" :model="dynamicForm" label-position="right" label-width="90px" size="small">
        <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info" /> 温馨提示：订单动态添加后将无法编辑/删除，请确认信息无误后再提交
        </div>
        <el-form-item label="动态内容" prop="content">
          <el-input v-model="dynamicForm.content" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item v-if="user.rank===0" label="是否公开" prop="isPub">
          <el-radio-group v-model="dynamicForm.isPub">
            <el-radio :label="0">公开</el-radio>
            <el-radio :label="1">仅组织，经销商不可见</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile :key="dynamicForm.key" v-model="dynamicForm.files" :old="dynamicForm.oldFiles" />
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg :key="dynamicForm.key" v-model="dynamicForm.imgids" :old="dynamicForm.oldImages" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="dynamicloading" @click="SubDynamic('dynamicForm')">立即提交</el-button>
          <el-button @click="dynamicVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="materialTitle"
      :visible.sync="materialVisible"
      width="80%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :before-close="closeMaterial"
      :append-to-body="true"
    >
      <div v-loading="materialloading" style="height: 490px;width: 100%">
        <el-form :inline="true" size="small" :model="dbjSearchForm">
          <el-form-item label="区域">
            <el-select v-model="dbjSearchForm.area" style="width: 150px" filterable clearable>
              <el-option
                v-for="item in dbjSearchForm.areaList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="分类">
            <el-select v-model="dbjSearchForm.type" style="width: 100px" filterable clearable>
              <el-option
                v-for="item in dbjSearchForm.typeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="搜索关键字">
            <el-input v-model="dbjSearchForm.search" @keyup.enter.native="searchMaterial" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchMaterial">搜索</el-button>
          </el-form-item>
          <el-form-item style="float: right;">
            <span style="margin-right:20px;">数量合计：<span style="font-size: 16px;font-weight: 500;color: #409EFF">{{ totalCount }}</span></span>
            <span v-if="roleInfo.money===1&&orderInfo.mark>7">金额合计：<span style="font-size: 16px;font-weight: 500;color: #409EFF">{{ totalMoney }}</span></span>
          </el-form-item>
        </el-form>
        <pl-table
          height="490px"
          :datas="materialTableData"
          :data="materialTableData"
          border
          size="small"
          use-virtual
          :pagination-show="false"
          :row-height="45"
        >
          <pl-table-column prop="xuhao" label="序号" width="80" show-overflow-tooltip fixed />
          <pl-table-column prop="area" label="区域" width="120" show-overflow-tooltip />
          <pl-table-column prop="type" label="分类" width="80" show-overflow-tooltip />
          <pl-table-column prop="name" label="名称" width="160" show-overflow-tooltip />
          <pl-table-column prop="material" label="基材" width="80" show-overflow-tooltip />
          <pl-table-column prop="high" label="高/长" width="70" show-overflow-tooltip />
          <pl-table-column prop="width" label="宽" width="70" show-overflow-tooltip />
          <pl-table-column prop="lwidth" label="L宽" width="70" show-overflow-tooltip />
          <pl-table-column prop="ply" label="厚" width="70" show-overflow-tooltip />
          <pl-table-column prop="num" label="数量" width="70" show-overflow-tooltip />
          <pl-table-column prop="val" label="数值" width="70" show-overflow-tooltip />
          <pl-table-column prop="unit" label="单位" width="70" show-overflow-tooltip />
          <pl-table-column prop="color" label="颜色" width="140" show-overflow-tooltip />
          <pl-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
          <pl-table-column v-if="roleInfo.money===1&&orderInfo.mark>7" fixed="right" prop="price" label="单价" min-width="100" show-overflow-tooltip />
          <pl-table-column v-if="roleInfo.money===1&&orderInfo.mark>7" fixed="right" prop="total" label="金额" min-width="100" show-overflow-tooltip />
        </pl-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="materialTableData=[],materialVisible=false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="afterTitle"
      :visible.sync="afterIVisible"
      width="762px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="fullscreenAfterLoading" class="tcf-detail-table">
        <tr>
          <th>订单号</th>
          <td>{{ afterinfoData.order.ordernum }}</td>
          <th>原正单号</th>
          <td>{{ afterinfoData.order.beforenum }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ afterinfoData.order.all_name }}</td>
          <th>生产车间</th>
          <td>{{ afterinfoData.order.product_factory }}</td>
        </tr>
        <tr>
          <th>客诉时间</th>
          <td colspan="3">{{ afterinfoData.order.time }}</td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="3">{{ afterinfoData.order.address }}</td>
        </tr>
        <tr>
          <th>投诉内容</th>
          <td colspan="3">{{ afterinfoData.afterSale.content }}</td>
        </tr>
        <tr v-if="afterinfoData.order.bid == 3">
          <th>售后部<br>处理意见</th>
          <td colspan="3">{{ afterinfoData.opinions.afterSale }}</td>
        </tr>
        <tr v-if="afterinfoData.order.bid == 3">
          <th>生产部<br>处理意见</th>
          <td colspan="3">{{ afterinfoData.opinions.production }}</td>
        </tr>
        <tr v-if="afterinfoData.order.bid == 3">
          <th>销售部<br>处理意见</th>
          <td colspan="3">{{ afterinfoData.opinions.sales }}</td>
        </tr>
        <tr v-if="afterinfoData.order.bid != 3">
          <th>返修单</th>
          <td colspan="3">
            <span v-if="afterinfoData.afterSale.reworkid" class="tcf-link" @click="downFile(afterinfoData.afterSale.reworkid,0)">
              <i class="el-icon-download" />{{ afterinfoData.afterSale.reworkname }}
            </span>
          </td>
        </tr>
        <tr>
          <th>判定单</th>
          <td colspan="3">
            <el-image
              v-if="afterinfoData.afterSale.decision_url"
              style="width: 60px; height: 60px;"
              fit="cover"
              :preview-src-list="[afterinfoData.afterSale.decision_url]"
              :src="afterinfoData.afterSale.decision_url"
            />
          </td>
        </tr>
        <tr>
          <th style="width:80px">责任部门<br>售后原因</th>
          <td colspan="3">
            <el-table
              size="mini"
              :data="afterinfoData.deptRson"
              style="width: 100%"
            >
              <el-table-column
                prop="deptname"
                label="责任部门"
                align="center"
                width="100"
                show-overflow-tooltip
              />
              <el-table-column
                prop="rsonname"
                label="售后原因"
                align="center"
                width="130"
                show-overflow-tooltip
              />
              <el-table-column
                prop="num"
                label="不良数量"
                align="center"
                width="100"
              />
              <el-table-column
                prop="remark"
                align="center"
                label="备注"
                show-overflow-tooltip
              />
            </el-table>

          </td>
        </tr>
        <tr>
          <th>责任车间</th>
          <td>{{ afterinfoData.factory }}</td>
          <th>售后赔款</th>
          <td>{{ afterinfoData.afterSale.amount }}&nbsp;元</td>
        </tr>
        <tr>
          <th>售后备注</th>
          <td colspan="3">{{ afterinfoData.afterSale.remark }}</td>
        </tr>
        <tr>
          <th>处理人</th>
          <td>{{ afterinfoData.afterSale.username }}</td>
          <th>处理时间</th>
          <td>{{ afterinfoData.afterSale.opertime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="afterIVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="offerInfo!==null&&offerInfo!==undefined"
      :title="offerTitle"
      :visible.sync="offerVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div v-loading="fullscreenOfferLoading" style="font-size: 13px;color:#606266;padding: 0 20px">
        <div>
          <span style="color:#99a9bf">报价员：</span>
          <span>{{ offerInfo.offername }}</span>
          <span style="color:#99a9bf;margin-left: 20px">报价时间：</span>
          <span>{{ offerInfo.time }}</span>
        </div>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">报价单：</span>
          <span class="tcf-link" @click="downFile(offerInfo.fileid,0)"><i class="el-icon-download" /> {{ offerInfo.file_name }}</span>
        </div>
        <div style="margin-top: 15px">
          <template>
            <el-table
              size="mini"
              :data="orderquotedata"
              style="width: 100%"
            >
              <el-table-column
                align="center"
                prop="year"
                label="年份"
                width="60"
              />
              <el-table-column
                prop="name"
                label="报价书编号"
                mini-width="280"
              />
            </el-table>
          </template>
        </div>
        <el-card shadow="hover" style="margin-top: 15px">
          <div>
            <span style="color:#99a9bf">墙板：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.wall }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">柜体：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.cabinet }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">门类：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.door }}</span>元
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf;">铝材：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.aluminum }}</span>元
            <span style="color:#99a9bf;margin-left: 20px;">配件：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px;">{{ offerInfo.access }}</span>元
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">加价：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.raise }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">优惠及退款：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.best }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">折扣：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.discount }}</span>折
          </div>
        </el-card>
        <el-card v-if="offerAccountReceipt.length>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">折扣/优惠</span>
          <el-table
            :data="offerAccountReceipt"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              show-overflow-tooltip
              label="折扣/优惠名称"
              min-width="120"
            />
            <el-table-column
              width="120"
              align="right"
              show-overflow-tooltip
              label="优惠金额"
            >
              <template slot-scope="scope">
                <span style="color:#F56C6C;margin-right: 6px">{{ scope.row.money }}</span>元
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card v-if="offerInfo.other != 0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">其他费用：</span>
          <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.other }}</span>元
          <el-table
            :data="offerOther"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              show-overflow-tooltip
              label="费用名称"
              min-width="120"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.type===1" :disable-transitions="true" size="mini" type="warning">木架</el-tag>
                <el-tag v-if="scope.row.type===2&&user.group_nature!==1" :disable-transitions="true" size="mini" type="success">调色</el-tag>
                <el-tag v-if="scope.row.type===3" :disable-transitions="true" size="mini" type="info">水性漆</el-tag>
                <span :style="scope.row.type===1?'margin-left: 6px':scope.row.type===2&&user.group_nature!==1?'margin-left: 6px':scope.row.type===3?'margin-left: 6px':''">{{ scope.row.type===2&&user.group_nature===1?'其他费用':scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              align="right"
              show-overflow-tooltip
              label="金额"
            >
              <template slot-scope="scope">
                <span style="color:#F56C6C;margin-right: 6px">{{ scope.row.amount }}</span>元
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card v-if="offerChanges.length>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">更改单费用：</span>
          <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.changes }}</span>元
          <span v-if="offerInfo.refund!=0">，退款<span style="color:#F56C6C;font-size: 14px;margin-right: 6px;margin-left: 6px">{{ offerInfo.refund }}</span>元</span>
          <el-table
            :data="offerChanges"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="num"
              label="更改单号"
              width="200"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.type===0" :disable-transitions="true" size="mini" style="margin-right: 6px" type="danger">设计变更</el-tag>
                <el-tag v-if="scope.row.type===1" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-4">材质变更</el-tag>
                <el-tag v-if="scope.row.type===2" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-6">暂停生产</el-tag>
                <el-tag v-if="scope.row.type===3" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-7">取消订单</el-tag>
                <el-tag v-if="scope.row.type===4" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-2">颜色变更</el-tag>
                <el-tag v-if="scope.row.type===5" :disable-transitions="true" size="mini" style="margin-right: 6px" type="warning">通知单</el-tag>
                <el-tag v-if="scope.row.type===6" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-10">其他</el-tag>
                {{ scope.row.num }}
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="变更内容"
              min-width="200"
              show-overflow-tooltip
            />
            <el-table-column
              label="更改费用"
              width="100"
              fixed="right"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span style="color:#f56c6c">{{ scope.row.amount }}</span>元
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="100"
              fixed="right"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-search" size="mini" @click="viewOrderChange(scope.row)">详细</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">总报价：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.amount }}</span>元
          <s v-if="offerInfo.amount!==offerInfo.totalprice" style="margin-left: 10px;color:#999;">{{ offerInfo.totalprice }}</s>
          <span style="margin-left: 20px">（大写：{{ UpperAmount }}）</span>
        </div>
        <div v-if="offerInfo.factorycom!=0||offerInfo.designcom!=0" style="margin-top: 15px">
          <span style="color:#99a9bf">设计承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.designcom }}</span>元
          <span style="color:#99a9bf;margin-left: 20px">工厂承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.factorycom }}</span>元
          <span style="color:#99a9bf;margin-left: 20px">客户承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.clientcom }}</span>元
        </div>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">已收款：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.paidfor }}</span>元
          <span style="color:#99a9bf;margin-left: 20px">余款：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.balance }}</span>元
          <el-tag v-if="offerInfo.balance<=0" size="mini" style="margin-left: 10px">已结清</el-tag>
        </div>
        <div v-if="offerImgs!==null&&offerImgs!==undefined&&offerImgs.length>0" style="margin-top: 15px">
          <span style="color:#99a9bf">领导凭证：</span>
          <el-image
            v-for="img in offerImgs"
            style="width: 50px; height: 50px;margin-right: 10px"
            :src="img"
            :preview-src-list="offerImgs"
            fit="cover"
          />
        </div>
        <div v-if="offerInfo.remark!==null&&offerInfo.remark!==''&&offerInfo.remark!==undefined" style="margin-top: 15px">
          <span style="color:#99a9bf">备注：</span>
          <span>{{ offerInfo.remark }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="offerVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="接单"
      :visible.sync="jdVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="jdForm" :model="jdForm" :rules="jdRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="jdForm.ordername" :disabled="true" />
        </el-form-item>
        <!--        <el-form-item label="订单类型" prop="type">-->
        <!--          <el-radio v-model="jdForm.type" :label="0">正单</el-radio>-->
        <!--          <el-radio v-model="jdForm.type" :label="1">客改单</el-radio>-->
        <!--          <el-radio v-model="jdForm.type" :label="2">增补单</el-radio>-->
        <!--          <el-radio v-model="jdForm.type" :label="3">色板单</el-radio>-->
        <!--          <el-radio v-model="jdForm.type" :label="4">售后单</el-radio>-->
        <!--        </el-form-item>-->
        <el-form-item v-if="jdForm.type===3" label="分配类型" prop="issplit">
          <el-radio-group v-model="jdForm.issplit">
            <el-radio :label="0">技术评估</el-radio>
            <el-radio :label="1">自主拆单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="预估价格" prop="price">
          <el-input v-model="jdForm.price" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="jdForm.type===4" label="售后内容" prop="after">
          <el-input v-model="jdForm.after" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item v-if="jdForm.type===0" label="报备关联" prop="reportid">
          <el-cascader
            v-model="jdForm.reportid"
            :options="jdReportList"
            style="width:100%"
            filterable
            clearable
          />
        </el-form-item>
        <el-form-item label="接单备注" prop="content">
          <el-input v-model="jdForm.content" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="jdForm.files" />
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="jdForm.imgids" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="jdloading" @click="subEditJd('jdForm')">立即接单</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="jdloading" @click="turnJd('jdForm')">驳回</el-button>
          <el-button @click="jdVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="技术评估"
      :visible.sync="jspgVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="jspgForm" :model="jspgForm" :rules="jspgRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="jspgForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="评估备注" prop="content">
          <!-- <el-input v-model="jspgForm.content" type="textarea" maxlength="200" show-word-limit /> -->
          <el-select
            v-model="jspgForm.content"
            style="width: 100%;"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择或输入备注/原因"
          >
            <el-option
              v-for="(item, index) in rsonList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="jspgForm.files" />
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="jspgForm.imgids" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="jspgloading" @click="subEditJspg('jspgForm')">评估通过</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="jspgloading" @click="turnJspg('jspgForm')">驳回</el-button>
          <el-button @click="jspgVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="拆单分配"
      :visible.sync="cdfpVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="cdfpForm" :model="cdfpForm" :rules="cdfpRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="cdfpForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="拆单人员" prop="splitid">
          <UserSelect v-model="cdfpForm.splitid" :groupid="user.dGroupid" :userid="user.dUserid" />
        </el-form-item>
        <el-form-item label="分配备注" prop="content">
          <el-input v-model="cdfpForm.content" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="cdfpForm.files" />
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="cdfpForm.imgids" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="cdfploading" @click="subEditCdfp('cdfpForm')">立即分配</el-button>
          <el-button @click="cdfpVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="拆单"
      :visible.sync="cdVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="cdForm" :model="cdForm" :rules="cdRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="cdForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="料单导入" prop="fileid">
          <SingleFile :key="cdfileLoad" v-model="cdForm.fileid" :accept="'.xls'" :old="cdoldFile" :tip="'只能上传Excel，文件上传后请导入'" />
        </el-form-item>
        <el-form-item label="料单状态" prop="splitFileid">
          <el-tag v-if="cdForm.splitFileid!==null&&cdForm.splitFileid!==''&&cdForm.splitFileid!==undefined" type="success" :disable-transitions="true">料单已导入</el-tag>
          <el-tag v-if="(cdForm.fileid===null||cdForm.fileid===''||cdForm.fileid===undefined)&&(cdForm.splitFileid===null||cdForm.splitFileid===''||cdForm.splitFileid===undefined)" type="danger" :disable-transitions="true">未上传料单</el-tag>
          <el-tag v-if="cdForm.fileid!==null&&cdForm.fileid!==''&&cdForm.fileid!==undefined&&(cdForm.splitFileid===null||cdForm.splitFileid===''||cdForm.splitFileid===undefined)" type="warning" :disable-transitions="true">未导入料单</el-tag>
          <el-button v-if="cdForm.splitFileid!==null&&cdForm.splitFileid!==''&&cdForm.splitFileid!==undefined" icon="el-icon-document-checked" @click="getMaterialDetail">查看导入详情</el-button>
          <el-popconfirm v-if="cdForm.fileid!==null&&cdForm.fileid!==''&&cdForm.fileid!==undefined" :key="cdimportKey" title="确认导入此料单吗？" @onConfirm="cdimportMaterials">
            <el-button slot="reference" :loading="cdimportloading" icon="el-icon-finished">导入料单</el-button>
          </el-popconfirm>
        </el-form-item>
        <el-form-item label="拆单备注" prop="content">
          <el-input v-model="cdForm.content" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="cdForm.files" />
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="cdForm.imgids" :size="'sm'" />
        </el-form-item>
        <!-- <el-form-item label="下一拆单订单" prop="nextOrderId" label-width="105px">
          <el-select
            v-model="cdForm.nextOrderId"
            placeholder="请选择订单，可输入关键字搜索"
            filterable
            clearable
            prefix-icon="el-icon-search"
            style="width: 100%;"
          >
            <el-option
              v-for="(item, index) in selectNextOrderList"
              :key="index"
              :value="item.order_id"
              :label="item.order_num + ' / ' + item.all_name + ' / ' + item.address"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item style="text-align: right;">
          <el-popconfirm :key="cdbtnKey" title="已经确认这份料单导入正确，是否继续？" placement="top" width="200" @onConfirm="subEditCd('cdForm')">
            <el-button slot="reference" type="primary" :loading="cdloading">拆单完成</el-button>
          </el-popconfirm>
          <el-button style="margin-left: 10px" @click="cdVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="orderInfo.type===0 ? '订单驳回' : '代为确认'"
      :visible.sync="ddqrVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="ddqrForm" :model="ddqrForm" :rules="ddqrRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="ddqrForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="确认备注" prop="content">
          <el-input v-model="ddqrForm.content" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="ddqrForm.files" />
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="ddqrForm.imgids" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button v-if="orderInfo.type!==0" type="primary" icon="el-icon-check" :loading="ddqrloading" @click="subEditDdqr('ddqrForm')">立即确认</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="ddqrloading" @click="turnDdqr('ddqrForm')">驳回</el-button>
          <el-button @click="ddqrVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="订单报价"
      :visible.sync="dbjVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :close-on-click-modal="dbjForm.offerFileid===null||dbjForm.offerFileid===''||dbjForm.offerFileid===undefined"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="dbjForm" :model="dbjForm" :rules="dbjRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="dbjForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="报价书" prop="qid">
          <el-select v-model="dbjForm.qid" filterable style="width: 100%" placeholder="请选择" multiple>
            <el-option
              v-for="item in quoteData"
              v-if="dbjForm.bid===item.bid||(dbjForm.bid===2&&item.bid===1)"
              :label="item.name"
              :value="item.qid"
            >
              <el-tag size="mini" type="warning">{{ item.year }}年</el-tag>
              <span style="margin-left: 6px">{{ item.name }}</span>
            </el-option>
          </el-select>
          <!--          <el-button type="text" @click="downQuote" icon="el-icon-download">下载报价书</el-button>-->
        </el-form-item>
        <el-form-item label="报价上传" prop="fileid">
          <SingleFile :key="dbjfileLoad" v-model="dbjForm.fileid" :accept="'.xls'" :old="dbjoldFile" :tip="'只能上传Excel，文件上传后请导入'" />
        </el-form-item>
        <el-form-item label="报价解析" prop="offerFileid">
          <el-tag v-if="dbjForm.offerFileid!==null&&dbjForm.offerFileid!==''&&dbjForm.offerFileid!==undefined" type="success" :disable-transitions="true">报价单已解析</el-tag>
          <el-tag v-if="(dbjForm.fileid===null||dbjForm.fileid===''||dbjForm.fileid===undefined)&&(dbjForm.offerFileid===null||dbjForm.offerFileid===''||dbjForm.offerFileid===undefined)" type="danger" :disable-transitions="true">未上传报价单</el-tag>
          <el-tag v-if="dbjForm.fileid!==null&&dbjForm.fileid!==''&&dbjForm.fileid!==undefined&&(dbjForm.offerFileid===null||dbjForm.offerFileid===''||dbjForm.offerFileid===undefined)" type="warning" :disable-transitions="true">未解析报价单</el-tag>
          <el-popconfirm v-if="dbjForm.fileid!==null&&dbjForm.fileid!==''&&dbjForm.fileid!==undefined" :key="dbjimportKey" title="确认解析此报价单吗？" placement="top" @onConfirm="dbjimportOffer">
            <el-button slot="reference" :loading="dbjimportloading" icon="el-icon-finished">解析报价单</el-button>
          </el-popconfirm>
        </el-form-item>
        <el-row v-if="dbjForm.offerFileid!==null&&dbjForm.offerFileid!==''&&dbjForm.offerFileid!==undefined">
          <el-col :span="24">
            <el-form-item label="报价分解">
              <el-card shadow="never" class="tcf-offer-card">
                <el-collapse v-model="bjfjActiveNames">
                  <el-collapse-item title="品类报价" name="1">
                    <el-col :span="12">
                      <el-form-item label="墙板" prop="wall">
                        <el-input v-model="dbjForm.wall" oninput="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="柜体" prop="cabinet">
                        <el-input v-model="dbjForm.cabinet" oninput="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="门类" prop="door">
                        <el-input v-model="dbjForm.door" oninput="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="配件" prop="access">
                        <el-input v-model="dbjForm.access" oninput="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="铝材" prop="aluminum">
                        <el-input v-model="dbjForm.aluminum" oninput="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-collapse-item>
                  <el-collapse-item v-show="orderInfo.produnum.indexOf('SZ')<0" title="系列报价" name="3">
                    <el-col :span="12">
                      <el-form-item label="乔金斯" prop="jokins">
                        <el-input v-model="dbjForm.jokins" oninput="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="云庭御邑" prop="yt">
                        <el-input v-model="dbjForm.yt" oninput="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-collapse-item>
                  <el-collapse-item title="工艺报价" name="2">
                    <el-col :span="12">
                      <el-form-item label="混油" prop="oil">
                        <el-input v-model="dbjForm.oil" oninput="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="贴皮" prop="tiepi">
                        <el-input v-model="dbjForm.tiepi" oninput="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="免漆板" prop="paint">
                        <el-input v-model="dbjForm.paint" oninput="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-collapse-item>
                </el-collapse>
              </el-card>
            </el-form-item>
          </el-col>
          <el-col :span="24" style="padding: 10px 0 10px 90px;">
            <span style="color:#99a9bf;font-size:12px;"><i class="el-icon-info" style="margin-right:6px;" />报价提示：订单金额 = 墙板 + 柜体 + 门类 + 配件 + 铝材 + 加价 + 其他费用 - 优惠</span>
          </el-col>
          <el-col :span="24">
            <el-form-item label="订单金额">
              <span style="font-weight: 500;color:#409EFF;margin-left: 10px;font-size: 16px">{{ dbjForm.amount }}</span>
              <span style="font-size: 12px">元</span>
              <s v-if="dbjForm.amount!==dbjForm.totalprice" style="font-size: 13px;color:#999;margin-left: 10px">{{ dbjForm.totalprice }}</s>
              <el-tag v-if="parseFloat(dbjForm.discount)>0" type="danger" size="mini" style="margin-left: 10px">{{ dbjForm.discount }} 折</el-tag>
              <span style="font-size: 12px;float: right">
                （ 大写：{{ dbjUpperAmount }} ）
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="加价" prop="raise">
              <el-input v-model="dbjForm.raise" oninput="value=value.replace(/[-][^0-9.]/g,'')">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠" prop="best">
              <el-input v-model="dbjForm.best">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="折扣" prop="discount">
              <el-input v-model="dbjForm.discount" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">折</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="返点/折扣">
              <el-card shadow="never" class="tcf-offer-rebate-card">
                <el-collapse>
                  <el-collapse-item>
                    <template slot="title">
                      业绩/支票返点（合计：{{ dbjForm.rebateAmount }}）
                    </template>
                    <el-table
                      ref="multipleRebateTable"
                      :data="dbjForm.bjRebateList"
                      :show-header="false"
                      style="width: 100%"
                      @selection-change="handleRebateSelectionChange"
                    >
                      <el-table-column
                        type="selection"
                        width="45"
                      />
                      <el-table-column
                        label="返点名称"
                        min-width="160"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <el-tag v-if="scope.row.credit===0" :disable-transitions="true" size="mini">冲抵{{ scope.row.maximpact }}%</el-tag>
                          <el-tag v-if="scope.row.credit===9" :disable-transitions="true" size="mini">任意冲抵</el-tag>
                          <el-tag :disable-transitions="true" size="mini" type="warning">最低{{ scope.row.mindiscount }}折</el-tag>
                          <span style="color:#000;margin-left: 2px;cursor: pointer" @click="viewRebateDateil(scope.row)">{{ scope.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="余额"
                        width="100"
                        align="right"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ scope.row.balance }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="优惠金额"
                        width="160"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.discountAmount" :disabled="!scope.row.ischeck" placeholder="优惠金额" oninput="value=value.replace(/[^0-9.]/g,'')">
                            <template slot="append">元</template>
                          </el-input>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-collapse-item>
                  <el-collapse-item>
                    <template slot="title">
                      报备金折扣（合计：{{ dbjForm.reportAmount }}）
                    </template>
                    <el-table
                      ref="multipleReportTable"
                      :data="dbjForm.bjReportList"
                      :show-header="false"
                      style="width: 100%"
                      @selection-change="handleReportSelectionChange"
                    >
                      <el-table-column
                        type="selection"
                        width="45"
                      />
                      <el-table-column
                        label="报备金名称"
                        min-width="160"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <el-tag :disable-transitions="true" size="mini" type="warning">最低{{ scope.row.mindiscount }}折</el-tag>
                          <span style="color:#000;margin-left: 2px;cursor: pointer" @click="viewReportDateil(scope.row)">{{ scope.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="当前折扣"
                        width="160"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.currentDiscount" :disabled="!scope.row.ischeck" placeholder="当前折扣" oninput="value=value.replace(/[^0-9.]/g,'')">
                            <template slot="append">折</template>
                          </el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="优惠金额"
                        width="160"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.discountAmount" :disabled="!scope.row.ischeck" placeholder="优惠金额" oninput="value=value.replace(/[^0-9.]/g,'')">
                            <template slot="append">元</template>
                          </el-input>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-collapse-item>
                  <el-collapse-item>
                    <template slot="title">
                      临时折扣（合计：{{ dbjForm.tempAmount }}）
                    </template>
                    <el-table
                      ref="multipleTempTable"
                      :data="dbjForm.bjTempList"
                      :show-header="false"
                      style="width: 100%"
                      @selection-change="handleTempSelectionChange"
                    >
                      <el-table-column
                        type="selection"
                        width="45"
                      />
                      <el-table-column
                        label="折扣名称"
                        min-width="160"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <el-tag :disable-transitions="true" size="mini" type="warning">最低{{ scope.row.mindiscount }}折</el-tag>
                          <span style="color:#000;margin-left: 2px;cursor: pointer" @click="viewTempDiscount(scope.row.datid)">{{ scope.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="折扣/金额"
                        width="100"
                        align="right"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span v-if="scope.row.credit===0" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ scope.row.amount }}</span>
                          <span v-if="scope.row.credit===1" style="color:#409EFF;font-weight: 500;">{{ scope.row.discount }}折</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="优惠金额"
                        width="160"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.discountAmount" :disabled="!scope.row.ischeck" placeholder="优惠金额" oninput="value=value.replace(/[^0-9.]/g,'')">
                            <template slot="append">元</template>
                          </el-input>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-collapse-item>
                </el-collapse>
              </el-card>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="其他费用">
              <el-card shadow="never" style="font-size: 12px">
                <div style="margin-bottom: 10px">
                  费用总计：<span style="font-size:12px;font-weight: 500;">{{ dbjForm.other }}</span>
                  <el-button icon="el-icon-plus" style="float: right" @click="dbjaddOther">添加其他费用</el-button>
                </div>
                <el-row v-for="(item, index) in dbjForm.offerOther" :key="item.key">
                  <el-col :span="4" style="padding-right: 6px">
                    <el-form-item :prop="'offerOther.' + index +'.type'" :rules="dbjofferOtherRules.type">
                      <el-select v-model="item.type" placeholder="类型">
                        <el-option label="其他" :value="0" />
                        <el-option label="木架" :value="1" />
                        <el-option label="调色" :value="2" />
                        <el-option label="水性漆" :value="3" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :prop="'offerOther.' + index +'.name'" :rules="dbjofferOtherRules.name">
                      <el-input v-model="item.name" placeholder="请输入费用说明" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" style="padding-left: 6px">
                    <el-form-item :prop="'offerOther.' + index +'.amount'" :rules="dbjofferOtherRules.amount">
                      <el-input v-model="item.amount" placeholder="金额" oninput="value=value.replace(/[-][^0-9.]/g,'')">
                        <template slot="append">元</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="text-align: right">
                    <el-button type="danger" icon="el-icon-delete" plain @click="dbjdelOther(index)" />
                  </el-col>
                </el-row>
              </el-card>
            </el-form-item>
          </el-col>
          <el-col v-if="dbjForm.ordertype===4" :span="8">
            <el-form-item label="设计承担" prop="designcom">
              <el-input v-model="dbjForm.designcom" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="dbjForm.ordertype===4" :span="8">
            <el-form-item label="工厂承担" prop="factorycom">
              <el-input v-model="dbjForm.factorycom" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="dbjForm.ordertype===4" :span="8">
            <el-form-item label="客户承担" prop="clientcom">
              <el-input v-model="dbjForm.clientcom" :disabled="true">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="报价备注" prop="content">
          <el-input v-model="dbjForm.content" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item v-if="dbjForm.offerFileid!==null&&dbjForm.offerFileid!==''&&dbjForm.offerFileid!==undefined" label="确认凭证" prop="imgids">
          <span style="color:#99a9bf;font-size: 12px"><i class="el-icon-info" /> 更改折扣与优惠必须上传领导确认凭证</span><span style="color:#F56C6C;font-size: 12px">（这里上传的图片经销商不可见）</span>
          <MultiImg v-model="dbjForm.imgids" :size="'sm'" />
        </el-form-item>
        <el-form-item v-if="dbjForm.offerFileid!==null&&dbjForm.offerFileid!==''&&dbjForm.offerFileid!==undefined" label="公开凭证" prop="imgids">
          <span style="color:#F56C6C;font-size: 12px"><i class="el-icon-info" /> 这里上传的图片所有人可见</span>
          <MultiImg v-model="dbjForm.pubimgids" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-popconfirm :key="dbjbtnKey" title="确认提交此报价吗？" placement="top" @onConfirm="subEditDbj('dbjForm')">
            <el-button slot="reference" type="primary" icon="el-icon-check" :loading="dbjloading">确认报价</el-button>
          </el-popconfirm>
          <el-button type="danger" icon="el-icon-close" style="margin-left: 10px" :loading="dbjloading" @click="turnDbj('dbjForm')">驳回</el-button>
          <el-button @click="dbjVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      v-if="orderInfo.mark>8"
      title="订单预付款信息"
      :visible.sync="yfkVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="yfkForm" v-loading="yfkofferinfoLoading" :model="yfkForm" :rules="yfkRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="yfkForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="报价详情" prop="offerdetail">
          <el-card shadow="hover" style="font-size: 12px;color:#606266">
            <div>
              <span style="color:#99a9bf">总报价：</span>
              <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ yfkofferinfo.amount }}</span>元
              <s v-if="yfkofferinfo.amount!==yfkofferinfo.totalprice" style="margin-left: 10px;color:#999;">{{ yfkofferinfo.totalprice }}</s>
              <el-tag v-if="yfkofferinfo.discount>0" type="danger" :disable-transitions="true" size="mini" style="margin-left: 10px">{{ yfkofferinfo.discount }} 折</el-tag>
            </div>
            <div v-if="yfkofferinfo.factorycom!=0||yfkofferinfo.designcom!=0">
              <span style="color:#99a9bf">设计承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ yfkofferinfo.designcom }}</span>元
              <span style="color:#99a9bf;margin-left: 20px">工厂承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ yfkofferinfo.factorycom }}</span>元
              <span style="color:#99a9bf;margin-left: 20px">客户承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ yfkofferinfo.clientcom }}</span>元
            </div>
            <div>
              <span style="color:#99a9bf">预付款：</span>
              <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ yfkofferinfo.deposit }}</span>元
              <el-tag v-if="yfkofferinfo.isall===0" size="mini" :disable-transitions="true" style="margin-left: 10px">{{ yfkofferinfo.deposit_per }}%</el-tag>
              <el-tag v-if="yfkofferinfo.isall===1" size="mini" :disable-transitions="true" style="margin-left: 10px" type="warning">≤{{ yfkofferinfo.deposit_less }}取全款</el-tag>
            </div>
            <div v-if="yfkofferinfo.reportEndtime!==null&&yfkofferinfo.reportEndtime!==''&&yfkofferinfo.reportEndtime!==undefined">
              <span style="color:#99a9bf;font-size:12px;"><i class="el-icon-info" />
                当前折扣将在 <b v-if="yfkReportTime.day>0">{{ yfkReportTime.day }}天</b> <b>{{ yfkReportTime.hour }} : {{ yfkReportTime.min }} : {{ yfkReportTime.second }}</b>
                <span v-if="yfkofferinfo.reportEndDiscount>0">之后变为 <el-tag type="info" :disable-transitions="true" size="mini">{{ yfkofferinfo.reportEndDiscount }} 折</el-tag></span>
                <span v-if="yfkofferinfo.reportEndDiscount<=0">之后失效</span>
              </span>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item v-if="yfkofferinfo.deposit>0">
          <div style="font-size: 12px;color:#f56c6c;">
            <i class="el-icon-info" /> 预付款提示：请在订单收款里添加收款，财务收款审核通过将自动放行
          </div>
        </el-form-item>
        <!-- <el-form-item v-if="yfkofferinfo.deposit>0" label="账户余额">
          <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ yfkofferinfo.accamount }}</span>元
          <span style="color:#99a9bf">（{{ yfkofferinfo.accname }}）</span>
        </el-form-item>
        <el-form-item v-if="yfkofferinfo.deposit>0" label="扣款金额" prop="money">
          <el-input v-model="yfkForm.money" :disabled="true" style="width: 200px" oninput="value=value.replace(/[^0-9.]/g,'')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item> -->
        <el-form-item label="备注" prop="content">
          <el-input v-model="yfkForm.content" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button v-if="yfkofferinfo.deposit<=0" type="primary" icon="el-icon-check" :loading="yfkloading" @click="subEditYfk('yfkForm')">立即预付</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="yfkloading" @click="turnYfk('yfkForm')">预付款驳回</el-button>
          <el-button @click="yfkVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      v-if="orderInfo.mark>=9"
      :title="orderInfo.mark == 9 ? '订单跳过预付' : '订单修改过预付时间'"
      :visible.sync="yfkPassVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="yfkPassForm" :model="yfkPassForm" :rules="yfkPassRules" label-position="right" label-width="80px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="yfkPassForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="时间" prop="time">
          <el-date-picker
            v-model="yfkPassForm.time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择时间"
            :picker-options="yfkPassPickerOptions"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="yfkPassForm.remark" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="yfkPassLoading" @click="subPassYfk('yfkPassForm')">确定跳过</el-button>
          <el-button @click="yfkPassVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="工厂分派"
      :visible.sync="gcfpVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="gcfpForm" :model="gcfpForm" :rules="gcfpRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="gcfpForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="分派工厂" prop="groupid">
          <el-select v-model="gcfpForm.groupid" style="width:100%" filterable clearable placeholder="请选择" @change="getOrderPrice">
            <el-option
              v-for="item in gcfpgroupList"
              :key="item.factory_id"
              :label="item.factory_name"
              :value="item.factory_id"
            >
              <span style="float: left">{{ item.factory_name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.simple_name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="工厂折扣" prop="discount">
              <el-input v-model="gcfpForm.discount" placeholder="工厂折扣">
                <template slot="append">折</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="工厂金额" prop="price">
              <el-input v-model="gcfpForm.price" placeholder="工厂金额">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="分派备注" prop="content">
          <el-input v-model="gcfpForm.content" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="gcfpForm.files" />
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="gcfpForm.imgids" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="gcfploading" @click="subEditGcfp('gcfpForm')">立即分派</el-button>
          <el-button @click="gcfpVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="工厂接单"
      :visible.sync="gcjdVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="gcjdForm" :model="gcjdForm" :rules="gcjdRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="gcjdForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="接单备注" prop="content">
          <el-input v-model="gcjdForm.content" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="gcjdForm.files" />
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="gcjdForm.imgids" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="gcjdloading" @click="subEditGcjd('gcjdForm')">立即接单</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="gcjdloading" @click="turnGcjd('gcjdForm')">拒接</el-button>
          <el-button @click="gcjdVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="订单排产"
      :visible.sync="ddpcVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="ddpcForm" v-loading="ddpcformLoading" :model="ddpcForm" :rules="ddpcRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="ddpcForm.ordername" :disabled="true" />
        </el-form-item>
        <div v-for="(item, index) in ddpcForm.process" :key="item.key">
          <el-form-item :label="item.process_name" :prop="'process.' + index +'.process_name'" :rules="ddpcprocessRules.process_name">
            <div style="position: absolute">
              <i v-if="item.isComplete===0&&ddpcForm.mark===12" class="el-icon-remove-outline" style="color:#99a9bf" />
              <i v-if="item.isComplete===0&&ddpcForm.mark===13" class="el-icon-time" style="color:#E6A23C" />
              <i v-if="item.isComplete===1" class="el-icon-success" style="color:#67C23A" />
            </div>
            <el-input-number
              v-model="item.days"
              :min="1"
              :disabled="item.isComplete===1"
              style="margin-left:24px;"
            />
            <span style="color:#99a9bf;font-size:12px;margin-left: 10px">天</span>
          </el-form-item>
        </div>
        <el-form-item label="色板信息" prop="swatch">
          <el-input v-model="ddpcForm.swatch" type="textarea" maxlength="100" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="ddpcloading" @click="subEditDdpc('ddpcForm')">立即提交</el-button>
          <el-button @click="ddpcVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="修改订单信息"
      :visible.sync="editOrderInfoDialog"
      width="45%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <el-form ref="orderInfoForm" :model="orderInfoCopy" :rules="orderInfoRules" label-position="right" label-width="100px" size="small">
        <el-form-item label="订单号" prop="ordernum">
          <el-input v-model="orderInfoCopy.ordernum" disabled />
        </el-form-item>
        <el-form-item v-if="orderInfoCopy.produnum!==''" label="生产单号" prop="produnum">
          <el-input v-model="orderInfoCopy.produnum" disabled />
        </el-form-item>
        <el-form-item label="订单类型" prop="type">
          <el-radio-group v-model="orderInfoCopy.type" @change="changeType">
            <el-radio :label="0">正单</el-radio>
            <el-radio :label="1">客改单</el-radio>
            <el-radio :label="2">增补单</el-radio>
            <el-radio :label="3">色板单</el-radio>
            <el-radio :label="4">售后单</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item v-if="orderInfoCopy.type == 4" label="是否需要收款" prop="fk">
          <el-radio-group v-model="orderInfoCopy.fk">
            <el-radio :label="0">需要</el-radio>
            <el-radio :label="1">不需要</el-radio>
          </el-radio-group>
          <div style="font-size: 13px;color:#F56C6C">
            <i class=" el-icon-info"></i> 温馨提示：<br>
            <span>仅售后单时，是否需要对客户进行收款。</span><br>
          </div>
        </el-form-item> -->
        <el-form-item v-if="orderInfoCopy.type!==0&&isManual===false" label="原正单" prop="oldorderid">
          <OrderSelect :key="orderLoad" v-model="orderInfoCopy.oldorderid" :oldorderid="editOldorderid" :disabled="orderInfoCopy.delid===null||orderInfoCopy.delid===''" :delid="orderInfoCopy.delid" @setOrder="setOrder" />
          <el-button v-if="orderInfoCopy.delid!==null&&orderInfoCopy.delid!==''" type="text" icon="el-icon-edit" @click="openManual">找不到原正单，点击这里手动填写</el-button>
        </el-form-item>
        <el-form-item v-if="isManual===true&&orderInfoCopy.type!==0" label="原正单" prop="delid">
          <el-col :span="10" style="padding-right: 10px">
            <el-form-item prop="beforenum">
              <el-input v-model="orderInfoCopy.beforenum" :disabled="orderInfoCopy.delid===null||orderInfoCopy.delid===''" placeholder="请输入原正单生产单号" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item prop="beforeyear">
              <el-date-picker
                v-model="orderInfoCopy.beforeyear"
                :disabled="orderInfoCopy.delid===null||orderInfoCopy.delid===''"
                type="year"
                format="yyyy年"
                value-format="yyyy"
                :picker-options="pickerYear"
                placeholder="选择原正单年份"
              />
            </el-form-item>
          </el-col>
          <el-button v-if="orderInfoCopy.delid!==null&&orderInfoCopy.delid!==''" type="text" icon="el-icon-search" @click="isManual=false">点击这里搜索原正单</el-button>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-select v-model="orderInfoCopy.brand_name" placeholder="请品牌" disabled>
            <el-option :label="orderInfoCopy.brand_name" :value="orderInfoCopy.brand_name" />
          </el-select>
        </el-form-item>
        <el-form-item label="经销商" prop="all_name">
          <el-select v-model="orderInfoCopy.all_name" placeholder="请选择经销商" disabled>
            <el-option :label="orderInfoCopy.all_name" :value="orderInfoCopy.all_name" />
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称" prop="custname">
          <el-input v-model="orderInfoCopy.custname" maxlength="10" />
        </el-form-item>
        <el-form-item label="客户电话" prop="custtel">
          <el-input v-model="orderInfoCopy.custtel" maxlength="11" />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="orderInfoCopy.address" maxlength="100" />
        </el-form-item>
        <el-form-item label="订单性质" prop="nature">
          <el-radio v-model="orderInfoCopy.nature" :label="0">家装</el-radio>
          <el-radio v-model="orderInfoCopy.nature" :label="1">展厅</el-radio>
          <el-radio v-model="orderInfoCopy.nature" :label="2">工程</el-radio>
        </el-form-item>
        <el-form-item v-if="orderInfoCopy.type===0" label="报备关联" prop="reportid">
          <el-cascader
            v-model="editOrderReportid"
            :options="jdReportList"
            style="width:100%"
            filterable
            clearable
          />
        </el-form-item>
        <el-form-item label="设计师" prop="designer">
          <el-input v-model="orderInfoCopy.designer" maxlength="10" />
        </el-form-item>
        <el-form-item label="设计师电话" prop="designerTel">
          <el-input v-model="orderInfoCopy.designerTel" maxlength="11" />
        </el-form-item>
        <el-form-item label="色板来源" prop="source">
          <!--          <el-radio-group v-model="orderInfoCopy.source">-->
          <!--            <el-radio :label="0">厂部标准色板</el-radio>-->
          <!--            <el-radio :label="1">客户提供色板</el-radio>-->
          <!--            <el-radio :label="2">厂部定制色板</el-radio>-->
          <!--          </el-radio-group>-->
          <el-checkbox-group v-model="orderInfoCopy.source" @change="changeradio">
            <el-checkbox :label="0">厂部标准色板</el-checkbox>
            <el-checkbox :label="1">客户提供色板</el-checkbox>
            <el-checkbox :label="2">厂部定制色板</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="orderInfoCopy.source && orderInfoCopy.source.indexOf(0) > -1" label="厂部标准色板" prop="sids">
          <span v-if="!orderInfoCopy.bid" style="color:#99a9bf;">请先选择品牌</span>
          <el-select
            v-else
            v-model="orderInfoCopy.sids"
            style="width: 100%;"
            multiple
            filterable
            placeholder="可输入编号/名称搜索"
          >
            <el-option
              v-for="(item, index) in cbList"
              :key="index"
              :label="item.code + ' / ' + item.name + ' / ' + item.seriesname"
              :value="item.board_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预估价格" prop="estimated">
          <el-input v-model="orderInfoCopy.estimated" style="width: 300px;">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="下单时间" prop="time">
          <el-input v-model="orderInfoCopy.time" disabled />
        </el-form-item>
        <el-form-item label="期望交期" prop="exptime">
          <el-date-picker
            v-model="orderInfoCopy.exptime"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy年MM月dd日"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="eidtOrderBtn" @click="goEditOrderInfo('orderInfoForm')">立即提交</el-button>
          <!--          <el-button @click="resetEditOrder('orderInfoForm')">重置</el-button>-->
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="userType===0?'经销商信息':'员工信息'"
      :visible.sync="userDetailDialog"
      width="40%"
      :before-close="handleClose"
    >
      <el-row v-loading="userDetailLoading" style="padding:10px 20px 20px 20px">
        <div v-if="userType===1" style="margin-bottom:10px;">
          <span class="user-item">姓名：<span>{{ userDetail.dName }}</span></span>
          <span class="user-item" style="margin-left: 30px;">性别：<span>{{ userDetail.dSex }}</span></span>
          <span v-if="userDetail.dBirthday!==''" class="user-item" style="margin-left: 30px;">生日：<span>{{ userDetail.dBirthday }}<span v-if="userDetail.dBdtype===0" style="color: #20a0ff">(公历)</span><span v-else style="color: #20a0ff">(农历)</span></span></span>
          <span v-if="userDetail.dBirthday===''" class="user-item" style="margin-left: 30px;">生日：<span>未填写</span></span>
        </div>
        <div v-if="userType===0" style="margin-bottom:10px;">
          <span class="user-item">姓名：<span>{{ userDetail.name }}</span></span>
          <span class="user-item" style="margin-left: 30px;">性别：<span>{{ userDetail.sex }}</span></span>
          <span v-if="userDetail.birthday!==''" class="user-item" style="margin-left: 30px;">生日：<span>{{ userDetail.birthday }}<span v-if="userDetail.type===0" style="color: #20a0ff">(公历)</span><span v-else style="color: #20a0ff">(农历)</span></span></span>
          <span v-if="userDetail.birthday===''" class="user-item" style="margin-left: 30px;">生日：<span>未填写</span></span>
        </div>
        <div v-if="userType===1" style="margin-bottom:10px;">
          <span v-if="userDetail.dProvince!=='' && userDetail.dCity!=='' && userDetail.dCounty!==''" class="user-item">籍贯：<span>{{ userDetail.dProvince }}/{{ userDetail.dCity }}/{{ userDetail.dCounty }}</span></span>
          <span v-if="userDetail.dProvince==='' && userDetail.dCity==='' && userDetail.dCounty===''" class="user-item">籍贯：<span>未填写</span></span>
          <span v-if="userDetail.dProvince!=='' && userDetail.dCity==='' && userDetail.dCounty===''" class="user-item">籍贯：<span>{{ userDetail.dProvince }}</span></span>
          <span v-if="userDetail.dProvince!=='' && userDetail.dCity!=='' && userDetail.dCounty===''" class="user-item">籍贯：<span>{{ userDetail.dProvince }}/{{ userDetail.dCity }}</span></span>
          <span v-if="userDetail.dEmail!==''" class="user-item" style="margin-left: 30px;">邮箱：<span>{{ userDetail.dEmail }}</span></span>
          <span v-if="userDetail.dEmail===''" class="user-item" style="margin-left: 30px;">邮箱：<span>未填写</span></span>
          <span v-if="userDetail.dWchat!==''" class="user-item" style="margin-left: 30px;">微信：<span>{{ userDetail.dWchat }}</span></span>
          <span v-if="userDetail.dWchat===''" class="user-item" style="margin-left: 30px;">微信：<span>未填写</span></span>
        </div>
        <div v-if="userType===0" style="margin-bottom:10px;">
          <span v-if="userDetail.province!=='' && userDetail.city!=='' && userDetail.county!==''" class="user-item">籍贯：<span>{{ userDetail.province }}/{{ userDetail.city }}/{{ userDetail.county }}</span></span>
          <span v-if="userDetail.province==='' && userDetail.city==='' && userDetail.county===''" class="user-item">籍贯：<span>未填写</span></span>
          <span v-if="userDetail.province!=='' && userDetail.city==='' && userDetail.county===''" class="user-item">籍贯：<span>{{ userDetail.province }}</span></span>
          <span v-if="userDetail.province!=='' && userDetail.city!=='' && userDetail.county===''" class="user-item">籍贯：<span>{{ userDetail.province }}/{{ userDetail.city }}</span></span>
          <span v-if="userDetail.email!==''" class="user-item" style="margin-left: 30px;">邮箱：<span>{{ userDetail.email }}</span></span>
          <span v-if="userDetail.email===''" class="user-item" style="margin-left: 30px;">邮箱：<span>未填写</span></span>
          <span v-if="userDetail.wchat!==''" class="user-item" style="margin-left: 30px;">微信：<span>{{ userDetail.wchat }}</span></span>
          <span v-if="userDetail.wchat===''" class="user-item" style="margin-left: 30px;">微信：<span>未填写</span></span>
        </div>
        <div v-if="userType===0" style="margin-bottom:10px;">
          <span class="user-item">手机号：<span>{{ userDetail.username }}</span></span>
          <span v-if="userDetail.tel!==''" class="user-item" style="margin-left: 30px;">联系电话：<span>{{ userDetail.tel }}</span></span>
          <span v-if="userDetail.tel===''" class="user-item" style="margin-left: 30px;">联系电话：<span>未填写</span></span>
        </div>
        <div v-if="userType===1" style="margin-bottom:10px;">
          <span class="user-item">手机号：<span>{{ userDetail.dUsername }}</span></span>
          <span v-if="userDetail.dTel!==''" class="user-item" style="margin-left: 30px;">联系电话：<span>{{ userDetail.dTel }}</span></span>
          <span v-if="userDetail.dTel===''" class="user-item" style="margin-left: 30px;">联系电话：<span>未填写</span></span>
          <span class="user-item" style="margin-left: 30px;">职位：<span>{{ userDetail.position_name }}</span></span>
        </div>
        <div v-if="userType===1" style="margin-bottom:10px;">
          <span class="user-item">部门：<span>{{ userDetail.dept_name }}</span></span>
          <span class="user-item" style="margin-left: 30px;">公司：<span>{{ userDetail.group_name }}</span></span>
        </div>
      </el-row>
    </el-dialog>
    <el-dialog
      title="订单收款详细"
      :visible.sync="collectRecordDialog"
      width="900px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div style="height:40px">
        <template v-if="offerInfo!==null&&offerInfo!==''&&offerInfo!==undefined">
          <span style="color:#99a9bf">总报价：</span>
          <span style="color:#F56C6C;font-weight: 500;">{{ offerInfo.amount }}</span>
          <span style="color:#99a9bf;margin-left:20px;">已收款：</span>
          <span style="color: #F56C6C;font-weight: 500;">{{ offerInfo.paidfor }}</span>
          <span style="color:#99a9bf;margin-left:20px;">余款：</span>
          <span style="color: #F56C6C;font-weight: 500;">{{ offerInfo.balance }}</span>
          <el-tag v-if="offerInfo.balance<=0" size="mini" style="margin-left: 10px">已结清</el-tag>
        </template>
        <el-button v-if="roleInfo.jd===1&&brandPrincipal.serviceid===user.dUserid" size="small" icon="el-icon-money" type="danger" style="float: right; margin-left: 10px;" @click="refundBtn">退款申请</el-button>
        <el-button v-if="roleInfo.jd===1&&brandPrincipal.serviceid===user.dUserid" size="small" icon="el-icon-plus" type="primary" style="float: right; margin-left: 10px;" @click="addCollect(0)">添加收款</el-button>
        <el-button v-if="roleInfo.jd===1&&brandPrincipal.serviceid===user.dUserid&&orderInfo.mark==9" size="small" type="warning" style="float: right; margin-left: 10px;" @click="yfkPassBtn">跳过预付</el-button>
        <el-button v-if="roleInfo.jd===1&&brandPrincipal.serviceid===user.dUserid&&orderInfo.mark>9" size="small" type="warning" style="float: right; margin-left: 10px;" @click="yfkPassBtn">修改过预付时间</el-button>
      </div>
      <el-table
        v-loading="collectRecordLoading"
        :data="collectRecord"
        height="400"
        style="width: 100%;border:1px solid #EBEEF5;"
        size="small"
      >
        <el-table-column
          label="收款流水号"
          align="center"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.ranum!==null&&scope.row.ranum!==''&&scope.row.ranum!==undefined">{{ scope.row.ranum }}</span>
            <span v-if="scope.row.ranum===null||scope.row.ranum===''||scope.row.ranum===undefined">N/A</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="paycontent"
          label="收款内容"
          width="100"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="type"
          label="收款类型"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type===0">账户扣款</span>
            <span v-if="scope.row.type===3">收款申请</span>
            <span v-if="scope.row.type===1">支付宝</span>
            <span v-if="scope.row.type===2">微信</span>
            <span v-if="scope.row.type===4">收款抹零</span>
            <span v-if="scope.row.type===5">返点抵款</span>
            <span v-if="scope.row.type===6">赔款/划账</span>
            <span v-if="scope.row.type===7">报备金冲抵</span>
            <span v-if="scope.row.type===8">样品预存款抵扣</span>
            <span v-if="scope.row.type===9">冲业绩抵扣</span>
            <span v-if="scope.row.type===10">零售项目抵扣</span>
            <span v-if="scope.row.type===11">退款申请</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="receipttime"
          label="收款日期"
          align="center"
          width="120"
          show-overflow-tooltip
        />
        <el-table-column
          label="收款金额"
          align="center"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span style="color:#409EFF;font-weight: 500;">{{ scope.row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="卡号"
          width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="scope.row.type == 11">
              <span style="color:#99a9bf">是否减货款：</span>{{ scope.row.card == '1' ? '是' : '否' }}
            </div>
            <template v-else>
              <span v-if="scope.row.card!==null&&scope.row.card!==''&&scope.row.card!==undefined">{{ scope.row.card }}</span>
              <span v-if="scope.row.card===null||scope.row.card===''||scope.row.card===undefined">N/A</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="operName"
          label="操作人"
          align="center"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="time"
          label="操作时间"
          align="center"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column
          align="center"
          label="审核状态"
          fixed="right"
          width="100"
        >
          <template slot-scope="scope">
            <el-tag v-if="(scope.row.type===0||scope.row.type===3||scope.row.type===11)&&scope.row.mark===1" :disable-transitions="true" size="mini" type="danger">已拒绝</el-tag>
            <el-tag v-if="(scope.row.type===0||scope.row.type===3||scope.row.type===11)&&scope.row.mark===2" :disable-transitions="true" size="mini">已审核</el-tag>
            <el-tag v-if="(scope.row.type===0||scope.row.type===3||scope.row.type===11)&&scope.row.mark===0" :disable-transitions="true" size="mini" type="warning">审核中</el-tag>
            <el-tag v-if="scope.row.type!==0&&scope.row.type!==3&&scope.row.type!==11" :disable-transitions="true" size="mini">已审核</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          v-if="user.dUserid==438||(roleInfo.jd===1&&brandPrincipal.serviceid===user.dUserid)"
          align="center"
          fixed="right"
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-dropdown v-if="scope.row.type===11&&scope.row.mark!==2" size="mini" split-button icon="el-icon-edit" @click="refundEditBtn(scope.row)">
              <i class="el-icon-edit" /> 编辑
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item style="color:#F56C6C" @click.native="delCollect(scope.row)"><i class="el-icon-delete" />删除退款</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown v-if="(scope.row.type===0||scope.row.type===3)&&scope.row.mark!==2" size="mini" split-button icon="el-icon-edit" @click="addCollect(scope.row.crid)">
              <i class="el-icon-edit" /> 编辑
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item style="color:#F56C6C" @click.native="delCollect(scope.row)"><i class="el-icon-delete" />删除收款</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown v-if="scope.row.type===5||scope.row.type===6||scope.row.type===7" size="mini" split-button icon="el-icon-search" @click="viewOtherAcc(scope.row)">
              <i class="el-icon-search" /> 查看
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item style="color:#F56C6C" @click.native="delCollect(scope.row)"><i class="el-icon-delete" />删除收款</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-if="(scope.row.type===3)&&scope.row.mark===2" size="mini" icon="el-icon-search" @click="viewCollect(scope.row)">查看收款</el-button>
            <el-tooltip class="item" effect="dark" content="超过24小时后将无法删除" placement="top-start">
              <el-button v-if="(user.dUserid==438||new Date().getTime()-Date.parse(scope.row.time)<86400000)&&(scope.row.type===0||scope.row.type===4||scope.row.type===8||scope.row.type===9)" size="mini" icon="el-icon-delete" @click="delCollect(scope.row)">删除收款</el-button>
            </el-tooltip>
            <!-- <el-button v-if="scope.row.type===9" size="mini" :disabled="true">原系统收款</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="collectTitle"
      :visible.sync="editCollectVisible"
      width="770px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editCollectForm" v-loading="collectInfoLoading" :model="editCollectForm" :rules="editCollectRules" label-position="right" label-width="90px" size="small">
        <div v-if="editCollectForm.crid===0" style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info" /> 收款须知："<b>收款抹零</b>"不会从任何账户里扣除金额，且收款金额不可超过5元
        </div>
        <el-form-item v-if="editCollectForm.crid!==0&&editCollectForm.audittime!==null&&editCollectForm.audittime!==''" label="审核信息">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{ editCollectForm.audittime }}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{ editCollectForm.auditname }}</span>
            </div>
            <div v-if="editCollectForm.rson!=''&&editCollectForm.rson!=null" style="color:#606266;font-size: 13px;">
              <span style="color:#99a9bf">拒绝原因：</span>{{ editCollectForm.rson }}
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="收款内容" prop="paycontent">
          <el-select v-model="editCollectForm.paycontent" :disabled="orderInfo.type==3">
            <el-option
              v-for="item in paycontentList"
              v-if="(editCollectForm.crid!==0&&item.name!=='收款抹零')||editCollectForm.crid===0"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
              <span :style="item.name==='收款抹零'?'color:#F56C6C':''">{{ item.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="editCollectForm.paycontent==='拆单费'" style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info" /> 注意："<b>拆单费</b>"收取审核通过后将会取消该订单
        </div>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.crid===0" label="收款类型" prop="type">
          <el-radio v-model="editCollectForm.type" :label="0">账户扣款</el-radio>
          <el-radio v-model="editCollectForm.type" :label="3">收款申请</el-radio>
          <el-radio v-model="editCollectForm.type" :label="5">返点抵款</el-radio>
          <el-radio v-model="editCollectForm.type" :label="6">售后赔款</el-radio>
          <!-- <el-radio v-model="editCollectForm.type" :label="7">报备金冲抵</el-radio> -->
          <el-radio v-if="orderInfoCopy.type==0 && editCollectForm.paycontent!=='拆单费'" v-model="editCollectForm.type" :label="8">样品预存款抵扣</el-radio>
          <el-radio v-if="editCollectForm.paycontent!=='拆单费'" v-model="editCollectForm.type" :label="9">冲业绩抵扣</el-radio>
          <el-radio v-if="orderInfo.delid === '1137fdb9-88cd-4827-82a1-c256e83b84d6'" v-model="editCollectForm.type" :label="10">零售项目抵扣</el-radio>
        </el-form-item>
        <el-form-item v-if="editCollectForm.type===0&&editCollectForm.paycontent!=='收款抹零'" label="账户余额">
          <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ editCollectForm.accamount }}</span>元
          <span style="color:#99a9bf">（{{ editCollectForm.accname }}）</span>
        </el-form-item>
        <el-form-item v-if="editCollectForm.type===8&&editCollectForm.paycontent!=='收款抹零'" label="样品预存款余额">
          <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ editCollectForm.leftJoin }}</span>元
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===5" label="返点账户" prop="accdataid">
          <Rebate v-model="editCollectForm.accdataid" :orderid="orderInfo.orderid" @setRebate="setRebate" />
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===5&&editCollectForm.rebateInfo.balance!==null&&editCollectForm.rebateInfo.balance!==undefined" label="账户余额">
          <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ editCollectForm.rebateInfo.balance }}</span>元
          <el-tag v-if="editCollectForm.rebateInfo.credit===0" :disable-transitions="true" size="mini" type="warning">最高冲抵{{ editCollectForm.rebateInfo.maximpact }}%</el-tag>
          <el-tag v-if="editCollectForm.rebateInfo.credit===9" :disable-transitions="true" size="mini">任意冲抵</el-tag>
          <el-button type="text" icon="el-icon-search" style="margin-left: 20px" @click="viewRebateDateil(editCollectForm.rebateInfo)">查看账户详细</el-button>
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===6" label="赔款账户" prop="accdataid">
          <After v-model="editCollectForm.accdataid" :orderid="orderInfo.orderid" @setAfter="setAfter" />
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===6&&editCollectForm.afterInfo.balance!==null&&editCollectForm.afterInfo.balance!==undefined" label="账户余额">
          <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ editCollectForm.afterInfo.balance }}</span>元
          <el-tag v-if="editCollectForm.afterInfo.credit===0" :disable-transitions="true" size="mini" type="warning">最高冲抵{{ editCollectForm.afterInfo.maximpact }}%</el-tag>
          <el-tag v-if="editCollectForm.afterInfo.credit===9" :disable-transitions="true" size="mini">任意冲抵</el-tag>
          <el-button type="text" icon="el-icon-search" style="margin-left: 20px" @click="viewAfterDateil(editCollectForm.afterInfo)">查看账户详细</el-button>
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===7" label="报备金账户" prop="accdataid">
          <Report v-model="editCollectForm.accdataid" :orderid="orderInfo.orderid" @setReport="setReport" />
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===7&&editCollectForm.reportInfo.balance!==null&&editCollectForm.reportInfo.balance!==undefined" label="账户余额">
          <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ editCollectForm.reportInfo.balance }}</span>元
          <el-button type="text" icon="el-icon-search" style="margin-left: 20px" @click="viewReportDateil(editCollectForm.reportInfo)">查看账户详细</el-button>
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===9" label="冲业绩记录" prop="accdataid">
          <Achievement v-model="editCollectForm.accdataid" :delid="orderInfo.delid" @setAchievement="setAchievement" />
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===10" label="零售项目" prop="accdataid">
          <Project v-model="editCollectForm.accdataid" :delid="orderInfo.delid" @setProject="setProject" />
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===9&&editCollectForm.achievementInfo.balance!==null&&editCollectForm.achievementInfo.balance!==undefined" label="冲业绩余额">
          <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ editCollectForm.achievementInfo.balance }}</span>元
          <el-button type="text" icon="el-icon-search" style="margin-left: 20px" @click="viewAchievementDateil(editCollectForm.achievementInfo)">查看冲业绩详细</el-button>
        </el-form-item>
        <div v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===3" style="font-size: 12px;color:#99a9bf;margin-bottom: 18px;padding-left: 20px">
          <i class="el-icon-info" /> 申请提示：此收款申请财务审核通过后将自动加入此订单收款中
          <!-- 此收款申请财务审核通过后使用金额将自动加入此订单收款中，剩余金额将自动充值到当前经销商账户 -->
        </div>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===3" label="收款账户" prop="aid">
          <el-select v-model="editCollectForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name"
            >
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===3" label="收款性质" prop="nature">
          <el-select v-model="editCollectForm.nature">
            <el-option
              v-for="item in receiptNatureList"
              :key="item.rntid"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="收款日期" prop="receipttime">
          <el-date-picker
            v-model="editCollectForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <div v-if="orderInfo.type==3" style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info" /> 色板单收款固定为全款一次性收款
        </div>
        <el-form-item label="收款金额" prop="money">
          <el-input v-model="editCollectForm.money" :disabled="orderInfo.type==3" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===3" label="卡号" prop="card">
          <el-input v-model="editCollectForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit />
        </el-form-item>
        <el-form-item v-if="editCollectForm.paycontent!=='收款抹零'&&editCollectForm.type===3" label="打款凭证" prop="imgids">
          <MultiImg :key="imgCollectLoad" v-model="editCollectForm.imgids" :limit="9" :size="'sm'" :old="editCollectimgList" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editCollectForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editCollectloading" @click="subCollectEdit('editCollectForm')">立即提交</el-button>
          <el-button @click="editCollectVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 提交退款申请 -->
    <el-dialog
      :title="refundApplyForm.id ? '编辑订单退款申请' : '添加订单退款申请'"
      :visible.sync="refundApplyVisible"
      width="600px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="refundApplyForm" v-loading="refundApplyLoading" :model="refundApplyForm" :rules="refundApplyRules" label-position="right" label-width="90px" size="small">
        <el-form-item v-if="refundApplyForm.id && refundApplyForm.audittime" label="审核信息">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{ refundApplyForm.audittime }}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{ refundApplyForm.auditname }}</span>
            </div>
            <div v-if="refundApplyForm.rson" style="color:#606266;font-size: 13px;">
              <span style="color:#99a9bf">拒绝原因：</span>{{ refundApplyForm.rson }}
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="退款日期" prop="receipttime">
          <el-date-picker
            v-model="refundApplyForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="退款金额" prop="money">
          <el-input v-model="refundApplyForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info" /> 是否减货款：勾选后，退款申请通过时订单总货款金额将会同步减去退款金额；不勾选则仅减少已收款金额，总货款不变。
        </div>
        <el-form-item label="是否减货款" prop="need">
          <el-checkbox v-model="refundApplyForm.need">是否减货款</el-checkbox>
        </el-form-item>
        <el-form-item label="退款凭证" prop="imgids">
          <MultiImg :key="refundApplyImgKey" v-model="refundApplyForm.imgids" :limit="9" :size="'sm'" :old="refundApplyImgList" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="refundApplyForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="refundApplyLoading" @click="subRefundApply('refundApplyForm')">立即提交</el-button>
          <el-button @click="refundApplyVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="业绩/支票返点详情"
      :visible.sync="viewRebateVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewRebateLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewRebatedata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewRebatedata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewRebatedata.delname }}</td>
          <th>返点名称</th>
          <td colspan="3" style="color:#000;">{{ viewRebatedata.name }}</td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span v-if="viewRebatedata.starttime==='0'"><i class="el-icon-date" /> 无期限</span>
            <span v-if="viewRebatedata.starttime!=='0'"><i class="el-icon-date" /> {{ viewRebatedata.starttime }} ~ {{ viewRebatedata.endtime }}</span>
          </td>
        </tr>
        <tr>
          <th>返点总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewRebatedata.amount }}</td>
          <th>返点余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewRebatedata.balance }}</td>
          <th>抵款方式</th>
          <td>
            <span v-if="viewRebatedata.credit===0">最高冲抵{{ viewRebatedata.maximpact }}%</span>
            <span v-if="viewRebatedata.credit===1">享受{{ viewRebatedata.maxdiscount }}折</span>
            <span v-if="viewRebatedata.credit===9">任意冲抵</span>
          </td>
        </tr>
        <tr>
          <th>适用订单</th>
          <td>
            <span v-if="viewRebatedata.ordertype===0">无限制</span>
            <span v-if="viewRebatedata.ordertype===1">正单</span>
            <span v-if="viewRebatedata.ordertype===2">补单</span>
          </td>
          <td colspan="4">
            订单金额满 {{ viewRebatedata.orderMoney }} 元以上可享受，同比享受最低折扣不低于 {{ viewRebatedata.mindiscount }} 折
          </td>
        </tr>
        <tr>
          <th>返点凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgRebateSrcList"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgRebateSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewRebatedata.remark }}</td>
        </tr>
        <tr v-if="viewRebatedata.mark===2">
          <th>审核人</th>
          <td>{{ viewRebatedata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewRebatedata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewRebateVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="报备金详情"
      :visible.sync="viewReportVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewReportLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewReportdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewReportdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewReportdata.delname }}</td>
          <th style="width: 100px">报备金名称</th>
          <td colspan="3" style="color:#000;">{{ viewReportdata.name }}</td>
        </tr>
        <tr>
          <th>报备要求</th>
          <td>
            {{ viewReportdata.per }}/单
          </td>
          <th>账户余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewReportdata.balance }}</td>
          <td colspan="2">
            同比享受最低折扣不低于 {{ viewReportdata.mindiscount }} 折
          </td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportAddress">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.address }}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span><i class="el-icon-date" /> {{ viewReportdata.starttime }} ~ {{ viewReportdata.endtime }}</span>
          </td>
        </tr>
        <tr>
          <th>对应折扣</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportDiscount">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.starttime }} 至 {{ d.endtime }}</td>
                <td style="width: 100px;text-align: center">{{ d.discount }}折</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="5">{{ viewReportAcccount.groupname }}（{{ viewReportAcccount.name }}，{{ viewReportAcccount.card }}）</td>
        </tr>
        <tr>
          <th>打款金额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewReportdata.amount }}</td>
          <th>打款日期</th>
          <td>{{ viewReportdata.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ viewReportdata.nature }}</td>
        </tr>
        <tr>
          <th>报备凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgReportSrcList"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgReportSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewReportdata.remark }}</td>
        </tr>
        <tr v-if="viewReportdata.mark===2">
          <th>审核人</th>
          <td>{{ viewReportdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewReportdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewReportVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 冲业绩详情 -->
    <el-dialog
      title="冲业绩详情"
      :visible.sync="viewCyjVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewCyjLoading" class="tcf-detail-table cyj-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewCyjdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewCyjdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewCyjdata.dealerName || orderInfo.all_name }}</td>
          <th>卡号</th>
          <td>{{ viewCyjdata.card || '-' }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">{{ viewCyjdata.aCardName }}（{{ viewCyjdata.aCard }}）</td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ viewCyjdata.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ viewCyjdata.nature || '银行收款' }}</td>
        </tr>
        <tr>
          <th>冲业绩名称</th>
          <td colspan="5" style="color:#000;">{{ viewCyjdata.name }}</td>
        </tr>
        <tr>
          <th>冲业绩总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewCyjdata.amount }}</td>
          <th>所剩余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewCyjdata.balance }}</td>
        </tr>
        <tr>
          <th>冲业绩凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgCyjSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgCyjSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>余额去向</th>
          <td colspan="5">{{ viewCyjdata.info || '-' }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ viewCyjdata.remark || '-' }}</td>
        </tr>
        <tr>
          <th>审核人</th>
          <td>{{ viewCyjdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewCyjdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewCyjVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="售后赔款详情"
      :visible.sync="viewAfterVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewAfterLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewAfterdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewAfterdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewAfterdata.delname }}</td>
          <th>赔款名称</th>
          <td colspan="3" style="color:#000;">{{ viewAfterdata.name }}</td>
        </tr>
        <tr>
          <th>类型</th>
          <td v-if="viewAfterdata.type===0" colspan="3" style="color:#000;">售后赔款</td>
          <td v-if="viewAfterdata.type===1" colspan="3" style="color:#000;">划帐</td>
        </tr>
        <tr>
          <th>赔款总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewAfterdata.amount }}</td>
          <th>账户余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewAfterdata.balance }}</td>
          <th>抵款方式</th>
          <td>
            <span v-if="viewAfterdata.credit===0">最高冲抵{{ viewAfterdata.maximpact }}%</span>
            <span v-if="viewAfterdata.credit===9">任意冲抵</span>
          </td>
        </tr>
        <tr>
          <th>适用订单</th>
          <td>
            <span v-if="viewAfterdata.ordertype===0">无限制</span>
            <span v-if="viewAfterdata.ordertype===1">正单</span>
            <span v-if="viewAfterdata.ordertype===2">补单</span>
          </td>
          <td colspan="4">
            订单金额满 {{ viewAfterdata.orderMoney }} 元以上可冲抵
          </td>
        </tr>
        <tr>
          <th>赔款凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgAfterSrcList"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgAfterSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewAfterdata.remark }}</td>
        </tr>
        <tr v-if="viewAfterdata.mark===2">
          <th>审核人</th>
          <td>{{ viewAfterdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewAfterdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewAfterVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="订单收款详情"
      :visible.sync="viewCollectVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewCollectLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewCollectData.operName }}</td>
          <th>申请时间</th>
          <td>{{ viewCollectData.time }}</td>
        </tr>
        <tr>
          <th>流水号</th>
          <td>{{ viewCollectData.ranum }}</td>
          <th>卡号</th>
          <td>{{ viewCollectData.card }}</td>
        </tr>
        <tr>
          <th>收款账户</th>
          <td colspan="3">{{ viewCollectData.accountname }}（{{ viewCollectData.accname }}，{{ viewCollectData.acccard }}）</td>
        </tr>
        <tr>
          <th>收款日期</th>
          <td>{{ viewCollectData.receipttime }}</td>
          <th>收款性质</th>
          <td>{{ viewCollectData.nature }}</td>
        </tr>
        <tr>
          <th>收款内容</th>
          <td>{{ viewCollectData.paycontent }}</td>
          <th>收款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewCollectData.money }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in viewCollectImg"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="viewCollectImg"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ viewCollectData.remark }}</td>
        </tr>
        <tr v-if="viewCollectData.mark===2">
          <th>审核人</th>
          <td>{{ viewCollectData.auditname }}</td>
          <th>审核时间</th>
          <td>{{ viewCollectData.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewCollectVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="售后处理"
      :visible.sync="editAfterVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editAfterForm" v-loading="editAfterLoading" :model="editAfterinfoData.afterEditForm" :rules="editAfterinfoData.editRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="订单信息" prop="orderinfo">
          <el-card shadow="hover" style="font-size: 12px;">
            <div>
              <span style="color:#99a9bf">订单号：</span>
              <span style="color:#606266">{{ editAfterinfoData.afterEditForm.ordernum }}</span>
              <span style="color:#99a9bf;margin-left: 20px">原正单号：</span>
              <span style="color:#606266">{{ editAfterinfoData.afterEditForm.productnum }}</span>
            </div>
            <div>
              <span style="color:#99a9bf">经销商：</span>
              <span style="color:#606266">{{ editAfterinfoData.afterEditForm.delname }}</span>
              <span style="color:#99a9bf;margin-left: 20px">生产车间：</span>
              <span style="color:#606266">{{ editAfterinfoData.afterEditForm.factory }}</span>
            </div>
            <div>
              <span style="color:#99a9bf">客诉反应时间：</span>
              <span style="color:#606266">{{ editAfterinfoData.afterEditForm.time }}</span>
            </div>
            <div>
              <span style="color:#99a9bf;">终端地址：</span>
              <span style="color:#606266">{{ editAfterinfoData.afterEditForm.address }}</span>
            </div>
            <div>
              <span style="color:#99a9bf;">售后/投诉内容：</span>
              <span style="color:#606266">{{ editAfterinfoData.afterEditForm.content }}</span>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item v-if="editAfterinfoData.afterEditForm.bid == 3" label="售后部处理意见" prop="afterSale">
          <div slot="label" style="display: flex; flex-direction: column; justify-content: center;">
            <span>售后部</span><span style="line-height: 4px;">处理意见</span>
          </div>
          <el-input v-model="editAfterinfoData.afterEditForm.opinions.afterSale" type="textarea" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item v-if="editAfterinfoData.afterEditForm.bid == 3" label="售后部处理意见" prop="production">
          <div slot="label" style="display: flex; flex-direction: column; justify-content: center;">
            <span>生产部</span><span style="line-height: 4px;">处理意见</span>
          </div>
          <el-input v-model="editAfterinfoData.afterEditForm.opinions.production" type="textarea" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item v-if="editAfterinfoData.afterEditForm.bid == 3" label="售后部处理意见" prop="sales">
          <div slot="label" style="display: flex; flex-direction: column; justify-content: center;">
            <span>销售部</span><span style="line-height: 4px;">处理意见</span>
          </div>
          <el-input v-model="editAfterinfoData.afterEditForm.opinions.sales" type="textarea" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item v-if="editAfterinfoData.afterEditForm.bid != 3" label="返修单" prop="reworkid">
          <SingleFile :key="editAfterinfoData.fileLoad" v-model="editAfterinfoData.afterEditForm.reworkid" :accept="'.xls,.xlsx'" :old="editAfterinfoData.oldFile" :tip="'只能上传Excel，文件上传后请导入'" />
        </el-form-item>
        <el-form-item label="判定单" prop="decisionid">
          <SingleImg :key="editAfterinfoData.imgLoad" v-model="editAfterinfoData.afterEditForm.decisionid" :oldurl="editAfterinfoData.oldImg" />
        </el-form-item>
        <!--        <el-form-item label="售后原因" prop="rson">-->
        <!--          <el-cascader disabled v-model="editAfterinfoData.afterEditForm.rson" :props="manySelect" style="width:100%" :options="editAfterinfoData.afterReasonOption" filterable clearable></el-cascader>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="责任部门" prop="depts">-->
        <!--          <el-select disabled  v-model="editAfterinfoData.afterEditForm.depts" style="width:100%" multiple placeholder="选择部门">-->
        <!--            <el-option label="设计" :value="0">设计</el-option>-->
        <!--            <el-option label="木工" :value="1">木工</el-option>-->
        <!--            <el-option label="油漆" :value="2">油漆</el-option>-->
        <!--            <el-option label="包装" :value="3">包装</el-option>-->
        <!--            <el-option label="外协" :value="4">外协</el-option>-->
        <!--            <el-option label="客户" :value="5">客户</el-option>-->
        <!--            <el-option label="其它" :value="6">其它</el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="责任车间" prop="gourpid">-->
        <!--          <el-select disabled v-model="editAfterinfoData.afterEditForm.gourpid" style="width:100%" filterable clearable>-->
        <!--            <el-option-->
        <!--              v-for="item in editAfterinfoData.groupList"-->
        <!--              :key="item.factory_id"-->
        <!--              :label="item.simple_name"-->
        <!--              :value="item.factory_id">-->
        <!--              <span style="float: left">{{ item.simple_name }}</span>-->
        <!--              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.factory_name }}</span>-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="售后赔款" prop="amount">-->
        <!--          <el-input :disabled="true" v-model="editAfterinfoData.afterEditForm.amount" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px">-->
        <!--            <template slot="append">元</template>-->
        <!--          </el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="售后备注" prop="remark">
          <el-input v-model="editAfterinfoData.afterEditForm.remark" type="textarea" maxlength="100" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="editAfterinfoData.editAfterSubLoading" size="small" @click="subAfterEdit('editAfterForm')">立即提交</el-button>
        <el-button size="small" @click="editAfterVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="订单临时折扣"
      :visible.sync="tempDiscountVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div v-if="roleInfo.jd===1&&brandPrincipal.serviceid===user.dUserid" style="height:40px">
        <span style="color:#99a9bf">共</span>
        <span style="color:#409EFF;font-weight: 500;margin: 0 3px">{{ tempDiscountData.length }}</span>
        <span style="color:#99a9bf">项</span>
        <el-button size="small" icon="el-icon-plus" type="primary" style="float: right;" @click="editTempDiscount(0)">添加临时折扣</el-button>
      </div>
      <el-table
        v-loading="tempDiscountLoading"
        :data="tempDiscountData"
        height="400"
        style="width: 100%;border:1px solid #EBEEF5;"
        size="small"
      >
        <el-table-column
          prop="name"
          label="折扣名称"
          min-width="140"
          show-overflow-tooltip
        />
        <el-table-column
          label="方式"
          width="100"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.credit===0">金额冲抵</span>
            <span v-if="scope.row.credit===1">享受折扣</span>
          </template>
        </el-table-column>
        <el-table-column
          label="折扣/金额"
          align="center"
          width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.credit===0" style="color:#409EFF;font-weight: 500;">{{ scope.row.amount }}元</span>
            <span v-if="scope.row.credit===1" style="color:#409EFF;font-weight: 500;">{{ scope.row.discount }}折</span>
          </template>
        </el-table-column>
        <el-table-column
          label="有效期"
          width="200"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.starttime==='0'">无期限</span>
            <span v-if="scope.row.starttime!=='0'">{{ scope.row.starttime }} ~ {{ scope.row.endtime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="申请人"
          width="120"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.username }}
          </template>
        </el-table-column>
        <el-table-column
          label="申请时间"
          width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.time }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="100"
          align="center"
          fixed="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini" type="warning">审核中</el-tag>
            <el-tag v-if="scope.row.mark===2" :disable-transitions="true" size="mini">未使用</el-tag>
            <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="danger">审核拒绝</el-tag>
            <el-tag v-if="scope.row.mark===9" :disable-transitions="true" size="mini" type="success">已使用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          v-if="roleInfo.jd===1&&brandPrincipal.serviceid===user.dUserid"
          align="center"
          fixed="right"
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-dropdown v-if="scope.row.mark===0||scope.row.mark===1" size="mini" split-button icon="el-icon-edit" @click="editTempDiscount(scope.row.datid)">
              <i class="el-icon-edit" /> 编辑
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item style="color:#F56C6C" @click.native="delTempDiscount(scope.row.datid)"><i class="el-icon-delete" /> 删除折扣</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-if="scope.row.mark===2||scope.row.mark===9" icon="el-icon-search" size="mini" @click="viewTempDiscount(scope.row.datid)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="editTempDiscountTitle"
      :visible.sync="editTempDiscountVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editTempDiscountForm" v-loading="infoTempDiscountLoading" :model="editTempDiscountForm" :rules="editTempDiscountRules" label-position="right" label-width="90px" size="small">
        <el-form-item v-if="editTempDiscountForm.audittime!==null&&editTempDiscountForm.audittime!==''" label="审核信息">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{ editTempDiscountForm.audittime }}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{ editTempDiscountForm.auditname }}</span>
            </div>
            <div v-if="editTempDiscountForm.auditrson!==''&&editTempDiscountForm.auditrson!==null" style="color:#606266;font-size: 13px;">
              <span style="color:#99a9bf">拒绝原因：</span>{{ editTempDiscountForm.auditrson }}
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="折扣名称" prop="name">
          <el-input v-model="editTempDiscountForm.name" maxlength="200" placeholder="请输入临时折扣名称" show-word-limit />
        </el-form-item>
        <el-form-item label="抵款方式" prop="credit">
          <el-radio-group v-model="editTempDiscountForm.credit">
            <el-radio :label="0">金额冲抵</el-radio>
            <el-radio :label="1">享受折扣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="editTempDiscountForm.credit===0" label="冲抵金额" prop="amount">
          <el-input v-model="editTempDiscountForm.amount" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item v-if="editTempDiscountForm.credit===1" label="享受折扣" prop="discount">
          <el-input v-model="editTempDiscountForm.discount" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">折</template></el-input>
        </el-form-item>
        <el-form-item label="使用期限" prop="term">
          <el-radio-group v-model="editTempDiscountForm.term">
            <el-radio :label="0">无期限</el-radio>
            <el-radio :label="1">固定期限</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="editTempDiscountForm.term===1" label="有效期" prop="time">
          <el-date-picker
            v-model="editTempDiscountForm.time"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="最低折扣" prop="mindiscount">
          <el-input v-model="editTempDiscountForm.mindiscount" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 330px"><template slot="append">折（同比享受最低折扣）</template></el-input>
        </el-form-item>
        <el-form-item label="折扣凭证" prop="imgids">
          <MultiImg :key="imgLoad" v-model="editTempDiscountForm.imgids" :limit="9" :size="'sm'" :old="editTempDiscountimgList" />
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input v-model="editTempDiscountForm.remark" type="textarea" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editTempDiscountLoading" @click="subTempDiscountEdit">立即提交</el-button>
          <el-button @click="editTempDiscountVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="临时折扣详情"
      :visible.sync="viewTempDiscountVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="infoTempDiscountLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewTempDiscountData.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewTempDiscountData.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewTempDiscountData.delname }}</td>
          <th>折扣名称</th>
          <td colspan="3" style="color:#000;">{{ viewTempDiscountData.name }}</td>
        </tr>
        <tr>
          <th>使用状态</th>
          <td>
            <el-tag v-if="viewTempDiscountData.mark===2" :disable-transitions="true" size="mini">未使用</el-tag>
            <el-tag v-if="viewTempDiscountData.mark===9" :disable-transitions="true" size="mini" type="success">已使用</el-tag>
          </td>
          <td colspan="4">
            同比享受最低折扣不低于 {{ viewTempDiscountData.mindiscount }} 折
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span v-if="viewTempDiscountData.starttime==='0'"><i class="el-icon-date" /> 无期限</span>
            <span v-if="viewTempDiscountData.starttime!=='0'"><i class="el-icon-date" /> {{ viewTempDiscountData.starttime }} ~ {{ viewTempDiscountData.endtime }}</span>
          </td>
        </tr>
        <tr>
          <th style="width: 90px">折扣/金额</th>
          <td style="color:#409EFF;font-weight: 500;">
            <span v-if="viewTempDiscountData.credit===0"><i class="el-icon-coin" /> {{ viewTempDiscountData.amount }}</span>
            <span v-if="viewTempDiscountData.credit===1">{{ viewTempDiscountData.discount }}折</span>
          </td>
          <th>抵款方式</th>
          <td colspan="3">
            <span v-if="viewTempDiscountData.credit===0">金额冲抵</span>
            <span v-if="viewTempDiscountData.credit===1">享受折扣</span>
          </td>
        </tr>
        <tr>
          <th>折扣凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgTempDiscountSrcList"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgTempDiscountSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewTempDiscountData.remark }}</td>
        </tr>
        <tr>
          <th>审核人</th>
          <td>{{ viewTempDiscountData.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewTempDiscountData.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewTempDiscountVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="更改单列表"
      :visible.sync="orderChangeVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div style="height:40px">
        <span style="color:#99a9bf">共</span>
        <span style="color:#409EFF;font-weight: 500;margin: 0 3px">{{ orderChangeData.length }}</span>
        <span style="color:#99a9bf">项</span>
        <el-button size="small" icon="el-icon-plus" type="primary" style="float: right;" @click="editOrderChange(null)">添加更改单</el-button>
      </div>
      <el-table
        v-loading="orderChangeLoading"
        :data="orderChangeData"
        height="400"
        style="width: 100%;border:1px solid #EBEEF5;"
        size="small"
      >
        <el-table-column
          prop="num"
          label="更改单号"
          width="140"
          show-overflow-tooltip
        />
        <el-table-column
          label="变更类别"
          width="100"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type===0">设计变更</span>
            <span v-if="scope.row.type===1">材质变更</span>
            <span v-if="scope.row.type===2">暂停生产</span>
            <span v-if="scope.row.type===3">取消订单</span>
            <span v-if="scope.row.type===4">颜色变更</span>
            <span v-if="scope.row.type===5">通知单</span>
            <span v-if="scope.row.type===6">其他</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否公开"
          width="100"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ispub===1" :disable-transitions="true" size="mini" type="danger">仅组织</el-tag>
            <el-tag v-if="scope.row.ispub===0" :disable-transitions="true" size="mini">公开</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="申请部门"
          width="100"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.dept===0">客户</span>
            <span v-if="scope.row.dept===1">拆单</span>
            <span v-if="scope.row.dept===2">方案</span>
            <span v-if="scope.row.dept===3">车间</span>
            <span v-if="scope.row.dept===4">采购</span>
            <span v-if="scope.row.dept===5">软件</span>
            <span v-if="scope.row.dept===6">其他</span>
            <span v-if="scope.row.dept===7">建模</span>
            <span v-if="scope.row.dept===8">研发</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          label="变更内容"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          label="申请人"
          width="120"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.initname }}
          </template>
        </el-table-column>
        <el-table-column
          label="申请时间"
          width="160"
          prop="time"
          show-overflow-tooltip
        />
        <el-table-column
          label="状态"
          width="100"
          align="center"
          fixed="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="info">未提交</el-tag>
            <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini" class="tcf-tag-4">客服确认</el-tag>
            <el-tag v-if="scope.row.mark===2" :disable-transitions="true" size="mini" class="tcf-tag-6">生产动态</el-tag>
            <el-tag v-if="scope.row.mark===3" :disable-transitions="true" size="mini" class="tcf-tag-7">设计确认</el-tag>
            <el-tag v-if="scope.row.mark===4" :disable-transitions="true" size="mini" class="tcf-tag-2">待报价</el-tag>
            <el-tag v-if="scope.row.mark===5" :disable-transitions="true" size="mini" type="warning">客户确认</el-tag>
            <el-tag v-if="scope.row.mark===6" :disable-transitions="true" size="mini" class="tcf-tag-10">PMC确认</el-tag>
            <el-tag v-if="scope.row.mark===100" :disable-transitions="true" size="mini">已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-dropdown v-if="scope.row.mark>=0&&scope.row.mark<=2&&scope.row.inittype===1&&scope.row.initid===user.dUserid" size="mini" split-button icon="el-icon-edit" @click="viewOrderChange(scope.row)">
              <i class="el-icon-search" /> 查看
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="editOrderChange(scope.row)"><i class="el-icon-edit" /> 编辑</el-dropdown-item>
                <el-dropdown-item style="color:#F56C6C" @click.native="delOrderChange(scope.row.ocid)"><i class="el-icon-delete" /> 删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-if="scope.row.mark>2||scope.row.inittype!==1||scope.row.initid!==user.dUserid" icon="el-icon-search" size="mini" @click="viewOrderChange(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="editOrderChangeTitle"
      :visible.sync="editOrderChangeVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editOrderChangeForm" :model="editOrderChangeForm" :rules="editOrderChangeRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="订单号">
          <el-input v-model="orderInfo.ordernum" :disabled="true" />
        </el-form-item>
        <el-form-item label="生产单号">
          <el-input v-model="orderInfo.produnum" :disabled="true" />
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="orderInfo.address" :disabled="true" />
        </el-form-item>
        <el-form-item label="是否公开" prop="ispub">
          <el-radio-group v-model="editOrderChangeForm.ispub">
            <el-radio :label="0">公开</el-radio>
            <el-radio :label="1">仅组织，经销商不可见</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="申请部门" prop="dept">
          <el-radio v-model="editOrderChangeForm.dept" :label="0">客户</el-radio>
          <el-radio v-model="editOrderChangeForm.dept" :label="1">拆单</el-radio>
          <el-radio v-model="editOrderChangeForm.dept" :label="2">方案</el-radio>
          <el-radio v-model="editOrderChangeForm.dept" :label="3">车间</el-radio>
          <el-radio v-model="editOrderChangeForm.dept" :label="4">采购</el-radio>
          <el-radio v-model="editOrderChangeForm.dept" :label="5">软件</el-radio>
          <el-radio v-model="editOrderChangeForm.dept" :label="7">建模</el-radio>
          <el-radio v-model="editOrderChangeForm.dept" :label="8">研发</el-radio>
          <el-radio v-model="editOrderChangeForm.dept" :label="6">其他</el-radio>
        </el-form-item>
        <el-form-item label="变更类别" prop="type">
          <el-radio v-model="editOrderChangeForm.type" :label="0">设计变更</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="1">材质变更</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="2">暂停生产</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="3">取消订单</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="4">颜色变更</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="5">通知单</el-radio>
          <el-radio v-model="editOrderChangeForm.type" :label="6">其他</el-radio>
        </el-form-item>
        <el-form-item label="变更内容" prop="content">
          <el-input v-model="editOrderChangeForm.content" type="textarea" :autosize="{ minRows: 4, maxRows: 10}" />
        </el-form-item>
        <el-form-item label="备注说明">
          <el-input v-model="editOrderChangeForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件">
          <MultiFile v-model="editOrderChangeForm.files" />
        </el-form-item>
        <el-form-item label="附属图片">
          <MultiImg v-model="editOrderChangeForm.imgids" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editOrderChangeLoading" @click="subOrderChangeEdit">立即提交</el-button>
          <el-button @click="editOrderChangeVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="viewOrderChangeTitle"
      :visible.sync="viewOrderChangeVisible"
      width="1120px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div>
        <el-button size="mini" style="margin-left: 32%;margin-bottom: 10px" icon="el-icon-printer" @click="printChangeSheet()">打印更改单</el-button>
      </div>
      <el-row v-loading="viewOrderChangeLoading">
        <el-col :span="10">
          <table class="tcf-detail-table">
            <tr>
              <th>更改单号</th>
              <td>{{ viewOrderChangeData.oc.num }}</td>
              <th>生产单号</th>
              <td>{{ viewOrderChangeData.oc.produnum }}</td>
            </tr>
            <tr>
              <th>详细地址</th>
              <td colspan="3">{{ viewOrderChangeData.oc.address }}</td>
            </tr>
            <tr>
              <th>变更类别</th>
              <td>
                <span v-if="viewOrderChangeData.oc.type===0">设计变更</span>
                <span v-if="viewOrderChangeData.oc.type===1">材质变更</span>
                <span v-if="viewOrderChangeData.oc.type===2">暂停生产</span>
                <span v-if="viewOrderChangeData.oc.type===3">取消订单</span>
                <span v-if="viewOrderChangeData.oc.type===4">颜色变更</span>
                <span v-if="viewOrderChangeData.oc.type===5">通知单</span>
                <span v-if="viewOrderChangeData.oc.type===6">其他</span>
              </td>
              <th>申请部门</th>
              <td>
                <span v-if="viewOrderChangeData.oc.dept===0">客户</span>
                <span v-if="viewOrderChangeData.oc.dept===1">拆单</span>
                <span v-if="viewOrderChangeData.oc.dept===2">方案</span>
                <span v-if="viewOrderChangeData.oc.dept===3">车间</span>
                <span v-if="viewOrderChangeData.oc.dept===4">采购</span>
                <span v-if="viewOrderChangeData.oc.dept===5">软件</span>
                <span v-if="viewOrderChangeData.oc.dept===6">其他</span>
                <span v-if="viewOrderChangeData.oc.dept===7">建模</span>
                <span v-if="viewOrderChangeData.oc.dept===8">研发</span>
              </td>
            </tr>
            <tr>
              <th>变更内容</th>
              <td colspan="3"><div class="pl">{{ viewOrderChangeData.oc.content }}</div></td>
            </tr>
            <tr>
              <th>拆单人员</th>
              <td>{{ viewOrderChangeData.oc.splitname }}</td>
              <th>生产动态</th>
              <td style="font-weight: bold;color:#f56c6c">
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===0">PMC阶段</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===1">开料完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===2">组装完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===3">贴皮完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===4">白胚完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===5">做灰完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===6">底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===7">粗磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===8">二次底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===9">细磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===10">面漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===11">包装完工</span>
              </td>
            </tr>
            <tr>
              <th>工厂</th>
              <td colspan="3">
                <span v-if="viewOrderChangeData.oc.factory===0">无</span>
                <span v-if="viewOrderChangeData.oc.factory===1">浙江乔金斯生态家居有限公司 </span>
                <span v-if="viewOrderChangeData.oc.factory===2">浙江首造智能家居有限公司</span>
              </td>
            </tr>
            <tr>
              <th>变更原因</th>
              <td colspan="3">{{ viewOrderChangeData.oc.rson }}</td>
            </tr>
            <tr>
              <th colspan="2" style="text-align: center">变更前内容</th>
              <th colspan="2" style="text-align: center">变更后内容</th>
            </tr>
            <tr>
              <td colspan="2"><div class="pl">{{ viewOrderChangeData.oc.beforetxt }}</div></td>
              <td colspan="2"><div class="pl">{{ viewOrderChangeData.oc.aftertxt }}</div></td>
            </tr>
            <tr v-if="roleInfo.money===1&&viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">
              <th>报价明细</th>
              <td colspan="3">{{ viewOrderChangeData.oc.offerdetail }}</td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.mark>4">
              <th v-if="roleInfo.money===1&&viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">报价费用</th>
              <td v-if="roleInfo.money===1&&viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4" style="font-weight: bold;color:#409EFF">{{ viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.amount:'' }}</td>
              <th>交期延长</th>
              <td :colspan="roleInfo.money===1&&viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4?1:3">{{ viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.day+'天':'' }}</td>
            </tr>
            <tr v-if="roleInfo.money===1&&viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">
              <th>费用承担</th>
              <td colspan="3">
                <span style="color:#99a9bf">拆单承担:</span>
                <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 3px">{{ viewOrderChangeData.oc.designcom }}</span>元
                <span style="color:#99a9bf;margin-left: 8px">工厂承担:</span>
                <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 3px">{{ viewOrderChangeData.oc.factorycom }}</span>元
                <span style="color:#99a9bf;margin-left: 8px">客户承担:</span>
                <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 3px">{{ viewOrderChangeData.oc.clientcom }}</span>元
                <span style="color:#99a9bf;margin-left: 8px">退款金额:</span>
                <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 3px">{{ viewOrderChangeData.oc.refund }}</span>元
              </td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.ispub===1">
              <td colspan="4" style="color:#F56C6C"><i class="el-icon-lock" /> 此更改单未公开，仅组织内部人员可见，经销商不可见</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="5">
          <el-timeline>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>0?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>0?viewOrderChangeData.oc.time:''"
            >
              提交
              <div v-if="viewOrderChangeData.oc.mark>0" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.initname }}<el-tag size="mini" :type="viewOrderChangeData.oc.inittype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.initposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>1?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>1?viewOrderChangeData.oc.sercontime:''"
            >
              客服确认
              <div v-if="viewOrderChangeData.oc.mark===1&&roleInfo.jd===1" style="margin-top: 10px">
                <el-button size="small" type="primary" @click="orderChangeOper(viewOrderChangeData.oc.ocid,1)">立即确认</el-button>
              </div>
              <div v-if="viewOrderChangeData.oc.mark>1" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.servicename }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.serviceposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>2?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>2?viewOrderChangeData.oc.pmctime:''"
            >
              生产动态
              <div v-if="viewOrderChangeData.oc.mark===2&&roleInfo.gcfp===1" style="margin-top: 10px">
                <el-button size="small" type="primary" @click="orderChangeOper(viewOrderChangeData.oc.ocid,2)">立即评估</el-button>
              </div>
              <div v-if="viewOrderChangeData.oc.mark>2" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.pmcuname }}<el-tag size="mini" type="warning" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcuposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>3?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>3?viewOrderChangeData.oc.assesstime:''"
            >
              设计确认
              <div v-if="viewOrderChangeData.oc.mark===3&&roleInfo.cd===1" style="margin-top: 10px">
                <el-button size="small" type="primary" @click="orderChangeOper(viewOrderChangeData.oc.ocid,3)">立即评估</el-button>
              </div>
              <div v-if="viewOrderChangeData.oc.mark>3" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.assessname }}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.assessposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=4||viewOrderChangeData.oc.offerid!==0"
              :type="viewOrderChangeData.oc.mark>4?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.offertime:''"
            >
              更改单报价
              <div v-if="viewOrderChangeData.oc.mark===4&&roleInfo.dbj===1" style="margin-top: 10px">
                <el-button size="small" type="primary" @click="orderChangeOper(viewOrderChangeData.oc.ocid,4)">立即报价</el-button>
              </div>
              <div v-if="viewOrderChangeData.oc.mark>4" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.offername }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.offerposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=5||viewOrderChangeData.oc.conid!==0"
              :type="viewOrderChangeData.oc.mark>5?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>5?viewOrderChangeData.oc.contime:''"
            >
              客户确认
              <div v-if="orderInfo.type!==0&&viewOrderChangeData.oc.mark===5&&roleInfo.jd===1" style="margin-top: 10px">
                <el-tooltip content="仅非正单订单可代为确认" placement="top">
                  <el-button size="small" type="primary" @click="orderChangeOper(viewOrderChangeData.oc.ocid,5)">代为确认</el-button>
                </el-tooltip>
              </div>
              <div v-if="orderInfo.type===0&&viewOrderChangeData.oc.mark===5&&roleInfo.jd===1" style="margin-top: 10px">
                <el-tooltip content="仅非正单订单可代为确认" placement="top">
                  <el-button size="small" type="primary" @click="orderChangeOper(viewOrderChangeData.oc.ocid,5)">订单驳回</el-button>
                </el-tooltip>
              </div>
              <div v-if="viewOrderChangeData.oc.mark>5" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.conname }}<el-tag size="mini" :type="viewOrderChangeData.oc.contype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.conposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>6?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.pmccontime:''"
            >
              PMC确认
              <div v-if="viewOrderChangeData.oc.mark===6&&roleInfo.gcfp===1" style="margin-top: 10px">
                <el-button size="small" type="primary" @click="orderChangeOper(viewOrderChangeData.oc.ocid,6)">立即确认</el-button>
              </div>
              <div v-if="viewOrderChangeData.oc.mark>6" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.pmcconname }}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcconposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark===100?'primary':''"
            >
              完成
            </el-timeline-item>
          </el-timeline>
        </el-col>
        <el-col :span="9" class="tcf-order-change-remark">
          <div class="title">
            <span>更改单备注</span>
            <el-button size="small" icon="el-icon-plus" @click="addOrderChangeRemark()">添加备注</el-button>
          </div>
          <div v-if="viewOrderChangeData.ocrlst.length===0" class="order-dynamic-not">
            暂无更改单备注数据
          </div>
          <div class="content-list">
            <div v-for="d in viewOrderChangeData.ocrlst" class="order-dynamic-item">
              <div class="photo">
                <el-avatar shape="square" :size="50" :src="d.photo" />
              </div>
              <div class="info">
                <div class="username"><span>{{ d.username }}</span><el-tag v-if="d.posname!==null&&d.posname!==''&&d.posname!==undefined" :type="d.color===0?'':d.color===1?'success':d.color===2?'warning':''" size="mini">{{ d.posname }}</el-tag></div>
                <div class="time"><i class="el-icon-time" /> {{ d.time }}</div>
                <div class="content">
                  <div v-if="d.ispub===1" style="color:#f56c6c;"><i class="el-icon-lock" /> 仅组织员工可见，经销商无法查看</div>
                  <el-tag v-if="d.ctype===1" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客服确认驳回</el-tag>
                  <el-tag v-if="d.ctype===2" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">生产动态驳回</el-tag>
                  <el-tag v-if="d.ctype===3" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">设计确认驳回</el-tag>
                  <el-tag v-if="d.ctype===4" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">报价驳回</el-tag>
                  <el-tag v-if="d.ctype===5" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客户确认驳回</el-tag>
                  <el-tag v-if="d.ctype===6" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">PMC确认驳回</el-tag>
                  {{ d.content }}
                </div>
                <div class="files">
                  <div v-for="f in d.filelst" class="file-item" @click="downFile(f.fileid,0)">
                    <i class="el-icon-document" />
                    <div class="file-name">{{ f.file_name }}.{{ f.file_type }}</div>
                  </div>
                </div>
                <div class="imgs">
                  <el-image
                    v-for="img in d.imglst"
                    fit="cover"
                    class="dynamic-img"
                    :src="img"
                    :preview-src-list="d.imglst"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      :title="dynamicForm.title"
      :visible.sync="orderchangeRemarkVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="orderchangeRemarkForm" :model="dynamicForm" label-position="right" label-width="90px" size="small">
        <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info" /> 温馨提示：更改单备注添加后将无法编辑/删除，请确认信息无误后再提交
        </div>
        <el-form-item label="是否公开" prop="ispub">
          <el-radio-group v-model="dynamicForm.isPub">
            <el-radio :label="0">公开</el-radio>
            <el-radio :label="1">仅组织，经销商不可见</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注内容" prop="content">
          <el-input v-model="dynamicForm.content" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile :key="dynamicForm.key" v-model="dynamicForm.files" :old="dynamicForm.oldFiles" />
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg :key="dynamicForm.key" v-model="dynamicForm.imgids" :size="'sm'" :old="dynamicForm.oldImages" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="dynamicloading" @click="SubOrderChangeRemark('orderchangeRemarkForm')">立即提交</el-button>
          <el-button @click="orderchangeRemarkVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="orderChangeOperTitle"
      :visible.sync="orderChangeOperVisible"
      width="500px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="orderChangeOperForm" :model="orderChangeOperForm" :rules="orderChangeOperRules" label-position="right" label-width="90px" size="small">
        <el-form-item v-if="orderChangeOperForm.mark===2" label="生产动态" prop="progress">
          <el-select v-model="orderChangeOperForm.progress" filterable placeholder="请选择">
            <el-option label="PMC阶段" :value="0" />
            <el-option label="开料完工" :value="1" />
            <el-option label="组装完工" :value="2" />
            <el-option label="贴皮完工" :value="3" />
            <el-option label="白胚完工" :value="4" />
            <el-option label="做灰完工" :value="5" />
            <el-option label="底漆完工" :value="6" />
            <el-option label="粗磨完工" :value="7" />
            <el-option label="二次底漆完工" :value="8" />
            <el-option label="细磨完工" :value="9" />
            <el-option label="面漆完工" :value="10" />
            <el-option label="包装完工" :value="11" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="orderChangeOperForm.mark===2" label="工厂" prop="factory">
          <el-radio-group v-model="orderChangeOperForm.factory">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">浙江乔金斯生态家居有限公司</el-radio>
            <el-radio :label="2">浙江首造智能家居有限公司</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="orderChangeOperForm.mark===3" label="变更原因" prop="rson">
          <el-input v-model="orderChangeOperForm.rson" type="textarea" />
        </el-form-item>
        <el-form-item v-if="orderChangeOperForm.mark===3" label="变更前内容" prop="beforetxt">
          <el-input v-model="orderChangeOperForm.beforetxt" type="textarea" />
        </el-form-item>
        <el-form-item v-if="orderChangeOperForm.mark===3" label="变更后内容" prop="aftertxt">
          <el-input v-model="orderChangeOperForm.aftertxt" type="textarea" />
        </el-form-item>
        <!--        <el-form-item label="提交对象" prop="subobj" v-if="orderChangeOperForm.mark===3">-->
        <!--          <el-radio-group v-model="orderChangeOperForm.subobj">-->
        <!--            <el-radio :label="0">报价</el-radio>-->
        <!--            <el-radio :label="1">PMC</el-radio>-->
        <!--          </el-radio-group>-->
        <!--          <div style="font-size: 12px;color:#9aaabf">-->
        <!--            <i class="el-icon-info"></i> 提交给<b>报价</b>，如果该更改单未公开提交后将公开给经销商可见，提交给<b>PMC</b>则直接提交给PMC确认，无需报价-->
        <!--          </div>-->
        <!--        </el-form-item>-->
        <el-form-item v-if="orderChangeOperForm.mark===4" label="报价明细" prop="offerdetail">
          <el-input v-model="orderChangeOperForm.offerdetail" type="textarea" />
        </el-form-item>
        <el-form-item v-if="orderChangeOperForm.mark===4" label="更改费用" prop="amount">
          <el-input v-model="orderChangeOperForm.amount" style="width: 200px" oninput="value=value.replace(/[^0-9.]/g,'')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="orderChangeOperForm.mark===4" label="拆单承担" prop="designcom">
          <el-input v-model="orderChangeOperForm.designcom" style="width: 200px" oninput="value=value.replace(/[^0-9.]/g,'')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="orderChangeOperForm.mark===4" label="工厂承担" prop="factorycom">
          <el-input v-model="orderChangeOperForm.factorycom" style="width: 200px" oninput="value=value.replace(/[^0-9.]/g,'')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="orderChangeOperForm.mark===4" label="客户承担" prop="clientcom">
          <el-input v-model="orderChangeOperForm.clientcom" style="width: 200px" :disabled="true">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="orderChangeOperForm.mark===4" label="退款金额" prop="refund">
          <el-input v-model="orderChangeOperForm.refund" style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="orderChangeOperForm.mark===6" label="交期延长" prop="day">
          <el-input-number v-model="orderChangeOperForm.day" :min="0" />
          <span style="color:#99a9bf;font-size:12px;margin-left: 10px">天</span>
        </el-form-item>
        <el-form-item label="备注内容" prop="remark">
          <el-input v-model="orderChangeOperForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="orderChangeOperloading" @click="subOrderChangeOperForm(1)">{{ orderChangeOperForm.mark===2?'评估完成':'立即确认' }}</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="orderChangeOperloading" @click="subOrderChangeOperForm(0)">驳回</el-button>
          <el-button @click="orderChangeOperVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 订单采购相关弹窗 -->
    <el-dialog
      title="订单采购详细"
      :visible.sync="orderProcureDialog"
      width="900px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div style="height:40px">
        <!-- <span style="color:#99a9bf;margin-left:20px;">已采购金额：</span> -->
        <!-- <span style="color: #F56C6C;font-weight: 500;">{{ offerInfo.paidfor }}</span> -->
        <el-button size="small" icon="el-icon-plus" type="primary" style="float: right;" @click="addOrderProcure">添加采购</el-button>
      </div>
      <el-table
        v-loading="orderProcureLoading"
        :data="orderProcureList"
        height="400"
        style="width: 100%;border:1px solid #EBEEF5;"
        size="small"
      >
        <el-table-column
          prop="supplier"
          label="供应商"
          align="center"
          min-width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="content"
          label="采购内容"
          width="100"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          label="采购金额"
          align="center"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span style="color:#409EFF;font-weight: 500;">{{ scope.row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="paytime"
          label="付款日期"
          align="center"
          width="120"
          show-overflow-tooltip
        />
        <el-table-column
          align="center"
          label="付款卡号"
          width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.paycard">{{ scope.row.paycard }}</span>
            <span v-else>N/A</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="收款卡号"
          width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.receivecard">{{ scope.row.receivecard }}</span>
            <span v-else>N/A</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="operName"
          label="操作人"
          align="center"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="time"
          label="操作时间"
          align="center"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column
          align="center"
          fixed="right"
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-dropdown size="mini" split-button icon="el-icon-edit" @click="seeOrderProcure(scope.row)">
              <i class="el-icon-search" /> 查看
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item @click.native="addOrderProcure(scope.row)"><i class="el-icon-edit" /> 编辑</el-dropdown-item> -->
                <el-dropdown-item style="color:#F56C6C" @click.native="delOrderProcure(scope.row)">
                  <i class="el-icon-delete" /> 删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :title="orderProcureTitle"
      :visible.sync="orderProcureFormVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="orderProcureForm" :model="orderProcureForm" :rules="orderProcureRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="供应商" prop="supplier">
          <el-select v-model="orderProcureForm.supplier" style="width: 100%;" placeholder="请选择供应商">
            <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="采购内容" prop="content">
          <el-input v-model="orderProcureForm.content" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="采购金额" prop="money">
          <el-input v-model="orderProcureForm.money" style="width: 200px" oninput="value=value.replace(/[^0-9.]/g,'')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="付款日期" prop="paytime">
          <el-date-picker
            v-model="orderProcureForm.paytime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="付款卡号" prop="paycard">
          <el-input v-model="orderProcureForm.paycard" maxlength="100" placeholder="请输入付款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="收款卡号" prop="receivecard">
          <el-input v-model="orderProcureForm.receivecard" maxlength="100" placeholder="请输入收款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="orderProcureForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile :key="orderProcureForm.key" v-model="orderProcureForm.files" :old="orderProcureForm.oldFiles" />
        </el-form-item>
        <el-form-item label="打款凭证" prop="imgids">
          <MultiImg :key="orderProcureForm.key" v-model="orderProcureForm.imgids" :size="'sm'" :old="orderProcureForm.oldImages" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="orderProcureFormLoading" @click="submitOrderProcure('orderProcureForm')">立即提交</el-button>
          <el-button @click="orderProcureFormVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="订单采购详情"
      :visible.sync="orderProcureViewVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="orderProcureViewLoading" class="tcf-detail-table">
        <tr>
          <th>操作人</th>
          <td>{{ orderProcureViewData.operName }}</td>
          <th>操作时间</th>
          <td>{{ orderProcureViewData.time }}</td>
        </tr>
        <tr>
          <th>供应商</th>
          <td colspan="3">{{ orderProcureViewData.supplier }}</td>
        </tr>
        <tr>
          <th>采购内容</th>
          <td>{{ orderProcureViewData.content }}</td>
          <th>采购金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ orderProcureViewData.money }}</td>
        </tr>
        <tr>
          <th>付款卡号</th>
          <td colspan="3">{{ orderProcureViewData.paycard }}</td>
        </tr>
        <tr>
          <th>收款卡号</th>
          <td colspan="3">{{ orderProcureViewData.receivecard }}</td>
        </tr>
        <tr>
          <th>附属文件</th>
          <td colspan="3">
            <span v-for="(file,index) in orderProcureViewData.fileList" :key="index" class="tcf-link" @click="downFile(file.fileid,0)">
              <i class="el-icon-download" /> {{ file.file_name }}
            </span>
          </td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="(iurl,index) in orderProcureViewData.imgList"
              :key="index"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="orderProcureViewData.imgList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ orderProcureViewData.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="orderProcureViewVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="packTitle"
      :visible.sync="packVisible"
      width="700px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="packForm" size="small" :inline="true" :model="packForm" label-width="60px">
        <el-form-item label="标签号" prop="packnum">
          <el-input v-model="packForm.packnum" maxlength="14" style="width: 130px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="包号" prop="xuhao">
          <el-input v-model="packForm.xuhao" type="number" style="width: 130px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" @click="searchPack(packForm)">搜索</el-button>
          <el-button icon="el-icon-printer" :loading="exportMaterialLoading" plain @click="exportExcelMaterial">导出Excel</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="packloading" style="padding-bottom: 20px">
        <el-table
          ref="packTable"
          :data="packTableData"
          :row-style="{cursor: 'pointer'}"
          class="tcf-expand"
          min-height="400"
          size="small"
          @row-click="openPackDetails"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="50"
          >
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="tcf-panel">
                <p class="tcf-panel-header">
                  <span style="color:#99a9bf"><i class="el-icon-box"></i> 包装 {{ props.row.packnum }} 部件详细</span>
                </p>
                <div class="tcf-panel-body">
                  <el-table
                    :data="props.row.materialdataList"
                    size="mini"
                    :show-header="false"
                    style="width: 100%"
                  >
                    <el-table-column prop="barCode" fixed label="条码" show-overflow-tooltip width="130"></el-table-column>
                    <el-table-column prop="xuhao" fixed label="序号" show-overflow-tooltip width="70"></el-table-column>
                    <el-table-column prop="area" label="区域" show-overflow-tooltip width="100"></el-table-column>
                    <el-table-column prop="type" label="分类" show-overflow-tooltip width="80"></el-table-column>
                    <el-table-column prop="name" label="名称" show-overflow-tooltip width="130"></el-table-column>
                    <el-table-column prop="material" label="基材" show-overflow-tooltip width="80"></el-table-column>
                    <el-table-column label="规格" show-overflow-tooltip width="140">
                      <template slot-scope="scope">
                        <span v-if="scope.row.high!=null&&scope.row.high!=''">{{ scope.row.high }}</span>
                        <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
                        <span v-if="scope.row.width!=null&&scope.row.width!=''">{{ scope.row.width }}</span>
                        <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
                        <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{ scope.row.ply }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="color" label="颜色" show-overflow-tooltip min-width="130"></el-table-column>
                  </el-table>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="packnum" align="center" label="包标签号" show-overflow-tooltip width="130"></el-table-column>
          <el-table-column prop="xuhao" align="center" label="包号" show-overflow-tooltip width="90"></el-table-column>
          <el-table-column prop="iusername" align="center" label="入库人" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column prop="itime" align="center" label="入库时间" show-overflow-tooltip min-width="130"></el-table-column>
          <el-table-column prop="num" align="center" label="部件数量" show-overflow-tooltip width="90"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      title="订单完成"
      :visible.sync="finishVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="finishForm" :model="finishForm" :rules="finishRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="finishForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="完成原因" prop="rson">
          <el-input v-model="finishForm.rson" type="textarea" show-word-limit maxlength="200"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="finishLoading" @click="subFinish('finishForm')">立即提交</el-button>
          <el-button @click="finishVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="editPackTitle"
      :visible.sync="editPackVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editPackForm" size="small" :inline="true" :model="editPackForm" label-width="60px">
        <el-form-item label="标签号" prop="packnum">
          <el-input v-model="editPackForm.packnum" maxlength="14" style="width: 130px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="包号" prop="xuhao">
          <el-input v-model="editPackForm.xuhao" type="number" style="width: 80px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" @click="searchPack(editPackForm)">搜索</el-button>
          <el-button :loading="fullscreenLoading" icon="el-icon-finished" @click="applyPackOut">申请出库</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="packloading" style="padding-bottom: 20px">
        <el-table
          :data="packTableData"
          min-height="400"
          size="small"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" fixed :selectable="checkboxT" align="center" width="50"></el-table-column>
          <el-table-column prop="packnum" fixed align="center" label="包标签号" show-overflow-tooltip min-width="130"></el-table-column>
          <el-table-column prop="xuhao" align="center" label="包号" show-overflow-tooltip width="80"></el-table-column>
          <el-table-column prop="num" align="center" label="部件数量" show-overflow-tooltip width="80"></el-table-column>
          <el-table-column align="center" fixed="right" label="入库状态" show-overflow-tooltip width="80">
            <template slot-scope="props">
              <el-tag v-if="props.row.imark===0" :disable-transitions="true" size="mini" type="danger">未入库</el-tag>
              <el-tag v-if="props.row.imark===1" :disable-transitions="true" size="mini">已入库</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed="right" label="出库状态" show-overflow-tooltip width="80">
            <template slot-scope="props">
              <el-tag v-if="props.row.omark===0" :disable-transitions="true" size="mini" type="danger">未出库</el-tag>
              <el-tag v-if="props.row.omark===2" :disable-transitions="true" size="mini" type="warning">待出库</el-tag>
              <el-tag v-if="props.row.omark===1" :disable-transitions="true" size="mini">已出库</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      title="暂停拆单"
      :visible.sync="pauseSplitVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="pauseSplitForm" :model="pauseSplitForm" :rules="pauseSplitRules" label-position="right" label-width="100px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="pauseSplitForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-alert
          style="margin-bottom: 20px;"
          title="提示"
          type="info"
          description="备注内容、凭证图片二选一填写即可"
          :closable="false"
          show-icon
        >
        </el-alert>
        <el-form-item label="备注内容" prop="content">
          <el-input v-model="pauseSplitForm.content" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item label="凭证图片" prop="imgids">
          <MultiImg v-model="pauseSplitForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item label="下一拆单订单" prop="nextOrderId" label-width="105px">
          <el-select
            v-model="pauseSplitForm.nextOrderId"
            placeholder="请选择订单，可输入关键字搜索"
            filterable
            clearable
            prefix-icon="el-icon-search"
            style="width: 100%;"
          >
            <el-option
              v-for="(item, index) in selectNextOrderList"
              :key="index"
              :value="item.order_id"
              :label="item.order_num + ' / ' + item.all_name + ' / ' + item.address"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="pauseSplitLoading" @click="subSplitPause('pauseSplitForm')">立即暂停</el-button>
          <el-button @click="pauseSplitVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="申请继续拆单"
      :visible.sync="sqjxSplitVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="sqjxSplitForm" :model="sqjxSplitForm" :rules="sqjxSplitRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="sqjxSplitForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-alert
          style="margin-bottom: 20px;"
          title="提示"
          type="info"
          description="备注内容、凭证图片二选一填写即可"
          :closable="false"
          show-icon
        >
        </el-alert>
        <el-form-item label="备注内容" prop="content">
          <el-input v-model="sqjxSplitForm.content" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile key="sqjxSplitFile" v-model="sqjxSplitForm.files" />
        </el-form-item>
        <el-form-item label="凭证图片" prop="imgids">
          <MultiImg key="sqjxSplitImg" v-model="sqjxSplitForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="sqjxSplitLoading" @click="subSplitSqjx('sqjxSplitForm')">确认申请</el-button>
          <el-button @click="sqjxSplitVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  orderSchedule,
  getReceiptNature,
  getProcessList,
  factoryOrders,
  getFactoryList,
  factoryAssign,
  getErpOrderOfferDetail,
  getDebitSMSCode,
  insteadSubsist,
  insteadSubsistDown,
  passSubsist,
  offerOrder,
  ErpOrderImportOffer,
  confirmOrder,
  splitCarryOrder,
  ErpOrderImportMaterial,
  splitOrder,
  assessOrder,
  acceptOrder,
  getOrderDetail,
  getOrderTrack,
  getOrderDynamic,
  addOrderDynamic,
  getErpOrderMaterialDetail,
  getAfterSalePageInfo,
  getOrderQuoteDetail,
  digitUppercase,
  orderCollectRecord,
  getPaycontent,
  editOrderCollectRecord,
  delOrderCollectRecord,
  getCollectRecordByCrid,
  getDealerAccountReportByDelid,
  getRebateAndReportByOrderid,
  getDealerAccountRebateById,
  getDealerAccountReportById,
  getDealerAccountAfterById,
  getFactoryPrice,
  getAfterReason,
  editAfterSaleFile,
  getQuote,
  getErpDealerAccountTempList,
  editDealerAccountTemp,
  delDealerAccountTemp,
  getErpDealerAccountTempDetail,
  getOrderChangeListByOrderid,
  delOrderChange,
  getOrderChangeDetail,
  addOrderChangeRemark,
  editOrderChange,
  operOrderChange,
  selectClientOcm,
  selectMaterialDetails,
  upReceiveTime,
  printChangeSheet,
  getMultiFactory,
  getOrderProcureList,
  saveOrderProcure,
  deleteOrderProcure,
  exportShippingList,
  getErpOrderPackList,
  getBhRsonList,
  orderOver,
  delAchievementApply,
  applyOutStock,
  getOrderList,
  doRefund
} from '@/api/erp'
import { getFileInfo, getAccounts, getGroupReport, listDictByType } from '@/api/pub'
import { editOrderInfo, getUserDetail, deleteOrderDynamic } from '@/api/work'
import { getColorBoardList } from '@/api/about/swatch'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'
import UserSelect from '@/components/UserSelect'
import SingleFile from '@/components/upload/SingleFile'
import SingleImg from '@/components/upload/SingleImg'
import OrderSelect from '@/components/OrderSelect'
import Rebate from '@/components/DealerAccount/Rebate'
import After from '@/components/DealerAccount/After'
import Report from '@/components/DealerAccount/Report'
import Achievement from '@/components/DealerAccount/Achievement'
import Project from '@/components/DealerAccount/Project'
import qs from 'qs'
import { validatePhoneNumber } from '@/utils/validate'
import { getLodop } from '@/common/Lodop/LodopFuncs'
// import { getDealerAccountData } from '@/api/dealer'

export default {
  name: 'OrderHomepage',
  components: {
    MultiFile,
    MultiImg,
    UserSelect,
    SingleFile,
    SingleImg,
    OrderSelect,
    Rebate,
    After,
    Report,
    Achievement,
    Project
  },
  data() {
    const checkPrice = (rule, value, callback) => {
      if (value !== '') {
        if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value)) {
          callback(new Error('请填写正确的价格'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const validatePhone = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    const checkDiscount = (rule, value, callback) => {
      if (!/^((0\.[1-9]{1})|(([1-9]{1})(\.\d{1})?))$/.test(value)) {
        callback(new Error('请填写正确的折扣'))
      } else {
        callback()
      }
    }
    const validateTime = (rule, value, callback) => {
      if (value !== null && value !== undefined) {
        if (value.length !== 2) {
          callback(new Error('请选择有效期'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请选择有效期'))
      }
    }
    return {
      // // 经销商账户
      // accountData: {
      //   accid: null,
      //   accountname: null,
      //   balance: 0,
      //   delid: null,
      //   groupid: 0,
      //   monthExpenses: 0,
      //   monthRevenue: 0,
      //   status: 1,
      //   totalExpenses: 0,
      //   totalRevenue: 0
      // },
      n: '', // 客供物料状态变更临时参数
      ocms: [],
      ocm: '',
      swatchs: [],
      materialDetailsTitle: '物料详情',
      materialDetailsVisible: false,
      serviceReturnVisible: false,
      serviceReturnTitle: '信息确认',
      receiveTimeTitle: '请选择日期',
      receiveTimeVisible: false,
      receiveTimeForm: {
        time: ''
      },
      receiveTimeFormRules: {
        time: [{ required: true, message: '请选择日期', trigger: 'blur' }]
      },
      serviceReturnFormRules: {
        returnTranspnum: [{ required: true, message: '请输入物流单号', trigger: 'blur' }],
        returnTranspname: [{ required: true, message: '请输入物流名称', trigger: 'blur' }],
        time: [{ required: true, message: '请选择日期', trigger: 'blur' }]
      },
      serviceReturnForm: {
        returnTranspnum: '',
        returnTranspname: '',
        time: ''
      },
      orderChangeOperTitle: '',
      orderChangeOperloading: false,
      orderChangeOperForm: {
        ocid: 0,
        mark: 0,
        remark: '',
        progress: null,
        rson: '',
        beforetxt: '',
        aftertxt: '',
        subobj: null,
        offerdetail: '',
        factory: 0,
        amount: null,
        designcom: 0.0,
        factorycom: 0.0,
        clientcom: 0.0,
        refund: 0.0,
        day: 0
      },
      orderChangeOperRules: {
        day: [{ required: true, message: '请输入延期天数', trigger: 'change' }],
        offerdetail: [{ required: true, message: '请输入报价明细', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入更改费用', trigger: 'blur' }],
        designcom: [{ required: true, message: '请输入拆单承担', trigger: 'blur' }],
        factorycom: [{ required: true, message: '请输入工厂承担', trigger: 'blur' }],
        rson: [{ required: true, message: '请输入变更原因', trigger: 'blur' }],
        beforetxt: [{ required: true, message: '请输入变更前内容', trigger: 'blur' }],
        aftertxt: [{ required: true, message: '请输入变更后内容', trigger: 'blur' }],
        subobj: [{ required: true, message: '请选择提交对象', trigger: 'change' }],
        progress: [{ required: true, message: '请选择生产动态', trigger: 'change' }],
        factory: [{ required: true, message: '请选择工厂', trigger: 'change' }],
        remark: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }]
      },
      orderChangeOperVisible: false,
      editOrderChangeTitle: '',
      editOrderChangeVisible: false,
      editOrderChangeLoading: false,
      editOrderChangeForm: {
        ocid: 0,
        ispub: 0,
        dept: 0,
        type: 0,
        content: '',
        remark: '',
        imgids: [],
        files: []
      },
      editOrderChangeRules: {
        ispub: [{ required: true, message: '请选择是否公开', trigger: 'change' }],
        dept: [{ required: true, message: '请选择申请部门', trigger: 'change' }],
        type: [{ required: true, message: '请选择变更类别', trigger: 'change' }],
        content: [{ required: true, message: '请填写订单变更内容', trigger: 'blur' }]
      },
      viewOrderChangeTitle: '',
      viewOrderChangeVisible: false,
      viewOrderChangeLoading: false,
      viewOrderChangeData: {
        oc: [],
        ocrlst: []
      },
      orderchangeRemarkVisible: false,
      editocid: 0,
      orderChangeCount: 0,
      orderChangeUndoneCount: 0,
      orderChangeVisible: false,
      orderChangeLoading: false,
      orderChangeData: [],
      imgTempDiscountSrcList: [],
      viewTempDiscountData: [],
      viewTempDiscountVisible: false,
      imgLoad: '',
      tempDiscountTurnCount: 0,
      orderCollectTrunCount: 0,
      editTempDiscountimgList: [],
      editTempDiscountForm: {
        datid: 0,
        audittime: '',
        auditname: '',
        auditrson: '',
        name: '',
        credit: 0,
        amount: null,
        discount: null,
        term: 0,
        time: [],
        mindiscount: null,
        remark: '',
        imgids: []
      },
      editTempDiscountRules: {
        name: [{ required: true, message: '请输入临时折扣名称', trigger: 'blur' }],
        credit: [{ required: true, message: '请选择抵款方式', trigger: 'change' }],
        amount: [{ required: true, message: '请输入冲抵金额', trigger: 'blur' }],
        discount: [{ required: true, message: '请输入享受折扣', trigger: 'blur' }],
        term: [{ required: true, message: '请选择使用期限', trigger: 'change' }],
        time: [{ required: true, trigger: 'change', validator: validateTime }],
        mindiscount: [{ required: true, message: '请输入最低折扣', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传折扣凭证', trigger: 'change' }]
      },
      infoTempDiscountLoading: false,
      editTempDiscountLoading: false,
      editTempDiscountTitle: '',
      editTempDiscountVisible: false,
      tempDiscountVisible: false,
      tempDiscountLoading: false,
      tempDiscountData: [],
      quoteData: [],
      quotename: '',
      quoteyear: '',
      orderquotedata: [],
      viewCollectVisible: false,
      viewCollectLoading: false,
      viewCollectData: [],
      viewCollectImg: [],
      orderid: '',
      isManual: false,
      orderLoad: '',
      fullscreenLoading: false,
      loading: false,
      allInfo: {},
      orderInfo: [],
      editOrderInfoDialog: false,
      editOldorderid: '',
      eidtOrderBtn: false,
      orderInfoCopy: {},
      editOrderReportid: [],
      orderInfoRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        type: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
        oldorderid: [{ required: true, message: '请选择原正单', trigger: 'change' }],
        custname: [{ required: true, message: '请填写客户名称', trigger: 'blur' }],
        custtel: [
          { required: true, message: '请填写客户电话', trigger: 'blur' },
          { validator: validatePhone, message: '请填写正确的电话', trigger: 'blur' }
        ],
        address: [{ required: true, message: '请填写客户地址', trigger: 'blur' }],
        nature: [{ required: true, message: '请选择订单性质', trigger: 'change' }],
        designer: [{ required: true, message: '请填写设计师姓名', trigger: 'blur' }],
        designerTel: [{ required: true, message: '请填写设计师电话', trigger: 'blur' },
          { validator: validatePhone, message: '请填写正确的电话', trigger: 'blur' }],
        source: [{ required: true, message: '选择色板来源', trigger: 'change' }],
        sids: [{ required: true, message: '请选择色板', trigger: 'change' }],
        estimated: [{ validator: checkPrice, trigger: 'blur' }],
        exptime: [{ required: true, message: '请填写交期时间', trigger: 'blur' }],
        beforenum: [{ required: true, message: '请输入原正单号', trigger: 'blur' }],
        beforeyear: [{ required: true, message: '请选择原正单年份', trigger: 'change' }]
        // fk: [{ required: true, message: '请选择是否需要收款', trigger: 'change' }],
      },
      orderMark: [],
      afterInfo: [],
      splitInfo: [],
      offerInfo: [],
      brandPrincipal: {
        serviceid: null
      },
      UpperAmount: '零元整',
      roleInfo: [],
      trackLoading: false,
      trackActivities: [],
      orderDynamic: [],
      dynamicLoading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dynamicVisible: false,
      dynamicloading: false,
      dynamicForm: {
        dynamicId: 0,
        title: '添加订单动态',
        content: '',
        files: [],
        imgids: [],
        oldImages: [],
        oldFiles: [],
        key: '',
        isPub: 0
      },
      materialTableData: [],
      materialVisible: false,
      materialloading: false,
      materialTitle: '',
      afterIVisible: false,
      fullscreenAfterLoading: false,
      manySelect: { multiple: true },
      editAfterVisible: false,
      editAfterLoading: false,
      afterinfoData: {
        rson: '',
        factory: '',
        deptRson: [],
        order: {
          ordernum: null,
          beforenum: null,
          time: null,
          all_name: null,
          address: null,
          product_factory: null
        },
        afterSale: {
          decision_url: null,
          content: null,
          reworkname: null,
          reworkid: null,
          remark: null,
          amount: null,
          opertime: null,
          username: null,
          opinions: null
        },
        opinions: {}
      },
      editAfterinfoData: {
        groupList: [],
        editAfterSubLoading: false,
        afterEditForm: {
          asid: null,
          ordernum: '',
          productnum: '',
          factory: '',
          delname: '',
          address: '',
          time: '',
          content: '',
          reworkid: '',
          decisionid: null,
          rtid: null,
          arid: null,
          gourpid: null,
          amount: null,
          rson: [],
          remark: '',
          opinions: {},
          depts: []
        },
        editRules: {
          reworkid: [{ required: false, message: '请上传返修单', trigger: 'change' }],
          decisionid: [{ required: false, message: '请上传判定单', trigger: 'change' }],
          rson: [{ required: true, message: '请选择售后原因', trigger: 'change' }],
          gourpid: [{ required: true, message: '请选择责任车间', trigger: 'change' }],
          remark: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }],
          depts: [{ required: true, message: '请选择责任部门', trigger: ['change', 'blur'] }]
        },
        afterReasonOption: [],
        oldFile: [],
        oldImg: '',
        fileLoad: '',
        imgLoad: ''
      },
      isAfterinfo: false,
      afterTitle: '',
      offerTitle: '',
      offerVisible: false,
      isOfferInfo: false,
      offerImgs: [],
      offerOther: [],
      offerChanges: [],
      offerAccountReceipt: [],
      fullscreenOfferLoading: false,
      jdVisible: false,
      jdloading: false,
      jdForm: {
        price: null,
        orderid: '',
        ordername: '',
        type: null,
        issplit: null,
        content: '',
        files: [],
        imgids: [],
        after: '',
        reportid: []
      },
      jdRules: {
        price: [{ required: true, message: '请输入预估价格', trigger: 'blur' }],
        issplit: [{ required: true, message: '请选择分配类型', trigger: 'change' }],
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        type: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }],
        after: [{ required: true, message: '请在这里填售后内容', trigger: 'blur' }]
      },
      jdReportList: [],
      jspgVisible: false,
      jspgloading: false,
      jspgForm: {
        orderid: '',
        ordername: '',
        content: '',
        files: [],
        imgids: []
      },
      jspgRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'change' }]
      },
      rsonList: [],
      cdfpVisible: false,
      cdfploading: false,
      cdfpForm: {
        orderid: '',
        ordername: '',
        splitid: null,
        content: '',
        files: [],
        imgids: []
      },
      cdfpRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        splitid: [{ required: true, message: '请选择拆单人员', trigger: 'change' }]
      },
      cdVisible: false,
      cdloading: false,
      cdForm: {
        orderid: '',
        ordername: '',
        fileid: '',
        splitFileid: '',
        content: '',
        nextOrderId: '',
        files: [],
        imgids: []
      },
      cdRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        fileid: [{ required: true, message: '请上传料单', trigger: 'change' }],
        splitFileid: [{ required: true, message: '请导入料单', trigger: 'change' }],
        nextOrderId: [{ required: false, message: '请选择下一拆单订单', trigger: 'change' }]
      },
      cdfileLoad: '',
      cdoldFile: [],
      cdimportKey: '',
      cdimportloading: false,
      cdbtnKey: '',
      cdistempFile: false,

      nextOrdersLoading: false,
      selectNextOrderList: [],
      pauseSplitVisible: false,
      pauseSplitLoading: false,
      pauseSplitForm: {
        ordername: '',
        orderid: '',
        nextOrderId: '',
        content: '',
        imgids: []
      },
      pauseSplitRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: true, message: '请输入备注或上传凭证图片', trigger: 'blur' }],
        imgids: [{ required: true, message: '请输入备注或上传凭证图片', trigger: 'change' }],
        nextOrderId: [{ required: false, message: '请选择下一拆单订单', trigger: 'change' }]
      },
      sqjxSplitVisible: false,
      sqjxSplitLoading: false,
      sqjxSplitForm: {
        ordername: '',
        orderid: '',
        content: '',
        imgids: [],
        files: []
      },
      sqjxSplitRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: true, message: '请输入备注或上传凭证图片', trigger: 'blur' }],
        imgids: [{ required: true, message: '请输入备注或上传凭证图片', trigger: 'change' }]
      },

      ddqrVisible: false,
      ddqrloading: false,
      ddqrForm: {
        orderid: '',
        ordername: '',
        content: '',
        files: [],
        imgids: []
      },
      ddqrRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }]
      },
      dbjVisible: false,
      dbjForm: {
        qid: [],
        bid: 1,
        ordertype: 0,
        ordername: '',
        fileid: '',
        offerFileid: '',
        orderid: '',
        content: '',
        imgids: [],
        pubimgids: [],
        totalprice: 0.0,
        wall: 0.0,
        cabinet: 0.0,
        access: 0.0,
        door: 0.0,
        raise: 0.0,
        discount: 0.0,
        best: 0.0,
        factorycom: 0.0,
        clientcom: 0.0,
        designcom: 0.0,
        other: 0.0,
        amount: 0.0,
        offerOther: [],
        aluminum: 0.0,
        oil: 0.0,
        tiepi: 0.0,
        paint: 0.0,
        jokins: 0.0,
        yt: 0.0,
        rebateAmount: 0.0,
        rebateSelection: [],
        bjRebateList: [],
        bjReportList: [],
        reportAmount: 0.0,
        reportSelection: [],
        bjTempList: [],
        tempAmount: 0.0,
        tempSelection: []
      },
      dbjRules: {
        qid: [{ required: true, message: '请选择报价书编码', trigger: 'change' }],
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }],
        fileid: [{ required: true, message: '请上传报价单', trigger: 'change' }],
        offerFileid: [{ required: true, message: '请解析报价单', trigger: 'change' }],
        wall: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        cabinet: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        access: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        door: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        designcom: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        factorycom: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        clientcom: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        aluminum: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        paint: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        tiepi: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        oil: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        jokins: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        yt: [{ required: true, message: '请输入金额', trigger: 'blur' }]
      },
      dbjofferOtherRules: {
        type: [{ required: true, message: '请选择费用类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入费用说明', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入费用金额', trigger: 'blur' }]
      },
      bjfjActiveNames: ['1', '3'],
      viewRebateVisible: false,
      viewRebateLoading: false,
      viewRebatedata: [],
      imgRebateSrcList: [],
      viewCyjVisible: false,
      viewCyjLoading: false,
      imgCyjSrcList: [],
      viewCyjdata: [],
      viewReportVisible: false,
      viewReportLoading: false,
      viewReportdata: [],
      imgReportSrcList: [],
      viewReportAddress: [],
      viewReportDiscount: [],
      viewReportAcccount: [],
      viewAfterVisible: false,
      viewAfterLoading: false,
      imgAfterSrcList: [],
      viewAfterdata: [],
      allMaterialData: [],
      dbjSearchForm: {
        area: [],
        type: [],
        search: '',
        areaList: [],
        typeList: []
      },
      totalMoney: null,
      totalCount: null,
      dbjistempFile: false,
      dbjoldFile: [],
      dbjfileLoad: '',
      dbjimportKey: '',
      dbjbtnKey: '',
      dbjloading: false,
      dbjimportloading: false,
      dbjUpperAmount: '零元整',
      yfkVisible: false,
      yfkloading: false,
      yfkisDisabledCode: true,
      yfkisCodeLoading: false,
      yfkcodeBtn: '获取验证码',
      yfkcodeTimer: '',
      yfksounds: 60,
      yfkForm: {
        orderid: '',
        ordername: '',
        content: '',
        offername: '',
        offertime: '',
        offerfile: '',
        offerfileid: '',
        money: null,
        dedutel: '',
        msg_id: '',
        code: '',
        accid: null,
        deposit: 0,
        accamount: 0
      },
      yfkofferinfoLoading: false,
      yfkofferinfo: [],
      yfkReportTime: {
        curStartTime: '',
        day: 0,
        hour: '00',
        min: '00',
        second: '00'
      },
      yfkRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }],
        money: [{ required: true, message: '请输入扣款金额', trigger: 'blur' }],
        dedutel: [{ required: true, message: '请选择扣款验证号码', trigger: 'change' }],
        code: [{ required: true, message: '请输入六位短信验证码', trigger: 'blur' }]
      },
      yfkDealerTelList: [],
      yfkPassVisible: false,
      yfkPassLoading: false,
      yfkPassForm: {
        orderid: '',
        ordername: '',
        time: '',
        remark: ''
      },
      yfkPassRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        remark: [{ required: false, message: '请在这里填写备注', trigger: 'blur' }],
        time: [{ required: true, message: '请选择时间', trigger: 'change' }]
      },
      yfkPassPickerOptions: {
        disabledDate: (time) => {
          const bj = this.trackActivities.filter(r => r.name === '订单报价')
          if (bj && bj.length > 0 && bj[0].time) {
            return new Date(bj[0].time).getTime() - 86400000 > time.getTime() || time.getTime() > Date.now()
          }
          return time.getTime() > Date.now()
        }
      },
      gcfpgroupList: [],
      gcfpVisible: false,
      gcfploading: false,
      gcfpForm: {
        orderid: '',
        ordername: '',
        groupid: null,
        content: '',
        files: [],
        imgids: [],
        price: null,
        discount: null
      },
      gcfpRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        groupid: [{ required: true, message: '请选择分派的工厂', trigger: 'change' }],
        price: [{ required: true, validator: checkPrice, trigger: 'change' }],
        discount: [{ required: true, validator: checkDiscount, trigger: 'change' }]
      },
      gcfpisgetgroup: false,
      gcjdVisible: false,
      gcjdloading: false,
      gcjdForm: {
        orderid: '',
        ordername: '',
        content: '',
        files: [],
        imgids: []
      },
      gcjdRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写拒接原因', trigger: 'blur' }]
      },
      ddpcVisible: false,
      ddpcloading: false,
      ddpcformLoading: false,
      ddpcForm: {
        orderid: '',
        ordername: '',
        swatch: '',
        process: [],
        mark: null
      },
      ddpcRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        swatch: [{ required: true, message: '请输入色板信息', trigger: 'blur' }]
      },
      ddpcprocessRules: {
        process_name: [{ required: true, message: '请输入工序天数', trigger: 'blur' }]
      },
      userDetail: {},
      userDetailDialog: false,
      userDetailLoading: false,
      userType: 1,
      collectRecordDialog: false,
      collectRecordLoading: false,
      collectRecord: [],
      collectTitle: '添加订单收款',
      editCollectVisible: false,
      collectInfoLoading: false,
      groupList: [],
      receiptNatureList: [],
      accountsList: [],
      imgCollectLoad: '',
      editCollectimgList: [],
      editCollectForm: {
        crid: null,
        type: 0,
        accid: null,
        paycontent: '',
        money: null,
        remark: '',
        accamount: 0,
        accname: '',
        userid: null,
        orderid: '',
        receipttime: '',
        card: '',
        accdataid: null,
        rebateInfo: [],
        afterInfo: [],
        reportInfo: [],
        achievementInfo: [],
        aid: null,
        nature: '',
        imgids: [],
        audittime: '',
        auditname: '',
        rson: '',
        // 样品预存款编号
        joinId: null,
        // 剩余样品预存款
        leftJoin: 0
      },
      editCollectRules: {
        receipttime: [{ required: true, message: '请选择收款日期', trigger: 'change' }],
        type: [{ required: true, message: '请选择收款类型', trigger: 'change' }],
        paycontent: [{ required: true, message: '请选择收款内容', trigger: 'change' }],
        money: [{ required: true, message: '请输入收款金额', trigger: 'blur' }],
        accdataid: [{ required: true, message: '请选择账户', trigger: 'change' }],
        aid: [{ required: true, message: '请选择收款账户', trigger: 'change' }],
        nature: [{ required: true, message: '请选择收款性质', trigger: 'change' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }],
        card: [{ required: true, message: '请输入卡号', trigger: 'blur' }]
      },
      refundApplyVisible: false,
      refundApplyLoading: false,
      refundApplyImgList: [],
      refundApplyImgKey: '',
      refundApplyForm: {},
      refundApplyRules: {
        receipttime: [{ required: true, message: '请选择退款日期', trigger: 'change' }],
        money: [{ required: true, message: '请输入退款金额', trigger: 'blur' }],
        imgids: [{ required: false, message: '请上传退款凭证', trigger: 'change' }],
      },
      paycontentList: [],
      editCollectloading: false,
      factoryid: this.$route.query.data,
      isMultiFactory: false,
      multiGroupList: [],
      selectFactory: '',

      orderProcureDialog: false,
      orderProcureLoading: false,
      orderProcureList: [],
      orderProcureViewVisible: false,
      orderProcureViewLoading: false,
      orderProcureViewData: {},
      orderProcureTitle: '添加订单采购',
      orderProcureFileList: [],
      imgOrderProcureLoad: '',
      orderProcureImgList: [],
      orderProcureFormVisible: false,
      orderProcureForm: {},
      orderProcureFormLoading: false,
      orderProcureRules: {
        supplier: [{ required: true, message: '请选择供应商', trigger: 'change' }],
        content: [{ required: true, message: '请输入采购内容', trigger: 'blur' }],
        money: [{ required: true, message: '请输入采购金额', trigger: 'blur' }],
        paytime: [{ required: true, message: '请选择付款日期', trigger: 'change' }],
        paycard: [{ required: true, message: '请输入付款卡号', trigger: 'blur' }],
        receivecard: [{ required: true, message: '请输入收款卡号', trigger: 'blur' }]
      },
      supplierList: [],

      exportMaterialLoading: false,
      multipleSelection: [],
      packTitle: '',
      packVisible: false,
      editLoading: false,
      packForm: {
        orderid: '',
        packnum: '',
        xuhao: ''
      },
      packTableData: [],
      packloading: false,

      editPackTitle: '',
      editPackVisible: false,
      editPackForm: {
        orderid: '',
        packnum: '',
        xuhao: ''
      },

      finishVisible: false,
      finishLoading: false,
      finishForm: {
        orderid: '',
        ordername: '',
        rson: ''
      },
      finishRules: {
        rson: [{ required: true, message: '请输入完成原因', trigger: 'blur' }]
      },

      cbList: [],
      cbLoading: false
    }
  },
  computed: {
    user: getUser,
    pickerYear() {
      return {
        disabledDate(time) {
          return time.getTime() >= Date.now()
        }
      }
    }
  },
  watch: {
    'dbjForm.fileid': function(newVal) {
      if (!this.dbjistempFile) {
        if (newVal === null || newVal === '' || newVal === undefined) {
          if (this.dbjForm.offerFileid !== null && this.dbjForm.offerFileid !== '' && this.dbjForm.offerFileid !== undefined) {
            this.dbjForm.offerFileid = ''
          }
        }
      } else {
        this.dbjistempFile = false
      }
    },
    'dbjForm.wall': function(newVal) {
      this.dbjcountAmount()
    },
    'dbjForm.cabinet': function(newVal) {
      this.dbjcountAmount()
    },
    'dbjForm.access': function(newVal) {
      this.dbjcountAmount()
    },
    'dbjForm.door': function(newVal) {
      this.dbjcountAmount()
    },
    'dbjForm.aluminum': function(newVal) {
      this.dbjcountAmount()
    },
    'dbjForm.raise': function(newVal) {
      this.dbjcountAmount()
    },
    'dbjForm.best': function(newVal) {
      this.dbjcountAmount()
    },
    // 'dbjForm.discount': function(newVal) {
    //   this.dbjcountAmount()
    // },
    'dbjForm.other': function(newVal) {
      this.dbjcountAmount()
    },
    'dbjForm.totalprice': function(newVal) {
      this.dbjbearAmount()
    },
    'dbjForm.amount': function(newVal) {
      this.dbjbearAmount()
    },
    'dbjForm.factorycom': function(newVal) {
      this.dbjbearAmount()
    },
    'dbjForm.designcom': function(newVal) {
      this.dbjbearAmount()
    },
    'dbjForm.clientcom': function(newVal) {
      this.dbjbearAmount()
    },
    'dbjForm.offerOther': {
      handler(newValue, oldValue) {
        this.dbjotherAmount()
      },
      deep: true
    },
    'dbjForm.bjRebateList': {
      handler(newValue, oldValue) {
        this.rebateAmount()
      },
      deep: true
    },
    'dbjForm.bjReportList': {
      handler(newValue, oldValue) {
        this.reportAmount()
      },
      deep: true
    },
    'dbjForm.bjTempList': {
      handler(newValue, oldValue) {
        this.tempAmount()
      },
      deep: true
    },
    'yfkForm.dedutel': function(newVal) {
      if (newVal !== null && newVal !== '' && newVal !== undefined) {
        if (this.yfksounds === 60) {
          this.yfkisDisabledCode = false
        }
      } else {
        this.yfkisDisabledCode = true
      }
    },
    'editCollectForm.type': function(newVal) {
      this.editCollectForm.accdataid = null
      if (newVal !== 5) {
        this.editCollectForm.rebateInfo = []
      }
      if (newVal !== 6) {
        this.editCollectForm.afterInfo = []
      }
      if (newVal !== 7) {
        this.editCollectForm.reportInfo = []
      }
      if (newVal !== 9) {
        this.editCollectForm.achievementInfo = []
      }
    },
    'orderChangeOperForm.designcom': function(newVal) {
      this.compAmount()
    },
    'orderChangeOperForm.factorycom': function(newVal) {
      this.compAmount()
    },
    'orderChangeOperForm.amount': function(newVal) {
      this.compAmount()
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.orderid = this.$route.params && this.$route.params.id
    this.getOrder()
    this.getQuoteList()
    this.getTempDiscountTurnCount()
    this.getClientocm()
  },
  methods: {
    tranfromSec(seconds) {
      if (!seconds || seconds <= 0) return '--'
      const d = parseInt(seconds / 60 / 60 / 24)
      const h = parseInt(seconds / 60 / 60 % 24)
      const m = parseInt(seconds / 60 % 60)
      const s = parseInt(seconds % 60)
      return (d > 0 ? d + '天' : '') + (h > 0 ? h + '小时' : '') + (m > 0 ? m + '分' : '') + s + '秒'
    },
    changeradio() {
      // 不包含厂部色板
      if (this.orderInfoCopy.source.indexOf(0) === -1) {
        this.orderInfoCopy.sids = []
      }
    },
    getCbList(query = '') {
      this.cbList = []
      this.cbLoading = true
      getColorBoardList({
        page: 1,
        limit: 9999,
        content: query,
        brandid: this.orderInfoCopy.bid,
        seriesid: ''
      }).then(response => {
        this.cbList = response.data || []
        this.cbLoading = false
      }).catch(() => {
        this.cbList = []
        this.cbLoading = false
      })
    },
    getMultiFactory() {
      if (this.isMultiFactory) {
        getMultiFactory({ orderid: this.orderid }).then(response => {
          this.multiGroupList = response.data.multiGroupList
          this.multiGroupList.forEach(a => {
            if (a.dGroupid + '' === this.factoryid + '') {
              this.selectFactory = a.dAbbname
            }
          })
        }).catch(() => {
          this.loading = false
        })
      }
    },
    changeFactory() {
      this.factoryid = this.selectFactory
      this.getOrder()
    },
    serviceReturn(n) {
      this.serviceReturnVisible = true
      this.n = n
      this.serviceReturnTitle = n === 0 ? '物料发货' : '信息确认'
    },
    compAmount() {
      const amount = parseFloat(this.orderChangeOperForm.amount)
      let designcom = 0.0
      let factorycom = 0.0
      let clientcom = 0.0
      if (this.orderChangeOperForm.designcom !== null && this.orderChangeOperForm.designcom !== '' && this.orderChangeOperForm.designcom !== undefined) {
        if (parseFloat(this.orderChangeOperForm.designcom) >= 0) {
          designcom = parseFloat(this.orderChangeOperForm.designcom)
        }
      }
      if (this.orderChangeOperForm.factorycom !== null && this.orderChangeOperForm.factorycom !== '' && this.orderChangeOperForm.factorycom !== undefined) {
        if (parseFloat(this.orderChangeOperForm.factorycom) >= 0) {
          factorycom = parseFloat(this.orderChangeOperForm.factorycom)
        }
      }
      if (this.orderChangeOperForm.clientcom !== null && this.orderChangeOperForm.clientcom !== '' && this.orderChangeOperForm.clientcom !== undefined) {
        if (parseFloat(this.orderChangeOperForm.clientcom) >= 0) {
          clientcom = parseFloat(this.orderChangeOperForm.clientcom)
        }
      }
      if (factorycom < 0) {
        factorycom = 0
      }
      if (designcom < 0) {
        designcom = 0
      }
      clientcom = amount - factorycom - designcom
      if (clientcom < 0 || amount === null) {
        clientcom = 0
      }
      if (amount < designcom + factorycom) {
        this.orderChangeOperForm.designcom = 0
        this.orderChangeOperForm.factorycom = 0
        this.orderChangeOperForm.clientcom = 0
      } else {
        this.orderChangeOperForm.designcom = designcom
        this.orderChangeOperForm.factorycom = factorycom
        this.orderChangeOperForm.clientcom = clientcom.toFixed(2)
      }
    },
    serviceReturnSubmit(ocm) {
      this.$refs['serviceReturnForm'].validate((valid) => {
        if (valid) {
          this.employeesReceive(ocm)
          this.serviceReturnVisible = false
        }
      })
    },
    employeesReceive(ocm) {
      const data = {
        cmid: ocm.cmid,
        userid: this.user.dUserid,
        returnTranspnum: this.serviceReturnForm.returnTranspnum,
        returnTranspname: this.serviceReturnForm.returnTranspname,
        time: this.serviceReturnForm.time,
        n: this.n
      }
      upReceiveTime(data).then(response => {
        this.$message({
          message: this.n === 0 ? '提交成功' : '确认完成',
          type: 'success'
        })
        this.getClientocm()
        this.materialDetails(ocm)
        this.serviceReturnForm.returnTranspnum = ''
        this.serviceReturnForm.returnTranspname = ''
        this.serviceReturnForm.time = ''
      })
    },
    materialDetails(row) {
      this.materialDetailsVisible = true
      this.viewOrderChangeLoading = true
      const data = {
        cmid: row.cmid
      }
      selectMaterialDetails(data).then(response => {
        this.ocm = response.data
        this.viewOrderChangeLoading = false
      }).catch(() => {
        this.viewOrderChangeLoading = false
      })
    },
    getClientocm() {
      const data = {
        orderid: this.orderid
      }
      selectClientOcm(data).then(response => {
        this.ocms = response.data
      })
    },
    // 上面是我写的
    orderChangeOper(ocid, mark) {
      this.orderChangeOperForm.ocid = ocid
      this.orderChangeOperForm.mark = mark
      this.orderChangeOperForm.remark = ''
      this.orderChangeOperForm.progress = null
      this.orderChangeOperForm.factory = 0
      this.orderChangeOperForm.rson = ''
      this.orderChangeOperForm.beforetxt = ''
      this.orderChangeOperForm.aftertxt = ''
      this.orderChangeOperForm.subobj = null
      this.orderChangeOperForm.offerdetail = ''
      this.orderChangeOperForm.amount = null
      this.orderChangeOperForm.factorycom = 0.0
      this.orderChangeOperForm.clientcom = 0.0
      this.orderChangeOperForm.designcom = 0.0
      this.orderChangeOperForm.refund = 0.0
      this.orderChangeOperForm.day = 0
      if (mark === 1) {
        this.orderChangeOperTitle = '客服确认-更改单'
      } else if (mark === 2) {
        this.orderChangeOperTitle = '生产动态-更改单'
      } else if (mark === 3) {
        this.orderChangeOperTitle = '设计确认-更改单'
      } else if (mark === 4) {
        this.orderChangeOperTitle = '更改单报价-更改单'
      } else if (mark === 5) {
        this.orderChangeOperTitle = '代为确认-更改单'
      } else if (mark === 6) {
        this.orderChangeOperTitle = 'PMC确认-更改单'
      }
      this.orderChangeOperRules.remark[0].required = false
      this.orderChangeOperVisible = true
    },
    subOrderChangeOperForm(n) {
      if (!this.orderChangeOperloading) {
        if (n === 0) {
          this.orderChangeOperRules.remark[0].required = true
          if (this.orderChangeOperForm.mark === 2) {
            this.orderChangeOperRules.progress[0].required = false
          } else if (this.orderChangeOperForm.mark === 3) {
            this.orderChangeOperRules.rson[0].required = false
            this.orderChangeOperRules.beforetxt[0].required = false
            this.orderChangeOperRules.aftertxt[0].required = false
            this.orderChangeOperRules.subobj[0].required = false
          } else if (this.orderChangeOperForm.mark === 4) {
            this.orderChangeOperRules.offerdetail[0].required = false
            this.orderChangeOperRules.amount[0].required = false
          } else if (this.orderChangeOperForm.mark === 6) {
            this.orderChangeOperRules.day[0].required = false
          }
        } else {
          this.orderChangeOperRules.remark[0].required = false
          if (this.orderChangeOperForm.mark === 2) {
            this.orderChangeOperRules.progress[0].required = true
          } else if (this.orderChangeOperForm.mark === 3) {
            this.orderChangeOperRules.rson[0].required = true
            this.orderChangeOperRules.beforetxt[0].required = true
            this.orderChangeOperRules.aftertxt[0].required = true
            this.orderChangeOperRules.subobj[0].required = true
            this.orderChangeOperForm.subobj = 0
          } else if (this.orderChangeOperForm.mark === 4) {
            this.orderChangeOperRules.offerdetail[0].required = true
            this.orderChangeOperRules.amount[0].required = true
          } else if (this.orderChangeOperForm.mark === 6) {
            this.orderChangeOperRules.day[0].required = true
          }
        }
        this.$refs[`orderChangeOperForm`].validate((valid) => {
          if (valid) {
            this.orderChangeOperloading = true
            let data = {}
            if (this.orderChangeOperForm.mark === 4) {
              data = {
                userid: this.user.dUserid,
                role: 1,
                ocid: this.orderChangeOperForm.ocid,
                type: n,
                mark: this.orderChangeOperForm.mark,
                remark: this.orderChangeOperForm.remark,
                progress: this.orderChangeOperForm.progress,
                rson: this.orderChangeOperForm.rson,
                beforetxt: this.orderChangeOperForm.beforetxt,
                aftertxt: this.orderChangeOperForm.aftertxt,
                subobj: this.orderChangeOperForm.subobj,
                offerdetail: this.orderChangeOperForm.offerdetail,
                amount: this.orderChangeOperForm.amount,
                factorycom: this.orderChangeOperForm.factorycom,
                clientcom: this.orderChangeOperForm.clientcom,
                designcom: this.orderChangeOperForm.designcom,
                refund: this.orderChangeOperForm.refund,
                day: this.orderChangeOperForm.day
              }
            } else {
              data = {
                userid: this.user.dUserid,
                role: 1,
                ocid: this.orderChangeOperForm.ocid,
                type: n,
                mark: this.orderChangeOperForm.mark,
                remark: this.orderChangeOperForm.remark,
                progress: this.orderChangeOperForm.progress,
                factory: this.orderChangeOperForm.factory,
                rson: this.orderChangeOperForm.rson,
                beforetxt: this.orderChangeOperForm.beforetxt,
                aftertxt: this.orderChangeOperForm.aftertxt,
                subobj: this.orderChangeOperForm.subobj,
                offerdetail: this.orderChangeOperForm.offerdetail,
                amount: this.orderChangeOperForm.amount,
                day: this.orderChangeOperForm.day
              }
            }
            operOrderChange(data).then(response => {
              this.$message({
                message: '更改单操作成功',
                type: 'success'
              })
              this.orderChangeOperloading = false
              this.orderChangeOperVisible = false
              this.viewOrderChange({ ocid: this.orderChangeOperForm.ocid })
              this.openChangeList()
            }).catch(() => {
              this.orderChangeOperloading = false
            })
          } else {
            return false
          }
        })
      }
    },
    addOrderChangeRemark() {
      this.dynamicForm.content = ''
      this.dynamicForm.isPub = 0
      this.dynamicForm.files = []
      this.dynamicForm.imgids = []
      this.dynamicForm.oldFiles = []
      this.dynamicForm.oldImages = []
      this.dynamicForm.title = '添加更改单备注'
      this.dynamicForm.dynamicId = 0
      this.dynamicForm.key = new Date().getTime().toString()
      this.orderchangeRemarkVisible = true
    },
    SubOrderChangeRemark(formName) {
      if (!this.dynamicloading) {
        this.dynamicloading = true
        const data = {
          userid: this.user.dUserid,
          ocid: this.editocid,
          content: this.dynamicForm.content,
          fileStr: this.dynamicForm.files.join(','),
          imgStr: this.dynamicForm.imgids.join(','),
          type: 1,
          ocrid: this.dynamicForm.dynamicId,
          isPub: this.dynamicForm.isPub
        }
        addOrderChangeRemark(data).then(response => {
          this.$message({
            message: '更改单备注添加成功',
            type: 'success'
          })
          this.dynamicloading = false
          this.orderchangeRemarkVisible = false
          this.viewOrderChange({ ocid: this.editocid })
        }).catch(() => {
          this.dynamicloading = false
        })
      } else {
        return false
      }
    },
    subOrderChangeEdit() {
      this.$refs['editOrderChangeForm'].validate((valid) => {
        if (valid && !this.editOrderChangeLoading) {
          this.editOrderChangeLoading = true
          const data = {
            userid: this.user.dUserid,
            role: 1,
            ocid: this.editOrderChangeForm.ocid,
            ispub: this.editOrderChangeForm.ispub,
            orderid: this.editOrderChangeForm.orderid,
            dept: this.editOrderChangeForm.dept,
            type: this.editOrderChangeForm.type,
            content: this.editOrderChangeForm.content,
            remark: this.editOrderChangeForm.remark,
            imgids: this.editOrderChangeForm.imgids.join(','),
            files: this.editOrderChangeForm.files.join(','),
            factoryid: this.factoryid
          }
          editOrderChange(data).then(response => {
            this.$message({
              message: '更改单提交成功',
              type: 'success'
            })
            this.editOrderChangeVisible = false
            this.editOrderChangeLoading = false
            this.openChangeList()
          }).catch(() => {
            this.editOrderChangeLoading = false
          })
        } else {
          return false
        }
      })
    },
    editOrderChange(row) {
      this.editOrderChangeForm.remark = ''
      this.editOrderChangeForm.imgids = []
      this.editOrderChangeForm.files = []
      if (row !== null) {
        this.editOrderChangeTitle = '编辑更改单'
        this.editOrderChangeForm.ocid = row.ocid
        this.editOrderChangeForm.ispub = row.ispub
        this.editOrderChangeForm.dept = row.dept
        this.editOrderChangeForm.orderid = row.orderid
        this.editOrderChangeForm.content = row.content
        this.editOrderChangeForm.type = row.type
      } else {
        this.editOrderChangeTitle = '添加更改单'
        this.editOrderChangeForm.ocid = 0
        this.editOrderChangeForm.ispub = 0
        this.editOrderChangeForm.dept = 0
        this.editOrderChangeForm.orderid = this.orderid
        this.editOrderChangeForm.type = 0
        this.editOrderChangeForm.content = ''
      }
      this.editOrderChangeVisible = true
    },
    delOrderChange(ocid) {
      this.$confirm('删除此更改单申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.orderChangeLoading = true
        delOrderChange({ ocid: ocid }).then(response => {
          this.orderChangeLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.openChangeList()
        }).catch(() => {
          this.orderChangeLoading = false
        })
      }).catch(() => {})
    },
    openChangeList() {
      if (!this.orderChangeVisible) {
        this.orderChangeVisible = true
      }
      this.orderChangeLoading = true
      getOrderChangeListByOrderid({ orderid: this.orderid, role: 1 }).then(response => {
        this.orderChangeData = response.data
        this.orderChangeCount = this.orderChangeData.length
        this.orderChangeLoading = false
      }).catch(() => {
        this.orderChangeLoading = false
      })
    },
    viewOrderChange(row) {
      if (!this.viewOrderChangeVisible) {
        this.viewOrderChangeTitle = `更改单 ${row.num} 详情`
        this.viewOrderChangeVisible = true
      }
      this.viewOrderChangeLoading = true
      this.editocid = row.ocid
      getOrderChangeDetail({ ocid: row.ocid, role: 1 }).then(response => {
        this.viewOrderChangeLoading = false
        this.viewOrderChangeData = response.data
      }).catch(() => {
        this.viewOrderChangeLoading = false
      })
    },
    printChangeSheet() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        const printLoading = this.$loading({
          lock: true,
          text: '更改单正在打印，请勿关闭此页面',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        const data = {
          ocid: this.editocid,
          userid: this.user.dUserid,
          role: this.user.role,
          groupid: this.user.dGroupid
        }
        printChangeSheet(data).then(response => {
          LODOP.PRINT_INIT('更改单打印')
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
          LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
          LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', response.data)
          LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
          LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
          LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
          LODOP.NewPageA()
          LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
          LODOP.PREVIEW()
          printLoading.close()
        }).catch(() => {
          printLoading.close()
        })
      }
    },
    getTempDiscountTurnCount() {
      this.tempDiscountTurnCount = 0
      getErpDealerAccountTempList({ orderid: this.orderid }).then(response => {
        let count = 0
        for (const td of response.data) {
          if (td.mark === 0) {
            count++
          }
        }
        this.tempDiscountTurnCount = count
      })
    },
    subTempDiscountEdit() {
      this.$refs['editTempDiscountForm'].validate((valid) => {
        if (valid) {
          if (!this.editTempDiscountLoading) {
            this.editTempDiscountLoading = true
            let starttime = '0'
            let endtime = '0'
            if (this.editTempDiscountForm.term === 1) {
              starttime = this.editTempDiscountForm.time[0]
              endtime = this.editTempDiscountForm.time[1]
            }
            const data = {
              userid: this.user.dUserid,
              datid: this.editTempDiscountForm.datid,
              orderid: this.orderid,
              name: this.editTempDiscountForm.name,
              credit: this.editTempDiscountForm.credit,
              amount: this.editTempDiscountForm.amount,
              discount: this.editTempDiscountForm.discount,
              starttime: starttime,
              endtime: endtime,
              mindiscount: this.editTempDiscountForm.mindiscount,
              remark: this.editTempDiscountForm.remark,
              imgStr: this.editTempDiscountForm.imgids.join(',')
            }
            editDealerAccountTemp(data).then(response => {
              this.$message({
                message: '临时折扣提交成功',
                type: 'success'
              })
              this.editTempDiscountVisible = false
              this.editTempDiscountLoading = false
              this.editimgList = []
              this.tempDiscount()
            }).catch(() => {
              this.editTempDiscountLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    editTempDiscount(datid) {
      if (datid === 0) {
        this.editTempDiscountTitle = '添加订单临时折扣'
        this.editTempDiscountForm.datid = 0
        this.editTempDiscountForm.audittime = ''
        this.editTempDiscountForm.auditname = ''
        this.editTempDiscountForm.auditrson = ''
        this.editTempDiscountForm.name = ''
        this.editTempDiscountForm.credit = 0
        this.editTempDiscountForm.amount = null
        this.editTempDiscountForm.discount = null
        this.editTempDiscountForm.term = 0
        this.editTempDiscountForm.time = []
        this.editTempDiscountForm.mindiscount = null
        this.editTempDiscountForm.remark = ''
        this.editTempDiscountForm.imgids = []
        this.editTempDiscountimgList = []
        this.imgLoad = new Date().getTime()
        this.editTempDiscountVisible = true
      } else {
        this.editTempDiscountTitle = '编辑订单临时折扣'
        this.editTempDiscountVisible = true
        this.infoTempDiscountLoading = true
        getErpDealerAccountTempDetail({ datid: datid }).then(response => {
          this.infoTempDiscountLoading = false
          const d = response.data
          this.editTempDiscountForm.datid = d.datid
          this.editTempDiscountForm.audittime = d.audittime
          this.editTempDiscountForm.auditname = d.auditname
          this.editTempDiscountForm.auditrson = d.rson
          this.editTempDiscountForm.name = d.name
          this.editTempDiscountForm.credit = d.credit
          this.editTempDiscountForm.amount = d.amount
          this.editTempDiscountForm.discount = d.discount
          if (d.starttime !== '0') {
            this.editTempDiscountForm.term = 1
            this.editTempDiscountForm.time = []
            this.editTempDiscountForm.time.push(d.starttime)
            this.editTempDiscountForm.time.push(d.endtime)
          } else {
            this.editTempDiscountForm.term = 0
            this.editTempDiscountForm.time = []
          }
          this.editTempDiscountForm.mindiscount = d.mindiscount
          this.editTempDiscountForm.remark = d.remark
          const oldimgList = []
          for (const img of d.imglst) {
            oldimgList.push({ id: img.imgid, url: img.imgurl })
          }
          this.editTempDiscountimgList = oldimgList
          this.imgLoad = new Date().getTime()
        }).catch(() => {
          this.infoTempDiscountLoading = false
        })
      }
    },
    delTempDiscount(datid) {
      this.$confirm('删除此临时折扣申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tempDiscountLoading = true
        delDealerAccountTemp({ datid: datid }).then(response => {
          this.tempDiscountLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.tempDiscount()
        }).catch(() => {
          this.tempDiscountLoading = false
        })
      }).catch(() => {})
    },
    viewTempDiscount(datid) {
      this.imgTempDiscountSrcList = []
      this.viewTempDiscountVisible = true
      this.infoTempDiscountLoading = true
      getErpDealerAccountTempDetail({ datid: datid }).then(response => {
        this.infoTempDiscountLoading = false
        this.viewTempDiscountData = response.data
        const imgs = []
        for (const c of response.data.imglst) {
          imgs.push(c.imgurl)
        }
        this.imgTempDiscountSrcList = imgs
      }).catch(() => {
        this.infoTempDiscountLoading = false
      })
    },
    tempDiscount() {
      if (!this.tempDiscountVisible) {
        this.tempDiscountVisible = true
      }
      this.tempDiscountLoading = true
      getErpDealerAccountTempList({ orderid: this.orderid }).then(response => {
        this.tempDiscountData = response.data
        let count = 0
        for (const td of this.tempDiscountData) {
          if (td.mark === 0) {
            count++
          }
        }
        this.tempDiscountTurnCount = count
        this.tempDiscountLoading = false
      }).catch(() => {
        this.tempDiscountLoading = false
      })
    },
    goToDyAndTm(n) {
      if (n === 0) {
        this.$router.push({ path: '/work/category_print/' + this.orderid })
      } else if (n === 1) {
        this.$router.push({ path: '/work/parts_detail/' + this.orderid })
      } else if (n === 2) {
        this.$router.push({ path: '/work/accessories/' + this.orderid })
      } else if (n === 3) {
        this.$router.push({ path: '/work/production_bill_change/' + this.orderid })
      }
    },
    getQuoteList() {
      getQuote({ page: 1, limit: 99999 }).then(response => {
        this.quoteData = response.data
      })
    },
    changeType(val) {
      if (val === 3) {
        this.orderInfoRules.oldorderid[0].required = false
        this.orderInfoRules.beforenum[0].required = false
        this.orderInfoRules.beforeyear[0].required = false
      } else {
        this.orderInfoRules.oldorderid[0].required = true
        this.orderInfoRules.beforenum[0].required = true
        this.orderInfoRules.beforeyear[0].required = true
      }
    },
    setRebate(data) {
      if (data !== null) {
        this.editCollectForm.rebateInfo = data
        // if (this.editCollectForm.remark === null || this.editCollectForm.remark === '' || this.editCollectForm.remark === undefined) {
        //   this.editCollectForm.remark = data.name
        // }
      } else {
        this.editCollectForm.rebateInfo = []
      }
    },
    setAfter(data) {
      if (data !== null) {
        this.editCollectForm.afterInfo = data
      } else {
        this.editCollectForm.afterInfo = []
      }
    },
    setReport(data) {
      if (data !== null) {
        this.editCollectForm.reportInfo = data
      } else {
        this.editCollectForm.reportInfo = []
      }
    },
    setAchievement(data) {
      if (data !== null) {
        this.editCollectForm.achievementInfo = data
      } else {
        this.editCollectForm.achievementInfo = []
      }
    },
    setProject(data) {
      if (data !== null) {
        this.editCollectForm.projectInfo = data
      } else {
        this.editCollectForm.projectInfo = []
      }
    },
    setOrder(data) {
      if (data.bid === 3) {
        this.orderInfoCopy.beforenum = data.ordernum
      } else {
        this.orderInfoCopy.beforenum = data.produnum
      }
      this.orderInfoCopy.beforeyear = data.time.substring(0, 4)
    },
    openManual() {
      this.editOldorderid = ''
      this.orderInfoCopy.oldorderid = ''
      this.orderInfoCopy.beforenum = ''
      this.orderInfoCopy.beforeyear = ''
      this.isManual = true
    },
    viewCad(fileid) {
      this.$router.push({ path: '/work/cadView/' + fileid })
    },
    downFile(fileid, n) {
      let product = ''
      if (n === 1) {
        product = this.orderInfo.produnum
      }
      getFileInfo({ fileid: fileid, productNum: product }).then(response => {
        /* this.$message({
          message: '已下载 ' + response.data.dName + '.' + response.data.dType,
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = this.orderInfo.ordernum + '_' + response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        let download = `${response.data.dName}.${response.data.dType}`
        if (n === 1) {
          download = `${product}_${response.data.dName}.${response.data.dType}`
        }
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: download,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    getOrder() {
      this.loading = true
      getOrderDetail({ orderid: this.orderid, userid: this.user.dUserid, factoryid: this.factoryid }).then(response => {
        this.allInfo = response.data || {}
        this.orderInfo = response.data.orderDetail
        if (this.orderInfo) this.orderInfo.pf = response.data.pf
        this.isMultiFactory = response.data.orderDetail.ismultifactory === 1
        if (response.data.orderCollectTrunCount !== null && response.data.orderCollectTrunCount !== undefined) {
          this.orderCollectTrunCount = response.data.orderCollectTrunCount
        } else {
          this.orderCollectTrunCount = 0
        }
        if (response.data.orderChangeCount !== null && response.data.orderChangeCount !== undefined) {
          this.orderChangeCount = response.data.orderChangeCount
        } else {
          this.orderChangeCount = 0
        }
        if (response.data.orderChangeUndoneCount !== null && response.data.orderChangeUndoneCount !== undefined) {
          this.orderChangeUndoneCount = response.data.orderChangeUndoneCount
        } else {
          this.orderChangeUndoneCount = 0
        }
        this.orderInfoCopy = Object.assign({}, this.orderInfo)
        this.afterInfo = response.data.afterInfo
        this.offerInfo = response.data.quoteInfo
        if (response.data.dealerBrand !== null && response.data.dealerBrand !== undefined) {
          this.brandPrincipal = response.data.dealerBrand
        }
        if (this.offerInfo !== null && this.offerInfo !== undefined) {
          this.UpperAmount = digitUppercase(this.offerInfo.amount)
        }
        this.orderMark = response.data.orderMark
        this.splitInfo = response.data.splitInfo
        this.roleInfo = response.data.roleInfo
        this.swatchs = response.data.swatchs || []
        const orderTitle = this.orderInfo.produnum || this.orderInfo.ordernum
        // if (this.orderInfo.bid === 3) {
        //   if (this.orderInfo.ordernum !== null && this.orderInfo.ordernum !== '' && this.orderInfo.ordernum !== undefined) {
        //     orderTitle = this.orderInfo.ordernum
        //   }
        // } else {
        //   if (this.orderInfo.produnum !== null && this.orderInfo.produnum !== '' && this.orderInfo.produnum !== undefined) {
        //     orderTitle = this.orderInfo.produnum
        //   }
        // }
        const pageTitle = `订单详情 ${orderTitle}`
        document.title = pageTitle
        const route = Object.assign({}, this.tempRoute, { title: pageTitle })
        this.$store.dispatch('tagsView/updateVisitedView', route)
        this.loading = false
        this.isAfterinfo = false
        this.isOfferInfo = false
        this.getTrack()
        this.getMultiFactory()
      }).catch(() => {
        this.loading = false
      })
    },
    addSwatch(row) {

    },
    delSwatch(row) {
      this.$confirm('您确定要删除此厂部标准色板吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        deleteSwatch({ id: row.board_id }).then(response => {
          this.$message({
            message: '色板删除成功',
            type: 'success'
          })
          this.getOrder()
        }).catch(() => {})
      }).catch(() => {})
    },
    getTrack() {
      this.trackLoading = true
      getOrderTrack({ orderid: this.orderid, factoryid: this.factoryid }).then(response => {
        const arr = []
        for (const data of response.data) {
          if (data.time !== '' || data.username !== '') {
            arr.push(data)
          }
        }
        // if (arr.length < response.data.length) {
        //   arr[0].remark = '' // 售后订单直接完成
        // }
        this.trackActivities = arr
        this.trackLoading = false
        this.getDynamic()
      }).catch(() => {
        this.trackLoading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getDynamic()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getDynamic()
    },
    getDynamic() {
      this.dynamicLoading = true
      const data = {
        orderid: this.orderid,
        page: this.currentPage,
        limit: this.pageSize,
        rank: this.user.rank,
        factoryid: this.factoryid
      }
      // console.log(this.orderid)
      // console.log(this.factoryid)
      getOrderDynamic(data).then(response => {
        this.orderDynamic = response.data
        this.total = response.total
        this.dynamicLoading = false
      }).catch(() => {
        this.dynamicLoading = false
      })
    },
    addDynamic(dynamic) {
      this.dynamicForm.content = ''
      this.dynamicForm.files = []
      this.dynamicForm.imgids = []
      this.dynamicForm.oldFiles = []
      this.dynamicForm.oldImages = []
      if (dynamic === null) {
        this.dynamicForm.title = '添加订单动态'
        this.dynamicForm.dynamicId = 0
      } else {
        this.dynamicForm.dynamicId = dynamic.dynamic_id
        this.dynamicForm.title = '修改订单动态'
        this.dynamicForm.content = dynamic.content
        for (const item of dynamic.dynamicImgs) {
          const image = {
            id: item.imgid,
            url: item.img_path
          }
          this.dynamicForm.oldImages.push(image)
        }
        for (const item of dynamic.fileList) {
          const fileName = `${item.file_name}.${item.file_type}`
          const file = {
            id: item.fileid,
            name: fileName
          }
          this.dynamicForm.oldFiles.push(file)
        }
      }
      this.dynamicForm.key = new Date().getTime().toString()
      this.dynamicVisible = true
    },
    deleteDynamic(dynamic) {
      this.$confirm('您确定要删除这条动态吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        this.dynamicLoading = true
        deleteOrderDynamic({ dynamicid: dynamic.dynamic_id }).then(response => {
          this.$message({
            message: '订单动态删除成功',
            type: 'success'
          })
          this.getDynamic()
        }).catch(() => {
          this.dynamicLoading = false
        })
      }).catch(() => {
        this.dynamicLoading = false
      })
    },
    SubDynamic(formName) {
      if (!this.dynamicloading) {
        this.dynamicloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.orderid,
          content: this.dynamicForm.content,
          fileStr: this.dynamicForm.files.join(','),
          imgStr: this.dynamicForm.imgids.join(','),
          dynamicId: this.dynamicForm.dynamicId,
          isPub: this.dynamicForm.isPub,
          factoryid: this.factoryid
        }
        addOrderDynamic(data).then(response => {
          this.$message({
            message: '订单动态提交成功',
            type: 'success'
          })
          this.dynamicloading = false
          this.dynamicVisible = false
          this.getDynamic()
        }).catch(() => {
          this.dynamicloading = false
        })
      } else {
        return false
      }
    },
    getMaterialDetail() {
      this.materialTableData = []
      if (this.orderInfo.bid === 3) {
        this.materialTitle = this.orderInfo.ordernum + ' 拆单详情'
      } else {
        if (this.orderInfo.produnum !== null && this.orderInfo.produnum !== '' && this.orderInfo.produnum !== undefined) {
          this.materialTitle = this.orderInfo.produnum + ' 拆单详情'
        } else {
          this.materialTitle = this.orderInfo.ordernum + ' 拆单详情'
        }
      }
      this.dbjSearchForm.area = ''
      this.dbjSearchForm.type = ''
      this.dbjSearchForm.search = ''
      this.materialVisible = true
      this.materialloading = true
      this.totalMoney = 0
      this.totalCount = 0
      console.log('用户归属组织: ' + this.user.dGroupid)
      getErpOrderMaterialDetail({ orderid: this.orderid, groupid: this.user.dGroupid, factoryid: this.factoryid }).then(response => {
        this.materialloading = false
        this.materialTableData = response.data
        this.allMaterialData = response.data
        const areaArray = []
        const typeArray = []
        let money = 0
        let count = 0
        for (const item of this.materialTableData) {
          let haveArea = false
          for (let i = 0; i < areaArray.length; i++) {
            if (areaArray[i] === item.area) {
              haveArea = true
              break
            }
          }
          if (!haveArea) {
            areaArray.push(item.area)
          }
          let haveType = false
          for (let i = 0; i < typeArray.length; i++) {
            if (typeArray[i] === item.type) {
              haveType = true
              break
            }
          }
          if (!haveType) {
            typeArray.push(item.type)
          }
          money += item.total
          if (item.num !== null && item.num !== '' && item.num !== undefined) {
            count += parseInt(item.num)
          }
        }
        this.totalMoney = money.toFixed(2)
        this.totalCount = parseInt(count)
        this.dbjSearchForm.areaList = areaArray
        this.dbjSearchForm.typeList = typeArray
      }).catch(() => {
        this.materialloading = false
      })
    },
    searchMaterial() {
      const newMaterial = []
      let money = 0
      let count = 0
      for (const item of this.allMaterialData) {
        let flage = true
        if (this.dbjSearchForm.area !== '') {
          if (item.area !== this.dbjSearchForm.area) {
            flage = false
          }
        }
        if (this.dbjSearchForm.type !== '') {
          if (item.type !== this.dbjSearchForm.type) {
            flage = false
          }
        }
        if (this.dbjSearchForm.search !== '') {
          if (item.name.indexOf(this.dbjSearchForm.search) < 0 && item.xuhao.indexOf(this.dbjSearchForm.search) < 0 && item.material.indexOf(this.dbjSearchForm.search) < 0 && item.color.indexOf(this.dbjSearchForm.search) < 0) {
            flage = false
          }
        }
        if (flage) {
          if (item.num !== null && item.num !== '' && item.num !== undefined) {
            count += parseInt(item.num)
          }
          money += item.total
          newMaterial.push(item)
        }
      }
      this.totalMoney = money.toFixed(2)
      this.totalCount = parseInt(count)
      this.materialTableData = newMaterial
    },
    closeMaterial() {
      this.materialTableData = []
      this.materialVisible = false
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        let tempindex = 0
        let rowspan = 1
        let temp = null
        for (let i = 0; i <= this.materialTableData.length; i++) {
          if (i === 0) {
            tempindex = i
            rowspan = 1
            temp = this.materialTableData[i].area
          } else {
            if (i === this.materialTableData.length) {
              if (rowIndex === tempindex) {
                return {
                  rowspan: rowspan,
                  colspan: 1
                }
              }
            } else {
              if (temp === this.materialTableData[i].area) {
                rowspan++
                if (rowIndex === i) {
                  return {
                    rowspan: 0,
                    colspan: 0
                  }
                }
              } else {
                if (rowIndex === tempindex) {
                  return {
                    rowspan: rowspan,
                    colspan: 1
                  }
                } else {
                  tempindex = i
                  rowspan = 1
                  temp = this.materialTableData[i].area
                }
              }
            }
          }
        }
      }
    },
    viewAfterDetail() {
      if (!this.isAfterinfo) {
        if (this.orderInfo.produnum !== null && this.orderInfo.produnum !== '' && this.orderInfo.produnum !== undefined) {
          this.afterTitle = this.orderInfo.produnum + ' 售后处理详情'
        } else {
          this.afterTitle = this.orderInfo.ordernum + ' 售后处理详情'
        }
        this.fullscreenAfterLoading = true
        getAfterSalePageInfo({ afterid: this.afterInfo.after_id }).then(response => {
          this.afterinfoData = response.data
          this.afterinfoData.factory = this.afterinfoData.afterSale.factory
          this.afterinfoData.deptRson = this.afterinfoData.afterSale.reasonList
          this.afterinfoData.opinions = this.afterinfoData.afterSale.opinions ? JSON.parse(this.afterinfoData.afterSale.opinions) : {}
          this.fullscreenAfterLoading = false
          this.isAfterinfo = true
        }).catch(() => {
          this.fullscreenAfterLoading = false
        })
      }
      this.afterIVisible = true
    },
    viewOfferDetail() {
      if (!this.isOfferInfo) {
        if (this.orderInfo.bid === 3) {
          this.offerTitle = this.orderInfo.ordernum + '报价详情'
        } else {
          if (this.orderInfo.produnum !== null && this.orderInfo.produnum !== '' && this.orderInfo.produnum !== undefined) {
            this.offerTitle = this.orderInfo.produnum + ' 报价详情'
          } else {
            this.offerTitle = this.orderInfo.ordernum + ' 报价详情'
          }
        }
        this.fullscreenOfferLoading = true
        getOrderQuoteDetail({ orderid: this.orderid }).then(response => {
          // this.quotename = response.data.quotename
          // this.quoteyear = response.data.quoteyear
          this.orderquotedata = response.data.quotes
          this.offerImgs = response.data.imglst
          this.offerOther = response.data.otherlst
          this.offerChanges = response.data.changelst
          this.offerAccountReceipt = response.data.dralst
          this.fullscreenOfferLoading = false
          this.isOfferInfo = true
        }).catch(() => {
          this.fullscreenOfferLoading = false
        })
      }
      this.offerVisible = true
    },
    jdbtn() {
      this.jdRules.content[0].required = false
      this.jdRules.price[0].required = true
      this.jdRules.issplit[0].required = true
      this.jdForm.orderid = this.orderInfo.orderid
      this.jdForm.type = this.orderInfo.type
      if (this.orderInfo.type === 3) {
        this.jdForm.issplit = null
      } else {
        this.jdForm.issplit = 0
      }
      this.jdForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.address
      this.jdForm.content = ''
      this.jdForm.files = []
      this.jdForm.imgids = []
      this.jdForm.price = this.orderInfo.estimated
      this.jdForm.after = null
      this.jdForm.reportid = []
      if (this.jdForm.type === 0) {
        getDealerAccountReportByDelid({ delid: this.orderInfo.delid, groupid: this.orderInfo.groupid }).then(response => {
          const rslst = []
          for (const d of response.data) {
            const children = []
            for (const a of d.daralst) {
              if (a.orderid !== null && a.orderid !== '' && a.orderid !== undefined) {
                if (a.orderid === this.jdForm.orderid) {
                  children.push({ value: a.id, label: a.address })
                  this.jdForm.reportid = [d.darid, a.id]
                } else {
                  children.push({ value: a.id, label: a.address + '（已关联）', disabled: true })
                }
              } else {
                children.push({ value: a.id, label: a.address })
              }
            }
            rslst.push({ value: d.darid, label: d.name, children: children })
          }
          this.jdReportList = rslst
        }).catch(() => {
          this.jdReportList = []
        })
      } else {
        this.jdReportList = []
      }
      this.jdVisible = true
    },
    turnJd(formName) {
      this.jdRules.content[0].required = true
      this.jdRules.price[0].required = false
      this.jdRules.issplit[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubJdOrder(0)
        } else {
          return false
        }
      })
    },
    subEditJd(formName) {
      this.jdRules.content[0].required = false
      this.jdRules.price[0].required = true
      this.jdRules.issplit[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubJdOrder(1)
        } else {
          return false
        }
      })
    },
    SubJdOrder(ispass) {
      if (!this.jdloading) {
        this.jdloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.jdForm.orderid,
          type: this.jdForm.type,
          content: this.jdForm.content,
          ispass: ispass,
          fileids: this.jdForm.files.join(','),
          imgids: this.jdForm.imgids.join(','),
          price: this.jdForm.price,
          after: this.jdForm.after,
          reportid: this.jdForm.reportid.join(','),
          issplit: this.jdForm.issplit
        }
        acceptOrder(data).then(response => {
          let msg = '接单操作成功'
          if (ispass === 0) {
            msg = '订单已驳回'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.jdloading = false
          this.jdVisible = false
          this.getOrder()
        }).catch(() => {
          this.jdloading = false
        })
      } else {
        return false
      }
    },
    gotoShsq() {
      this.$router.push({ path: '/work/shsq' })
    },
    gotoShcl() {
      this.$router.push({ path: '/work/shcl' })
    },
    bhRsonList() {
      getBhRsonList().then(response => {
        this.rsonList = response.data || []
      }).catch(() => {})
    },
    jspgBtn() {
      this.jspgRules.content[0].required = false
      this.jspgForm.orderid = this.orderInfo.orderid
      this.jspgForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.address
      this.jspgForm.content = ''
      this.jspgForm.files = []
      this.jspgForm.imgids = []
      this.jspgVisible = true
      this.bhRsonList()
    },
    turnJspg(formName) {
      this.jspgRules.content[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubJspgOrder(0)
        } else {
          return false
        }
      })
    },
    subEditJspg(formName) {
      this.jspgRules.content[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubJspgOrder(1)
        } else {
          return false
        }
      })
    },
    SubJspgOrder(ispass) {
      if (!this.jspgloading) {
        this.jspgloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.jspgForm.orderid,
          reason: Array.isArray(this.jspgForm.content) ? this.jspgForm.content.join(';') : this.jspgForm.content,
          ispass: ispass,
          fileStr: this.jspgForm.files.join(','),
          imgStr: this.jspgForm.imgids.join(',')
        }
        assessOrder(data).then(response => {
          let msg = '技术评估已通过'
          if (ispass === 0) {
            msg = '订单已驳回'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.jspgloading = false
          this.jspgVisible = false
          this.getOrder()
        }).catch(() => {
          this.jspgloading = false
        })
      } else {
        return false
      }
    },
    cdfpBtn() {
      this.cdfpForm.orderid = this.orderInfo.orderid
      this.cdfpForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.address
      this.cdfpForm.content = ''
      this.cdfpForm.files = []
      this.cdfpForm.splitid = null
      this.cdfpForm.imgids = []
      this.cdfpVisible = true
    },
    subEditCdfp(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.cdfploading) {
            this.cdfploading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.cdfpForm.orderid,
              splitid: this.cdfpForm.splitid,
              content: this.cdfpForm.content,
              fileids: this.cdfpForm.files.join(','),
              imgids: this.cdfpForm.imgids.join(',')
            }
            splitOrder(data).then(response => {
              this.$message({
                message: '拆单已分配成功',
                type: 'success'
              })
              this.cdfploading = false
              this.cdfpVisible = false
              this.getOrder()
            }).catch(() => {
              this.cdfploading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    // 拆单调整
    splitChange() {
      this.$prompt('<span style="color: red;">拆单调整会将订单状态初始化为待拆单，中间流程数据将会丢失，请谨慎操作！</span> <br />如果确认需要拆单调整，请输入以下文字：<br /><strong>我已阅读并知悉以上注意事项</strong>', '重要提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        inputPlaceholder: '请输入',
        inputValidator: (value) => {
          if (value && value == '我已阅读并知悉以上注意事项') {
            return true
          }
          return '输入文字错误'
        },
        inputErrorMessage: '输入文字错误'
      }).then(() => {
        const data = {
          userid: this.user.dUserid,
          orderid: this.orderInfo.orderid,
          ctype: 103 // 103-申请拆单调整
        }
        // console.log(data)
        addOrderDynamic(data).then(response => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getOrder()
        }).catch(() => {})
      }).catch(() => {})
    },
    getSelectOrders(type, callback) {
      this.selectNextOrderList = []
      const data = {
        page: 1,
        limit: 9999,
        mark: 6,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        iscd: 1
      }
      this.nextOrdersLoading = true
      getOrderList(data).then(response => {
        this.nextOrdersLoading = false
        let list = response.data || []
        // 找出可以开始拆单的订单
        if (list.length > 0) {
          let hasChild = false
          // 如果该订单是子单 是否还有其余进行中子单
          if (type === 'finish' && this.orderInfo.splitOrderId) {
            hasChild = list.findIndex(r => r.splitOrderId &&
              r.splitOrderId == this.orderInfo.splitOrderId && r.splitStatus == 1 && r.order_id != this.orderInfo.orderid) > -1
          }
          // splitStatus 0:未开始、1:进行中、2:已暂停、3:待拆单员确认 4:已完成
          list = list.filter(r => {
            let flag1 = (r.splitStatus == 0 || r.splitStatus == 3) && r.order_id != this.orderInfo.orderid
            let flag2 = false
            // 如果是完成操作 且还有其他进行中子单 需要优先完成子单
            if (type === 'finish' && hasChild) {
              flag1 = false
              if (r.splitOrderId && this.orderInfo.splitOrderId) {
                flag2 = r.splitOrderId == this.orderInfo.splitOrderId && r.order_id != this.orderInfo.orderid
              }
            }
            return flag1 || flag2
          })
          // 排序 如果是子单 同子单数据在前
          if (this.orderInfo.splitOrderId && list.length > 0) {
            list.sort((a, b) => {
              return a.splitOrderId == this.orderInfo.splitOrderId ? 1 : 0
            })
          }
        }
        this.selectNextOrderList = list
        if (callback && typeof callback === 'function') {
          callback(this.selectNextOrderList.length)
        }
      }).catch(() => {
        this.nextOrdersLoading = false
      })
    },
    // 确认继续拆单
    startCdBtn() {
      // 3-待拆单员确认
      if (this.orderInfo.splitStatus != 3) return
      this.$confirm('是否确认继续拆单 ' + this.orderInfo.ordernum + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        const data = {
          userid: this.user.dUserid,
          orderid: this.orderInfo.orderid,
          ctype: 104 // 104-继续拆单
        }
        addOrderDynamic(data).then(response => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getOrder()
        }).catch(() => {})
      }).catch(() => {})
    },
    // 暂停拆单
    pauseCdBtn() {
      // splitStatus: 1-进行中
      if (this.orderInfo.splitStatus != 1) return
      this.pauseSplitForm = {
        orderid: this.orderInfo.orderid,
        ordername: this.orderInfo.ordernum + ' / ' + this.orderInfo.address,
        content: '',
        imgids: []
      }

      this.getSelectOrders('pause', (len) => {
        this.pauseSplitVisible = true
        this.pauseSplitRules.nextOrderId[0].required = len > 0
      })
    },
    // 暂停拆单
    subSplitPause(formName) {
      const required = this.pauseSplitForm.content.trim() || this.pauseSplitForm.imgids.length > 0
      this.pauseSplitRules.content[0].required = !required
      this.pauseSplitRules.imgids[0].required = !required
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.pauseSplitLoading) {
            this.pauseSplitLoading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.pauseSplitForm.orderid,
              nextOrderId: this.pauseSplitForm.nextOrderId,
              content: this.pauseSplitForm.content,
              imgStr: this.pauseSplitForm.imgids.join(','),
              ctype: 101 // 101-暂停拆单
            }
            addOrderDynamic(data).then(response => {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.pauseSplitLoading = false
              this.pauseSplitVisible = false
              this.getOrder()
            }).catch(() => {
              this.pauseSplitLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    // 申请继续拆单
    sqjxCdBtn() {
      // splitStatus: 2-已暂停
      if (this.orderInfo.splitStatus != 2) return
      this.sqjxSplitForm = {
        orderid: this.orderInfo.orderid,
        ordername: this.orderInfo.ordernum + ' / ' + this.orderInfo.address,
        content: '',
        imgids: [],
        files: []
      }
      this.sqjxSplitVisible = true
    },
    // 申请继续拆单
    subSplitSqjx(formName) {
      const required = this.sqjxSplitForm.content.trim() || this.sqjxSplitForm.imgids.length > 0
      this.sqjxSplitRules.content[0].required = !required
      this.sqjxSplitRules.imgids[0].required = !required
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.sqjxSplitLoading) {
            this.sqjxSplitLoading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.sqjxSplitForm.orderid,
              content: this.sqjxSplitForm.content,
              fileStr: this.sqjxSplitForm.files.join(','),
              imgStr: this.sqjxSplitForm.imgids.join(','),
              ctype: 102 // 102-申请继续拆单
            }
            addOrderDynamic(data).then(response => {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.sqjxSplitLoading = false
              this.sqjxSplitVisible = false
              this.getOrder()
            }).catch(() => {
              this.sqjxSplitLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    cdBtn() {
      this.cdForm.orderid = this.orderInfo.orderid
      this.cdForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.address
      this.cdForm.content = ''
      this.cdForm.files = []
      this.cdForm.fileid = ''
      this.cdistempFile = true
      if (this.splitInfo.splitfileid !== null && this.splitInfo.splitfileid !== '' && this.splitInfo.splitfileid !== undefined) {
        this.cdoldFile = [{ name: this.splitInfo.splitfilename, id: this.splitInfo.splitfileid }]
        this.cdForm.splitFileid = this.splitInfo.splitfileid
      } else {
        this.cdoldFile = []
        this.cdForm.splitFileid = ''
      }
      this.cdForm.imgids = []
      this.cdbtnKey = new Date().getTime()
      this.cdimportKey = new Date().getTime()
      this.cdfileLoad = new Date().getTime()

      this.getSelectOrders('finish', (len) => {
        this.cdVisible = true
        this.cdRules.nextOrderId[0].required = len > 0
      })
    },
    cdimportMaterials() {
      if (!this.cdimportloading) {
        this.cdimportloading = true
        const importLoading = this.$loading({
          lock: true,
          text: '料单正在导入，请勿关闭此页面',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        const data = {
          orderid: this.cdForm.orderid,
          fileid: this.cdForm.fileid,
          userid: this.user.dUserid
        }
        ErpOrderImportMaterial(data).then(response => {
          this.cdForm.splitFileid = this.cdForm.fileid
          this.cdimportloading = false
          this.$message({
            message: '料单导入成功',
            type: 'success'
          })
          importLoading.close()
        }).catch(() => {
          this.cdimportloading = false
          importLoading.close()
        })
      }
    },
    subEditCd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.cdloading) {
            this.cdloading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.cdForm.orderid,
              content: this.cdForm.content,
              // nextOrderId: this.cdForm.nextOrderId,
              fileids: this.cdForm.files.join(','),
              imgids: this.cdForm.imgids.join(',')
            }
            splitCarryOrder(data).then(response => {
              this.$message({
                message: '拆单已完成',
                type: 'success'
              })
              this.cdloading = false
              this.cdVisible = false
              this.getOrder()
            }).catch(() => {
              this.cdloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    ddqrBtn() {
      this.ddqrRules.content[0].required = false
      this.ddqrForm.orderid = this.orderInfo.orderid
      this.ddqrForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.address
      this.ddqrForm.content = ''
      this.ddqrForm.files = []
      this.ddqrForm.imgids = []
      this.ddqrVisible = true
    },
    turnDdqr(formName) {
      this.ddqrRules.content[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubDdqrOrder(0)
        } else {
          return false
        }
      })
    },
    subEditDdqr(formName) {
      this.ddqrRules.content[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubDdqrOrder(1)
        } else {
          return false
        }
      })
    },
    SubDdqrOrder(ispass) {
      if (!this.ddqrloading) {
        this.ddqrloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.ddqrForm.orderid,
          reason: this.ddqrForm.content,
          ispass: ispass,
          fileStr: this.ddqrForm.files.join(','),
          imgStr: this.ddqrForm.imgids.join(','),
          type: 1
        }
        confirmOrder(data).then(response => {
          let msg = '订单已代为确认'
          if (ispass === 0) {
            msg = '订单已驳回'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.ddqrloading = false
          this.ddqrVisible = false
          this.getOrder()
        }).catch(() => {
          this.ddqrloading = false
        })
      } else {
        return false
      }
    },
    dbjBtn() {
      this.dbjRules.fileid[0].required = true
      this.dbjRules.offerFileid[0].required = true
      this.dbjRules.content[0].required = false
      this.dbjForm.orderid = this.orderInfo.orderid
      this.dbjForm.ordertype = this.orderInfo.type
      this.dbjForm.bid = this.orderInfo.bid
      this.dbjForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.produnum + ' / ' + this.orderInfo.address
      this.dbjForm.content = ''
      this.dbjForm.files = []
      this.dbjForm.imgids = []
      this.dbjForm.pubimgids = []
      this.dbjistempFile = true
      this.dbjForm.fileid = ''
      this.dbjForm.offerFileid = ''
      if (this.offerInfo !== null && this.offerInfo !== undefined) {
        if (this.offerInfo.fileid !== null && this.offerInfo.fileid !== '' && this.offerInfo.fileid !== undefined) {
          this.dbjoldFile = [{ name: this.offerInfo.file_name, id: this.offerInfo.fileid }]
        } else {
          this.dbjoldFile = []
        }
      } else {
        this.dbjoldFile = []
      }
      this.dbjbtnKey = new Date().getTime()
      this.dbjimportKey = new Date().getTime()
      this.dbjfileLoad = new Date().getTime()
      this.dbjForm.totalprice = 0.0
      this.dbjForm.wall = 0.0
      this.dbjForm.cabinet = 0.0
      this.dbjForm.access = 0.0
      this.dbjForm.door = 0.0
      this.dbjForm.raise = 0.0
      this.dbjForm.discount = 0.0
      this.dbjForm.best = 0.0
      this.dbjForm.factorycom = 0.0
      this.dbjForm.clientcom = 0.0
      this.dbjForm.designcom = 0.0
      this.dbjForm.other = 0.0
      this.dbjForm.amount = 0.0
      this.dbjForm.offerOther = []
      this.dbjForm.aluminum = 0.0
      this.dbjForm.oil = 0.0
      this.dbjForm.tiepi = 0.0
      this.dbjForm.paint = 0.0
      this.dbjForm.jokins = 0.0
      this.dbjForm.yt = 0.0
      this.bjfjActiveNames = ['1', '3']
      // 业绩支票返点/报备金折扣
      this.dbjForm.rebateAmount = 0.0
      this.dbjForm.rebateSelection = []
      this.dbjForm.bjRebateList = []
      this.dbjForm.bjReportList = []
      this.dbjForm.bjTempList = []
      this.dbjForm.tempAmount = 0.0
      this.dbjForm.tempSelection = []
      this.dbjForm.reportAmount = 0.0
      this.dbjForm.reportSelection = []
      getRebateAndReportByOrderid({ orderid: this.dbjForm.orderid }).then(response => {
        this.dbjForm.bjRebateList = response.data.rebatelst
        this.dbjForm.bjReportList = response.data.repostlst
        this.dbjForm.bjTempList = response.data.templst
      }).catch(() => {
        this.dbjForm.bjRebateList = []
        this.dbjForm.bjReportList = []
        this.dbjForm.bjTempList = []
      })
      this.dbjVisible = true
    },
    viewRebateDateil(row) {
      this.imgRebateSrcList = []
      this.viewRebateVisible = true
      this.viewRebateLoading = true
      getDealerAccountRebateById({ darid: row.darid }).then(response => {
        this.viewRebateLoading = false
        this.viewRebatedata = response.data.dar
        const imgs = []
        for (const c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgRebateSrcList = imgs
      }).catch(() => {
        this.viewRebateLoading = false
      })
    },
    // downQuote() {
    //   if (this.dbjForm.qid === null || this.dbjForm.qid === '' || this.dbjForm.qid === undefined || this.dbjForm.qid === 0 || this.dbjForm.qid === '0') {
    //     this.$message({
    //       message: '请选择报价书',
    //       type: 'error'
    //     })
    //     return
    //   }
    //   let row = null
    //   for (const q of this.quoteData) {
    //     if (q.qid === this.dbjForm.qid) {
    //       row = q
    //       break
    //     }
    //   }
    //   if (row !== null) {
    //     getFileInfo({ fileid: row.fileid }).then(response => {
    //       const a = document.createElement('a')
    //       a.href = response.data.copyPath
    //       a.click()
    //       const h = this.$createElement
    //       this.$msgbox({
    //         title: '下载提示',
    //         message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
    //           h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
    //           h('a',
    //             { attrs: {
    //                 href: response.data.copyPath,
    //                 target: '_blank',
    //                 download: `${response.data.dName}.${response.data.dType}`,
    //                 style: 'color: #409EFF;text-decoration:underline;'
    //               }}, `点击这里`),
    //           h('span', null, `重新下载。`)
    //         ]),
    //         showCancelButton: false,
    //         confirmButtonText: '关闭',
    //         beforeClose: (action, instance, done) => {
    //           done()
    //         }
    //       }).then(action => {
    //       })
    //     }).catch(() => {})
    //   }
    // },
    viewReportDateil(row) {
      this.imgReportSrcList = []
      this.viewReportVisible = true
      this.viewReportLoading = true
      getDealerAccountReportById({ darid: row.darid }).then(response => {
        this.viewReportLoading = false
        this.viewReportdata = response.data.dar
        this.viewReportAddress = response.data.daralst
        this.viewReportDiscount = response.data.dardlst
        this.viewReportAcccount = response.data.acccount
        const imgs = []
        for (const c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgReportSrcList = imgs
      }).catch(() => {
        this.viewReportLoading = false
      })
    },
    viewAchievementDateil(row) {
      this.imgCyjSrcList = []
      this.viewCyjVisible = true
      this.viewCyjLoading = false
      this.viewCyjdata = { ...row }
      const imgs = [row.img]
      this.imgCyjSrcList = imgs
    },
    viewAfterDateil(row) {
      this.imgAfterSrcList = []
      this.viewAfterVisible = true
      this.viewAfterLoading = true
      getDealerAccountAfterById({ daaid: row.daaid }).then(response => {
        this.viewAfterLoading = false
        this.viewAfterdata = response.data.daa
        const imgs = []
        for (const c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgAfterSrcList = imgs
      }).catch(() => {
        this.viewAfterLoading = false
      })
    },
    viewOtherAcc(row) {
      if (row.acctype !== 9) {
        if (row.acctype === 0) {
          this.viewRebateDateil({ darid: row.daraccid })
        } else if (row.acctype === 1) {
          this.viewAfterDateil({ daaid: row.daraccid })
        } else if (row.acctype === 2) {
          this.viewReportDateil({ darid: row.daraccid })
        }
      }
    },
    handleRebateSelectionChange(val) {
      this.dbjForm.rebateSelection = val
      for (const rb of this.dbjForm.bjRebateList) {
        let ischeck = false
        for (const s of this.dbjForm.rebateSelection) {
          if (s.darid === rb.darid) {
            ischeck = true
            if (this.dbjForm.discount <= 0.0 || this.dbjForm.discount === null || this.dbjForm.discount === '' || this.dbjForm.discount === undefined) {
              this.dbjForm.discount = s.mindiscount
            } else {
              if (s.mindiscount < parseFloat(this.dbjForm.discount)) {
                this.dbjForm.discount = s.mindiscount
              }
            }
            break
          }
        }
        rb.ischeck = ischeck
      }
      if (this.dbjForm.tempSelection.length <= 0 && this.dbjForm.rebateSelection.length <= 0 && this.dbjForm.reportSelection.length <= 0) {
        this.dbjForm.discount = 0
      }
    },
    handleReportSelectionChange(val) {
      this.dbjForm.reportSelection = val
      for (const rb of this.dbjForm.bjReportList) {
        let ischeck = false
        for (const s of this.dbjForm.reportSelection) {
          if (s.darid === rb.darid) {
            ischeck = true
            if (this.dbjForm.discount <= 0.0 || this.dbjForm.discount === null || this.dbjForm.discount === '' || this.dbjForm.discount === undefined) {
              this.dbjForm.discount = s.currentDiscount
            } else {
              if (parseFloat(s.currentDiscount) < parseFloat(this.dbjForm.discount)) {
                this.dbjForm.discount = s.currentDiscount
              }
            }
            break
          }
        }
        rb.ischeck = ischeck
      }
      if (this.dbjForm.tempSelection.length <= 0 && this.dbjForm.reportSelection.length <= 0 && this.dbjForm.rebateSelection.length <= 0) {
        this.dbjForm.discount = 0
      }
    },
    handleTempSelectionChange(val) {
      this.dbjForm.tempSelection = val
      for (const rb of this.dbjForm.bjTempList) {
        let ischeck = false
        for (const s of this.dbjForm.tempSelection) {
          if (s.datid === rb.datid) {
            ischeck = true
            let _tempdiscount = s.discount
            if (s.credit === 0) {
              _tempdiscount = s.mindiscount
            }
            if (this.dbjForm.discount <= 0.0 || this.dbjForm.discount === null || this.dbjForm.discount === '' || this.dbjForm.discount === undefined) {
              this.dbjForm.discount = _tempdiscount
            } else {
              if (parseFloat(_tempdiscount) < parseFloat(this.dbjForm.discount)) {
                this.dbjForm.discount = _tempdiscount
              }
            }
            break
          }
        }
        rb.ischeck = ischeck
      }
      if (this.dbjForm.tempSelection.length <= 0 && this.dbjForm.rebateSelection.length <= 0 && this.dbjForm.reportSelection.length <= 0) {
        this.dbjForm.discount = 0
      }
    },
    rebateAmount() {
      if (this.dbjForm.rebateSelection.length > 0) {
        let amount = 0.0
        for (const sel of this.dbjForm.rebateSelection) {
          for (const rb of this.dbjForm.bjRebateList) {
            if (rb.darid === sel.darid) {
              if (rb.discountAmount !== null && rb.discountAmount !== '' && rb.discountAmount !== undefined) {
                amount = amount + parseFloat(rb.discountAmount)
              }
              if (parseFloat(rb.discountAmount) > parseFloat(rb.balance)) {
                this.$message.error(rb.name + '账户余额不足')
              }
              break
            }
          }
        }
        this.dbjForm.rebateAmount = amount.toFixed(2)
      } else {
        this.dbjForm.rebateAmount = 0.0
      }
      const bestAmount = parseFloat(this.dbjForm.rebateAmount) + parseFloat(this.dbjForm.reportAmount) + parseFloat(this.dbjForm.tempAmount)
      this.dbjForm.best = bestAmount.toFixed(2)
    },
    reportAmount() {
      if (this.dbjForm.reportSelection.length > 0) {
        let amount = 0.0
        for (const sel of this.dbjForm.reportSelection) {
          for (const rb of this.dbjForm.bjReportList) {
            if (rb.darid === sel.darid) {
              if (rb.discountAmount !== null && rb.discountAmount !== '' && rb.discountAmount !== undefined) {
                amount = amount + parseFloat(rb.discountAmount)
              }
              break
            }
          }
        }
        this.dbjForm.reportAmount = amount.toFixed(2)
      } else {
        this.dbjForm.reportAmount = 0.0
      }
      const bestAmount = parseFloat(this.dbjForm.rebateAmount) + parseFloat(this.dbjForm.reportAmount) + parseFloat(this.dbjForm.tempAmount)
      this.dbjForm.best = bestAmount.toFixed(2)
    },
    tempAmount() {
      if (this.dbjForm.tempSelection.length > 0) {
        let amount = 0.0
        for (const sel of this.dbjForm.tempSelection) {
          for (const rb of this.dbjForm.bjTempList) {
            if (rb.datid === sel.datid) {
              if (rb.discountAmount !== null && rb.discountAmount !== '' && rb.discountAmount !== undefined) {
                amount = amount + parseFloat(rb.discountAmount)
              }
              break
            }
          }
        }
        this.dbjForm.tempAmount = amount.toFixed(2)
      } else {
        this.dbjForm.tempAmount = 0.0
      }
      const bestAmount = parseFloat(this.dbjForm.rebateAmount) + parseFloat(this.dbjForm.reportAmount) + parseFloat(this.dbjForm.tempAmount)
      this.dbjForm.best = bestAmount.toFixed(2)
    },
    dbjcountAmount() {
      let wall = 0.0
      let cabinet = 0.0
      let access = 0.0
      let door = 0.0
      let aluminum = 0.0
      if (this.dbjForm.wall !== null && this.dbjForm.wall !== '' && this.dbjForm.wall !== undefined) {
        wall = parseFloat(this.dbjForm.wall)
      }
      if (this.dbjForm.cabinet !== null && this.dbjForm.cabinet !== '' && this.dbjForm.cabinet !== undefined) {
        cabinet = parseFloat(this.dbjForm.cabinet)
      }
      if (this.dbjForm.access !== null && this.dbjForm.access !== '' && this.dbjForm.access !== undefined) {
        access = parseFloat(this.dbjForm.access)
      }
      if (this.dbjForm.door !== null && this.dbjForm.door !== '' && this.dbjForm.door !== undefined) {
        door = parseFloat(this.dbjForm.door)
      }
      if (this.dbjForm.aluminum !== null && this.dbjForm.aluminum !== '' && this.dbjForm.aluminum !== undefined) {
        aluminum = parseFloat(this.dbjForm.aluminum)
      }
      let amount = wall + cabinet + access + door + aluminum
      let raise = 0.0
      let best = 0.0
      if (this.dbjForm.raise !== null && this.dbjForm.raise !== '' && this.dbjForm.raise !== undefined) {
        raise = parseFloat(this.dbjForm.raise)
      }
      if (this.dbjForm.best !== null && this.dbjForm.best !== '' && this.dbjForm.best !== undefined) {
        best = parseFloat(this.dbjForm.best)
      }
      let other = 0.0
      if (this.dbjForm.other !== null && this.dbjForm.other !== '' && this.dbjForm.other !== undefined) {
        other = parseFloat(this.dbjForm.other)
      }
      this.dbjForm.totalprice = (amount + raise + other).toFixed(0)
      amount = amount + raise - best
      // let discount = 1
      // if (this.dbjForm.discount !== null && this.dbjForm.discount !== '' && this.dbjForm.discount !== undefined) {
      //   if (parseFloat(this.dbjForm.discount) > 0) {
      //     discount = parseFloat(this.dbjForm.discount) / 10
      //   }
      // }
      // amount = amount * discount
      amount = amount + other
      if (amount < 0) {
        amount = 0.0
      }
      this.dbjForm.amount = amount.toFixed(0)
      this.dbjUpperAmount = digitUppercase(this.dbjForm.amount)
    },
    dbjbearAmount() {
      const amount = parseFloat(this.dbjForm.amount)
      let factorycom = 0.0
      let clientcom = 0.0
      let designcom = 0.0
      if (this.dbjForm.designcom !== null && this.dbjForm.designcom !== '' && this.dbjForm.designcom !== undefined) {
        if (parseFloat(this.dbjForm.designcom) >= 0) {
          designcom = parseFloat(this.dbjForm.designcom)
        }
      }
      if (this.dbjForm.factorycom !== null && this.dbjForm.factorycom !== '' && this.dbjForm.factorycom !== undefined) {
        if (parseFloat(this.dbjForm.factorycom) >= 0) {
          factorycom = parseFloat(this.dbjForm.factorycom)
        }
      }
      if (this.dbjForm.clientcom !== null && this.dbjForm.clientcom !== '' && this.dbjForm.clientcom !== undefined) {
        if (parseFloat(this.dbjForm.clientcom) >= 0) {
          clientcom = parseFloat(this.dbjForm.clientcom)
        }
      }
      if (designcom < 0) {
        designcom = 0
      }
      if (factorycom < 0) {
        factorycom = 0
      }
      clientcom = amount - factorycom - designcom
      if (clientcom < 0) {
        clientcom = 0
      }
      this.dbjForm.designcom = designcom
      this.dbjForm.factorycom = factorycom
      this.dbjForm.clientcom = clientcom.toFixed(2)
    },
    dbjotherAmount() {
      let otheramount = 0.0
      for (const o of this.dbjForm.offerOther) {
        let amount = 0.0
        if (o.amount !== null && o.amount !== '' && o.amount !== undefined) {
          amount = parseFloat(o.amount)
        }
        otheramount = otheramount + amount
      }
      this.dbjForm.other = otheramount.toFixed(2)
    },
    dbjimportOffer() {
      if (!this.dbjimportloading) {
        this.dbjimportloading = true
        const importLoading = this.$loading({
          lock: true,
          text: '报价单正在解析中，请勿关闭此页面',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        const data = {
          orderid: this.dbjForm.orderid,
          fileid: this.dbjForm.fileid,
          userid: this.user.dUserid
        }
        ErpOrderImportOffer(data).then(response => {
          this.dbjForm.totalprice = response.data.totalprice
          this.dbjForm.wall = response.data.wall
          this.dbjForm.cabinet = response.data.cabinet
          this.dbjForm.access = response.data.access
          this.dbjForm.door = response.data.door
          this.dbjForm.amount = response.data.totalprice
          this.dbjForm.offerFileid = this.dbjForm.fileid
          this.dbjForm.aluminum = response.data.aluminum
          this.dbjForm.oil = response.data.oil
          this.dbjForm.tiepi = response.data.tiepi
          this.dbjForm.paint = response.data.paint
          this.dbjimportloading = false
          this.$message({
            message: '报价单解析成功',
            type: 'success'
          })
          importLoading.close()
        }).catch(() => {
          this.dbjimportloading = false
          importLoading.close()
        })
      }
    },
    dbjaddOther() {
      this.dbjForm.offerOther.push({ type: null, name: '', amount: null })
    },
    dbjdelOther(index) {
      this.dbjForm.offerOther.splice(index, 1)
    },
    turnDbj(formName) {
      this.dbjRules.content[0].required = true
      this.dbjRules.fileid[0].required = false
      this.dbjRules.offerFileid[0].required = false
      this.dbjRules.qid[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubDbjOrder(0)
        } else {
          return false
        }
      })
    },
    subEditDbj(formName) {
      this.dbjRules.fileid[0].required = true
      this.dbjRules.offerFileid[0].required = true
      this.dbjRules.qid[0].required = true
      this.dbjRules.content[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let isok = true
          for (const rb of this.dbjForm.bjRebateList) {
            if (rb.ischeck) {
              if (rb.discountAmount === null || rb.discountAmount === '' || rb.discountAmount === undefined || parseFloat(rb.discountAmount) <= 0) {
                this.$message.error('请输入' + rb.name + '优惠金额')
                isok = false
                break
              } else {
                if (parseFloat(rb.discountAmount) > parseFloat(rb.balance)) {
                  this.$message.error(rb.name + '账户余额不足')
                  isok = false
                  break
                }
              }
            }
          }
          if (isok) {
            for (const rb of this.dbjForm.bjReportList) {
              if (rb.ischeck) {
                if (rb.currentDiscount === null || rb.currentDiscount === '' || rb.currentDiscount === undefined || parseFloat(rb.currentDiscount) <= 0) {
                  this.$message.error('请输入' + rb.name + '优惠折扣')
                  isok = false
                  break
                } else {
                  if (rb.discountAmount === null || rb.discountAmount === '' || rb.discountAmount === undefined || parseFloat(rb.discountAmount) <= 0) {
                    this.$message.error('请输入' + rb.name + '优惠金额')
                    isok = false
                    break
                  }
                }
              }
            }
          }
          if (isok) {
            for (const rb of this.dbjForm.bjTempList) {
              if (rb.ischeck) {
                if (rb.discountAmount === null || rb.discountAmount === '' || rb.discountAmount === undefined || parseFloat(rb.discountAmount) <= 0) {
                  this.$message.error('请输入' + rb.name + '优惠金额')
                  isok = false
                  break
                }
              }
            }
          }
          if (isok) {
            this.SubDbjOrder(1)
          }
        } else {
          return false
        }
      })
    },
    SubDbjOrder(ispass) {
      if (!this.dbjloading) {
        this.dbjloading = true
        const otherStr = qs.parse(this.dbjForm.offerOther)
        const rebateStr = []
        const reportStr = []
        const tempStr = []
        for (const rb of this.dbjForm.bjRebateList) {
          if (rb.ischeck) {
            rebateStr.push({ darid: rb.darid, amount: rb.discountAmount })
          }
        }
        for (const rb of this.dbjForm.bjReportList) {
          if (rb.ischeck) {
            reportStr.push({ darid: rb.darid, discount: rb.currentDiscount, amount: rb.discountAmount })
          }
        }
        for (const rb of this.dbjForm.bjTempList) {
          if (rb.ischeck) {
            tempStr.push({ datid: rb.datid, amount: rb.discountAmount })
          }
        }
        const data = {
          ispass: ispass,
          userid: this.user.dUserid,
          orderid: this.dbjForm.orderid,
          qid: this.dbjForm.qid.join(','),
          reason: this.dbjForm.content,
          imgStr: this.dbjForm.imgids.join(','),
          pubImgStr: this.dbjForm.pubimgids.join(','),
          totalprice: this.dbjForm.totalprice,
          wall: this.dbjForm.wall,
          cabinet: this.dbjForm.cabinet,
          access: this.dbjForm.access,
          door: this.dbjForm.door,
          raise: this.dbjForm.raise,
          discount: this.dbjForm.discount,
          best: this.dbjForm.best,
          designcom: this.dbjForm.designcom,
          factorycom: this.dbjForm.factorycom,
          clientcom: this.dbjForm.clientcom,
          other: this.dbjForm.other,
          amount: this.dbjForm.amount,
          otherStr: otherStr,
          aluminum: this.dbjForm.aluminum,
          tiepi: this.dbjForm.tiepi,
          oil: this.dbjForm.oil,
          jokins: this.dbjForm.jokins,
          yt: this.dbjForm.yt,
          paint: this.dbjForm.paint,
          rebateStr: qs.parse(rebateStr),
          reportStr: qs.parse(reportStr),
          tempStr: qs.parse(tempStr)
        }
        offerOrder(data).then(response => {
          let msg = '订单已报价成功'
          if (ispass === 0) {
            msg = '订单已驳回'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.dbjloading = false
          this.dbjVisible = false
          this.getOrder()
        }).catch(() => {
          this.dbjloading = false
        })
      } else {
        return false
      }
    },
    countReportTime() {
      const date = new Date()
      const now = date.getTime()
      const endDate = new Date(this.yfkReportTime.curStartTime)
      const end = endDate.getTime()
      const leftTime = end - now
      if (leftTime >= 0) {
        this.yfkReportTime.day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        const h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
        this.yfkReportTime.hour = h < 10 ? '0' + h : h
        const m = Math.floor(leftTime / 1000 / 60 % 60)
        this.yfkReportTime.min = m < 10 ? '0' + m : m
        const s = Math.floor(leftTime / 1000 % 60)
        this.yfkReportTime.second = s < 10 ? '0' + s : s
      } else {
        this.yfkReportTime.day = 0
        this.yfkReportTime.hour = '00'
        this.yfkReportTime.min = '00'
        this.yfkReportTime.second = '00'
      }
      if (Number(this.yfkReportTime.hour) === 0 && Number(this.yfkReportTime.day) === 0 && Number(this.yfkReportTime.min) === 0 && Number(this.yfkReportTime.second) === 0) {
        return
      } else {
        setTimeout(this.countReportTime, 1000)
      }
    },
    // 退款申请 添加按钮
    refundBtn() {
      this.refundApplyVisible = true
      this.refundApplyForm = {}
      this.refundApplyForm.orderId = this.orderInfo.orderid
      this.refundApplyForm.dealerId = this.orderInfo.delid
      this.refundApplyForm.imgids = []
      this.refundApplyImgList = []
      this.refundApplyImgKey = new Date().getTime()
    },
    // 退款申请 编辑按钮
    refundEditBtn(row) {
      this.refundApplyVisible = true
      this.refundApplyLoading = true
      getCollectRecordByCrid({ crid: row.crid }).then(response => {
        this.refundApplyForm = {
          id: row.crid,
          money: row.money,
          orderId: row.orderId || row.orderid || this.orderInfo.orderid,
          dealerId: row.dealerId || row.delid || this.orderInfo.delid,
          need: row.card == '1' ? true : false,
          receipttime: row.receipttime,
          imgids: [],
          remark: row.remark,
        }
        const oldimgList = []
        for (const img of response.data.imglst) {
          oldimgList.push({ id: img.img_id, url: img.img_url })
        }
        this.refundApplyImgKey = new Date().getTime()
        this.refundApplyImgList = oldimgList
        this.refundApplyLoading = false
      }).catch(() => {
        this.refundApplyLoading = false
      })
    },
    yfkPassBtn() {
      const myDate = new Date()
      const year = myDate.getFullYear()
      let month = myDate.getMonth() + 1
      let day = myDate.getDate()
      let hour = myDate.getHours()
      let min = myDate.getMinutes()
      let sec = myDate.getSeconds()
      month = month > 9 ? month + '' : '0' + month
      day = day > 9 ? day + '' : '0' + day
      hour = hour > 9 ? hour + '' : '0' + hour
      min = min > 9 ? min + '' : '0' + min
      sec = sec > 9 ? sec + '' : '0' + sec
      this.yfkPassForm = {
        orderid: this.orderInfo.orderid,
        ordername: this.orderInfo.ordernum + ' / ' + this.orderInfo.produnum + ' / ' + this.orderInfo.address,
        time: year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec,
        remark: ''
      }
      this.yfkPassVisible = true
    },
    yfkBtn() {
      this.yfkRules.content[0].required = false
      this.yfkisDisabledCode = true
      this.yfkForm.orderid = this.orderInfo.orderid
      this.yfkForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.produnum + ' / ' + this.orderInfo.address
      this.yfkForm.content = ''
      this.yfkofferinfo = []
      this.yfkForm.money = null
      this.yfkForm.accid = null
      this.yfkForm.dedutel = ''
      this.yfkForm.msg_id = ''
      this.yfkForm.code = ''
      this.yfkForm.deposit = 0
      this.yfkForm.accamount = 0
      this.yfkVisible = true
      this.yfkofferinfoLoading = true
      // getDealerTelList({ delid: this.orderInfo.delid, page: 1, limit: 9999999 }).then(response => {
      //   this.yfkDealerTelList = response.data
      // }).catch(() => {})
      getErpOrderOfferDetail({ orderid: this.orderInfo.orderid }).then(response => {
        this.yfkofferinfo = response.data
        if (this.yfkofferinfo.reportEndtime !== null && this.yfkofferinfo.reportEndtime !== '' && this.yfkofferinfo.reportEndtime !== undefined) {
          this.yfkReportTime.curStartTime = this.yfkofferinfo.reportEndtime
          this.countReportTime()
        }
        this.yfkForm.deposit = this.yfkofferinfo.deposit
        this.yfkForm.money = this.yfkForm.deposit
        this.yfkForm.accamount = this.yfkofferinfo.accamount
        this.yfkForm.accid = this.yfkofferinfo.accid
        this.yfkofferinfoLoading = false
      }).catch(() => {
        this.yfkofferinfoLoading = false
      })
    },
    yfkgetCode() {
      if (this.yfkForm.dedutel !== null && this.yfkForm.dedutel !== '' && this.yfkForm.dedutel !== undefined) {
        if (this.yfkForm.deposit > 0) {
          if (this.yfkForm.money !== null && parseFloat(this.yfkForm.money) > 0) {
            if (parseFloat(this.yfkForm.money) <= parseFloat(this.yfkForm.accamount)) {
              if (parseFloat(this.yfkForm.money) >= parseFloat(this.yfkForm.deposit)) {
                if (!this.yfkisDisabledCode) {
                  if (this.yfksounds === 60) {
                    this.yfkisCodeLoading = true
                    const arr = this.yfkForm.dedutel.split('@')
                    const data = {
                      verifyCode: '1434619f6b1b490fc7b225e6c052abd3',
                      opertype: 1,
                      userid: this.user.dUserid,
                      type: 0,
                      dataid: this.yfkForm.orderid,
                      amount: this.yfkForm.money,
                      phoneNum: arr[1],
                      receiver: arr[0]
                    }
                    getDebitSMSCode(data).then(response => {
                      this.yfkForm.msg_id = response.data
                      this.yfkisCodeLoading = false
                      this.yfkisDisabledCode = true
                      this.yfkcodeTimer = setInterval(this.yfkcountdown, 1000)
                    }).catch(() => {
                      this.yfkisCodeLoading = false
                    })
                  } else {
                    this.yfkisDisabledCode = true
                  }
                }
              } else {
                this.$message.error('扣款金额至少为 ' + this.yfkForm.deposit + ' 元')
              }
            } else {
              this.$message.error('账户余额不足')
            }
          } else {
            this.$message.error('请输入扣款金额')
          }
        } else {
          this.$message.error('预付款为0元，无需扣款')
        }
      } else {
        this.$message.error('请选择扣款验证手机号码')
      }
    },
    yfkcountdown() {
      this.yfksounds--
      if (this.yfksounds === 0) {
        clearInterval(this.yfkcodeTimer)
        this.yfkcodeBtn = '获取验证码'
        this.yfkisDisabledCode = false
        this.yfksounds = 60
      } else {
        this.yfkcodeBtn = '重新获取 ' + this.yfksounds
      }
    },
    turnYfk(formName) {
      this.yfkRules.content[0].required = true
      this.yfkRules.money[0].required = false
      this.yfkRules.dedutel[0].required = false
      this.yfkRules.code[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.yfkloading) {
            this.yfkloading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.yfkForm.orderid,
              reason: this.yfkForm.content,
              type: 1
            }
            insteadSubsistDown(data).then(response => {
              this.$message({
                message: '订单已驳回',
                type: 'success'
              })
              this.yfkloading = false
              this.yfkVisible = false
              this.yfksounds = 60
              if (this.yfkcodeTimer !== null && this.yfkcodeTimer !== '' && this.yfkcodeTimer !== undefined) {
                clearInterval(this.yfkcodeTimer)
                this.yfkcodeTimer = ''
                this.yfkcodeBtn = '获取验证码'
                this.yfkisDisabledCode = true
              }
              this.getOrder()
            }).catch(() => {
              this.yfkloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    subEditYfk(formName) {
      this.yfkRules.content[0].required = false
      this.yfkRules.money[0].required = true
      this.yfkRules.dedutel[0].required = true
      this.yfkRules.code[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.yfkloading) {
            this.yfkloading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.yfkForm.orderid,
              content: this.yfkForm.content,
              pay: this.yfkForm.money,
              code: this.yfkForm.code,
              msg_id: this.yfkForm.msg_id,
              type: 1,
              msgSwitch: this.yfkofferinfo.msgSwitch
            }
            insteadSubsist(data).then(response => {
              this.$message({
                message: '订单已代为预付款',
                type: 'success'
              })
              this.yfkloading = false
              this.yfkVisible = false
              this.yfksounds = 60
              if (this.yfkcodeTimer !== null && this.yfkcodeTimer !== '' && this.yfkcodeTimer !== undefined) {
                clearInterval(this.yfkcodeTimer)
                this.yfkcodeTimer = ''
                this.yfkcodeBtn = '获取验证码'
                this.yfkisDisabledCode = true
              }
              this.getOrder()
            }).catch(() => {
              this.yfkloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    subPassYfk(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.yfkPassLoading) {
            this.yfkPassLoading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.yfkPassForm.orderid,
              time: this.yfkPassForm.time,
              remark: this.yfkPassForm.remark
            }
            const bj = this.trackActivities.filter(r => r.name === '订单报价')
            if (bj && bj.length > 0 && bj[0].time) {
              if (new Date(bj[0].time).getTime() > new Date(this.yfkPassForm.time).getTime()) {
                this.$message({
                  message: '过预付时间不能小于订单报价时间',
                  type: 'warning'
                })
                this.yfkPassLoading = false
                return
              }
            }
            passSubsist(data).then(response => {
              this.$message({
                message: '订单已跳过预付',
                type: 'success'
              })
              this.yfkPassLoading = false
              this.yfkPassVisible = false
              this.getOrder()
            }).catch(() => {
              this.yfkPassLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    gcfpBtn() {
      if (!this.gcfpisgetgroup) {
        getFactoryList().then(response => {
          this.gcfpgroupList = response.data
          this.gcfpisgetgroup = true
        }).catch(() => {})
      }
      this.gcfpForm.orderid = this.orderInfo.orderid
      this.gcfpForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.produnum + ' / ' + this.orderInfo.address
      this.gcfpForm.content = ''
      this.gcfpForm.files = []
      this.gcfpForm.imgids = []
      this.gcfpForm.groupid = null
      this.gcfpForm.discount = null
      this.gcfpForm.price = null
      this.gcfpVisible = true
    },
    subEditGcfp(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.gcfploading) {
            this.gcfploading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.gcfpForm.orderid,
              factoryid: this.gcfpForm.groupid,
              content: this.gcfpForm.content,
              fileStr: this.gcfpForm.files.join(','),
              imgStr: this.gcfpForm.imgids.join(','),
              discount: this.gcfpForm.discount,
              price: this.gcfpForm.price
            }
            factoryAssign(data).then(response => {
              this.$message({
                message: '订单工厂已分派成功',
                type: 'success'
              })
              this.gcfploading = false
              this.gcfpVisible = false
              this.getOrder()
            }).catch(() => {
              this.gcfploading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    gcjdBtn() {
      this.gcjdForm.orderid = this.orderInfo.orderid
      this.gcjdForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.produnum + ' / ' + this.orderInfo.address
      this.gcjdForm.content = ''
      this.gcjdForm.files = []
      this.gcjdForm.imgids = []
      this.gcjdVisible = true
    },
    turnGcjd(formName) {
      this.gcjdRules.content[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubGcjdOrder(0)
        } else {
          return false
        }
      })
    },
    subEditGcjd(formName) {
      this.gcjdRules.content[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubGcjdOrder(1)
        } else {
          return false
        }
      })
    },
    SubGcjdOrder(ispass) {
      if (!this.gcjdloading) {
        this.gcjdloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.gcjdForm.orderid,
          reason: this.gcjdForm.content,
          ispass: ispass,
          fileStr: this.gcjdForm.files.join(','),
          imgStr: this.gcjdForm.imgids.join(',')
        }
        factoryOrders(data).then(response => {
          let msg = '接单成功'
          if (ispass === 0) {
            msg = '订单已拒接'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.gcjdloading = false
          this.gcjdVisible = false
          this.getOrder()
        }).catch(() => {
          this.gcjdloading = false
        })
      } else {
        return false
      }
    },
    ddpcBtn() {
      this.ddpcForm.orderid = this.orderInfo.orderid
      this.ddpcForm.ordername = this.orderInfo.ordernum + ' / ' + this.orderInfo.produnum + ' / ' + this.orderInfo.address
      this.ddpcVisible = true
      this.ddpcformLoading = true
      getProcessList({ orderid: this.ddpcForm.orderid }).then(response => {
        this.ddpcForm.process = response.data
        this.ddpcformLoading = false
      }).catch(() => {
        this.ddpcForm.process = []
        this.ddpcformLoading = false
      })
    },
    subEditDdpc(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ddpcloading) {
            this.ddpcloading = true
            let jsonStr = ''
            for (const p of this.ddpcForm.process) {
              jsonStr += '"' + p.process_id + '":' + p.days + ','
            }
            if (jsonStr.length > 0) {
              jsonStr = '{' + jsonStr.substring(0, jsonStr.length - 1) + '}'
            }
            const data = {
              userid: this.user.dUserid,
              orderid: this.ddpcForm.orderid,
              colorinfo: this.ddpcForm.swatch,
              jsonStr: jsonStr
            }
            orderSchedule(data).then(response => {
              this.$message({
                message: '订单排产成功',
                type: 'success'
              })
              this.ddpcloading = false
              this.ddpcVisible = false
              this.getOrder()
            }).catch(() => {
              this.ddpcloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    editOrderInfo() {
      const source = []
      if (this.orderInfoCopy.source.indexOf('厂部标准色板') !== -1) {
        source.push(0)
        this.orderInfoCopy.sids = this.swatchs.map(r => r.board_id)
      }
      if (this.orderInfoCopy.source.indexOf('客户提供色板') !== -1) {
        source.push(1)
      }
      if (this.orderInfoCopy.source.indexOf('厂部定制色板') !== -1) {
        source.push(2)
      }
      this.orderInfoCopy.source = source
      if (!this.orderInfoCopy.sids) this.orderInfoCopy.sids = []
      if (this.orderInfoCopy.oldorderid !== null && this.orderInfoCopy.oldorderid !== '' && this.orderInfoCopy.oldorderid !== undefined) {
        this.isManual = false
        this.editOldorderid = this.orderInfoCopy.oldorderid
        this.orderLoad = new Date().getTime()
      } else {
        this.isManual = true
      }
      if (this.orderInfoCopy.type === 3) {
        this.orderInfoRules.oldorderid[0].required = false
        this.orderInfoRules.beforenum[0].required = false
        this.orderInfoRules.beforeyear[0].required = false
      }
      this.editOrderReportid = []
      getDealerAccountReportByDelid({ delid: this.orderInfoCopy.delid, groupid: this.orderInfoCopy.groupid }).then(response => {
        const rslst = []
        for (const d of response.data) {
          const children = []
          for (const a of d.daralst) {
            if (a.orderid !== null && a.orderid !== '' && a.orderid !== undefined) {
              if (a.orderid === this.orderInfoCopy.orderid) {
                children.push({ value: a.id, label: a.address })
                this.editOrderReportid = [d.darid, a.id]
              } else {
                children.push({ value: a.id, label: a.address + '（已关联）', disabled: true })
              }
            } else {
              children.push({ value: a.id, label: a.address })
            }
          }
          rslst.push({ value: d.darid, label: d.name, children: children })
        }
        this.jdReportList = rslst
      }).catch(() => {
        this.jdReportList = []
      })
      this.getCbList()
      this.editOrderInfoDialog = true
    },
    handleClose(done) {
      this.orderInfoCopy = Object.assign({}, this.orderInfo)
      done()
    },
    goEditOrderInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.orderInfo.produnum !== '' && this.orderInfo.type !== this.orderInfoCopy.type) {
            this.$confirm(`您的此次操作将改变${this.orderInfo.bid === 3 ? '订' : '生产'}单号，确定要继续吗?`, '提示', {
              confirmButtonText: '是的',
              cancelButtonText: '再想想',
              type: 'warning'
            }).then(() => {
              this.eidtOrderBtn = true
              this.orderInfoCopy.reportid = this.editOrderReportid.join(',')
              this.orderInfoCopy.source = this.orderInfoCopy.source.join(',')
              this.orderInfoCopy.sids = this.orderInfoCopy.sids.join(',')
              editOrderInfo(this.orderInfoCopy).then(response => {
                this.$message({
                  type: 'success',
                  message: '订单修改成功'
                })
                this.editOrderInfoDialog = false
                this.eidtOrderBtn = false
                this.getOrder()
              }).catch(() => {
                this.eidtOrderBtn = false
              })
            }).catch(() => {})
          } else {
            this.eidtOrderBtn = true
            this.orderInfoCopy.reportid = this.editOrderReportid.join(',')
            this.orderInfoCopy.source = this.orderInfoCopy.source.join(',')
            this.orderInfoCopy.sids = this.orderInfoCopy.sids.join(',')
            editOrderInfo(this.orderInfoCopy).then(response => {
              this.$message({
                type: 'success',
                message: '订单修改成功'
              })
              this.editOrderInfoDialog = false
              this.eidtOrderBtn = false
              this.getOrder()
            }).catch(() => {
              this.eidtOrderBtn = false
            })
          }
        }
      })
    },
    resetEditOrder(formName) {
      this.orderInfoCopy = Object.assign({}, this.orderInfo)
      this.$refs[formName].resetFields()
    },
    getUserDetail(userId, type) {
      this.userDetailLoading = true
      this.userDetailDialog = true
      getUserDetail({ userid: userId, type: type }).then(response => {
        this.userType = type
        this.userDetail = response.data.user
        this.userDetailLoading = false
      }).catch(() => {
        this.userDetailLoading = false
      })
    },

    getOrderCollectRecord() {
      // // 获取当前经销商账户
      // getDealerAccountData({ delid: this.orderInfo.delid }).then(response => {
      //   this.accountData = response.data.filter(it => it.groupid === this.orderInfo.groupid)[0]
      //   // console.log(this.accountData)
      // }).catch(() => {})
      this.collectRecordDialog = true
      this.collectRecordLoading = true
      orderCollectRecord({ orderid: this.orderid }).then(response => {
        this.collectRecord = response.data
        this.collectRecordLoading = false
      }).catch(() => {
        this.collectRecordLoading = false
      })
    },
    addCollect(crid) {
      if (this.groupList.length <= 0) {
        getGroupReport().then(response => {
          this.groupList = response.data
        }).catch(() => {})
      }
      if (this.accountsList.length <= 0) {
        getAccounts().then(response => {
          this.accountsList = response.data
        }).catch(() => {})
      }
      if (this.receiptNatureList.length <= 0) {
        getReceiptNature().then(response => {
          this.receiptNatureList = response.data
        }).catch(() => {})
      }
      if (this.paycontentList.length <= 0) {
        getPaycontent().then(response => {
          this.paycontentList = response.data
        }).catch(() => {})
      }
      this.editCollectForm.orderid = this.orderInfo.orderid
      this.editCollectForm.crid = crid
      this.editCollectForm.accdataid = null
      if (crid === 0) {
        this.collectTitle = '添加订单收款'
        this.editCollectForm.paycontent = ''
        this.editCollectForm.receipttime = ''
        this.editCollectForm.card = ''
        this.editCollectForm.money = null
        // 色板单价格全款一次性收款
        if (this.orderInfo.type == 3) {
          this.editCollectForm.money = this.offerInfo.balance || this.offerInfo.amount
          this.editCollectForm.paycontent = '全款'
        }
        this.editCollectForm.remark = ''
        this.editCollectForm.aid = null
        this.editCollectForm.nature = ''
        this.editCollectForm.audittime = ''
        this.editCollectForm.auditname = ''
        this.editCollectForm.rson = ''
        this.editCollectForm.imgids = []
        this.editCollectimgList = []
        this.imgCollectLoad = new Date().getTime()
        this.editCollectForm.type = 0
        console.log(this.editCollectForm)
      } else {
        this.collectTitle = '编辑订单收款'
        this.editCollectForm.type = 3
        this.collectInfoLoading = true
        getCollectRecordByCrid({ crid: this.editCollectForm.crid }).then(response => {
          this.editCollectForm.paycontent = response.data.paycontent
          this.editCollectForm.receipttime = response.data.receipttime
          this.editCollectForm.card = response.data.card
          this.editCollectForm.money = response.data.money
          this.editCollectForm.remark = response.data.remark
          this.editCollectForm.aid = response.data.aid
          this.editCollectForm.nature = response.data.nature
          this.editCollectForm.audittime = response.data.audittime
          this.editCollectForm.auditname = response.data.auditname
          this.editCollectForm.rson = response.data.rson
          const oldimgList = []
          for (const img of response.data.imglst) {
            oldimgList.push({ id: img.img_id, url: img.img_url })
          }
          this.editCollectimgList = oldimgList
          this.imgCollectLoad = new Date().getTime()
          this.collectInfoLoading = false
        }).catch(() => {
          this.collectInfoLoading = false
        })
      }
      // 123456
      this.collectInfoLoading = true
      getErpOrderOfferDetail({ orderid: this.orderInfo.orderid }).then(response => {
        this.editCollectForm.accid = response.data.accid
        this.editCollectForm.accamount = response.data.accamount
        this.editCollectForm.accname = response.data.accname
        this.editCollectForm.joinId = response.data.joinId
        this.editCollectForm.leftJoin = response.data.leftJoin
        this.collectInfoLoading = false
      }).catch(() => {
        this.collectInfoLoading = false
      })
      // 123456
      this.editCollectVisible = true
    },
    subCollectEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editCollectloading) {
            if (this.editCollectForm.money === null || this.editCollectForm.money === '' || this.editCollectForm.money === undefined) {
              this.editCollectForm.money = 0
            }
            if (this.editCollectForm.paycontent === '收款抹零') {
              if (parseFloat(this.editCollectForm.money) > 5) {
                this.$message.error('抹零金额不可超过5元')
                return false
              }
            } else {
              if (this.editCollectForm.type === 0) { // 账户扣款
                if (parseFloat(this.editCollectForm.accamount) < parseFloat(this.editCollectForm.money)) {
                  this.$message.error('账户余额不足')
                  return false
                }
              } else if (this.editCollectForm.type === 3) { // 订单收款
              } else if (this.editCollectForm.type === 5) { // 返点抵款
                if (this.editCollectForm.accdataid === null || this.editCollectForm.accdataid === '' || this.editCollectForm.accdataid === undefined) {
                  this.$message.error('请选择返点账户')
                  return false
                }
                if (this.editCollectForm.rebateInfo.balance === null || this.editCollectForm.rebateInfo.balance === '' || this.editCollectForm.rebateInfo.balance === undefined) {
                  this.$message.error('请选择返点账户')
                  return false
                }
                if (parseFloat(this.editCollectForm.rebateInfo.balance) < parseFloat(this.editCollectForm.money)) {
                  this.$message.error('账户余额不足')
                  return false
                }
              } else if (this.editCollectForm.type === 6) { // 售后赔款
                if (this.editCollectForm.accdataid === null || this.editCollectForm.accdataid === '' || this.editCollectForm.accdataid === undefined) {
                  this.$message.error('请选择售后赔款账户')
                  return false
                }
                if (this.editCollectForm.afterInfo.balance === null || this.editCollectForm.afterInfo.balance === '' || this.editCollectForm.afterInfo.balance === undefined) {
                  this.$message.error('请选择售后赔款账户')
                  return false
                }
                if (parseFloat(this.editCollectForm.afterInfo.balance) < parseFloat(this.editCollectForm.money)) {
                  this.$message.error('账户余额不足')
                  return false
                }
              } else if (this.editCollectForm.type === 7) { // 报备金冲抵
                if (this.editCollectForm.accdataid === null || this.editCollectForm.accdataid === '' || this.editCollectForm.accdataid === undefined) {
                  this.$message.error('请选择报备金账户')
                  return false
                }
                if (this.editCollectForm.reportInfo.balance === null || this.editCollectForm.reportInfo.balance === '' || this.editCollectForm.reportInfo.balance === undefined) {
                  this.$message.error('请选择报备金账户')
                  return false
                }
                if (parseFloat(this.editCollectForm.reportInfo.balance) < parseFloat(this.editCollectForm.money)) {
                  this.$message.error('账户余额不足')
                  return false
                }
              } else if (this.editCollectForm.type === 8) { // 样品预存款抵扣
                if (parseFloat(this.editCollectForm.leftJoin) < parseFloat(this.editCollectForm.money)) {
                  this.$message.error('账户余额不足')
                  return false
                }
              } else if (this.editCollectForm.type === 9) { // 冲业绩抵扣
                if (this.editCollectForm.accdataid === null || this.editCollectForm.accdataid === '' || this.editCollectForm.accdataid === undefined) {
                  this.$message.error('请选择冲业绩抵扣账户')
                  return false
                }
                if (this.editCollectForm.achievementInfo.balance === null || this.editCollectForm.achievementInfo.balance === '' || this.editCollectForm.achievementInfo.balance === undefined) {
                  this.$message.error('请选择冲业绩抵扣账户')
                  return false
                }
                if (parseFloat(this.editCollectForm.achievementInfo.balance) < parseFloat(this.editCollectForm.money)) {
                  this.$message.error('账户余额不足')
                  return false
                }
              } else if (this.editCollectForm.type === 10) { // 零售项目
                if (this.editCollectForm.accdataid === null || this.editCollectForm.accdataid === '' || this.editCollectForm.accdataid === undefined) {
                  this.$message.error('请选择零售项目')
                  return false
                }
                if (this.editCollectForm.projectInfo.balance === null || this.editCollectForm.projectInfo.balance === '' || this.editCollectForm.projectInfo.balance === undefined) {
                  this.$message.error('请选择零售项目')
                  return false
                }
                if (parseFloat(this.editCollectForm.projectInfo.balance) < parseFloat(this.editCollectForm.money)) {
                  this.$message.error('零售项目余额不足')
                  return false
                }
              } else {
                this.$message.error('请选择收款类型')
                return false
              }
            }
            if (parseFloat(this.editCollectForm.money) <= 0) {
              this.$message.error('收款金额不可为0')
              return false
            }
            this.editCollectloading = true
            const data = {
              userid: this.user.dUserid,
              crid: this.editCollectForm.crid,
              type: this.editCollectForm.type,
              accid: this.editCollectForm.accid,
              paycontent: this.editCollectForm.paycontent,
              money: this.editCollectForm.money,
              remark: this.editCollectForm.remark,
              orderid: this.editCollectForm.orderid,
              card: this.editCollectForm.card,
              receipttime: this.editCollectForm.receipttime,
              accdataid: this.editCollectForm.accdataid,
              aid: this.editCollectForm.aid,
              nature: this.editCollectForm.nature,
              imgids: this.editCollectForm.imgids.join(','),
              joinId: this.editCollectForm.joinId
            }
            editOrderCollectRecord(data).then(response => {
              if (this.editCollectForm.crid === 0) {
                this.$message({
                  message: '订单收款添加成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  message: '订单收款编辑成功',
                  type: 'success'
                })
              }
              this.getOrder()
              this.editCollectForm.type = 3
              this.editCollectloading = false
              this.editCollectVisible = false
              this.getOrderCollectRecord()
            }).catch(() => {
              this.editCollectloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    delCollect(row) {
      if (row.type == 9) {
        this.$confirm('删除此订单冲业绩抵扣, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fullscreenLoading = true
          delAchievementApply({ crid: row.crid }).then(response => {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getOrder()
            this.fullscreenLoading = false
            this.getOrderCollectRecord()
          }).catch(() => {
            this.fullscreenLoading = false
          })
        }).catch(() => {})
        return
      }
      // 11-退款
      if (row.type == 11) {
        this.$confirm('删除此订单退款申请, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fullscreenLoading = true
          delOrderCollectRecord({ crid: row.crid }).then(response => {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getOrder()
            this.fullscreenLoading = false
            this.getOrderCollectRecord()
          }).catch(() => {
            this.fullscreenLoading = false
          })
        }).catch(() => {})
        return
      }
      this.$confirm('删除此订单收款, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        delOrderCollectRecord({ crid: row.crid }).then(response => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getOrder()
          this.fullscreenLoading = false
          this.getOrderCollectRecord()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },

    subRefundApply(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.refundApplyLoading) {
            if (this.refundApplyForm.money === null || this.refundApplyForm.money === '' || this.refundApplyForm.money === undefined) {
              this.refundApplyForm.money = 0
            }
            if (parseFloat(this.refundApplyForm.money) <= 0) {
              this.$message.error('退款金额不可为0')
              return false
            }
            this.refundApplyLoading = true
            const data = {
              userId: this.user.dUserid,
              id: this.refundApplyForm.id,
              money: this.refundApplyForm.money,
              orderId: this.refundApplyForm.orderId,
              dealerId: this.refundApplyForm.dealerId,
              need: this.refundApplyForm.need ? 1 : 0,
              receipttime: this.refundApplyForm.receipttime,
              imgids: this.refundApplyForm.imgids.join(','),
              remark: this.refundApplyForm.remark,
            }
            doRefund(data).then(response => {
              this.$message({
                message: '订单退款申请成功',
                type: 'success'
              })
              this.getOrder()
              this.refundApplyLoading = false
              this.refundApplyVisible = false
              this.getOrderCollectRecord()
            }).catch(() => {
              this.refundApplyLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },

    getOrderPrice(val) {
      if (val !== '' && val !== null) {
        getFactoryPrice({ orderid: this.orderid, factoryid: val }).then(response => {
          if (response.data !== null) {
            this.gcfpForm.discount = response.data.factoryDiscount
            this.gcfpForm.price = response.data.factoryAmount
          }
        })
      } else {
        this.gcfpForm.discount = null
        this.gcfpForm.price = null
      }
    },
    viewCollect(row) {
      this.viewCollectVisible = true
      this.viewCollectLoading = true
      getCollectRecordByCrid({ crid: row.crid }).then(response => {
        this.viewCollectData = response.data
        const oldimgList = []
        for (const img of response.data.imglst) {
          oldimgList.push(img.img_url)
        }
        this.viewCollectImg = oldimgList
        this.viewCollectLoading = false
      }).catch(() => {
        this.viewCollectLoading = false
      })
    },
    operAfter() {
      if (this.editAfterinfoData.afterReasonOption !== null && this.editAfterinfoData.afterReasonOption.length === 0) {
        getAfterReason().then(response => {
          const afterReasonOption = []
          for (const r of response.data) {
            const children = []
            for (const a of r.list) {
              children.push({ value: a.arid, label: a.name })
            }
            afterReasonOption.push({ value: r.rtid, label: r.name, children: children })
          }
          this.editAfterinfoData.afterReasonOption = afterReasonOption
        }).catch(() => {})
      }
      if (this.editAfterinfoData.groupList !== null && this.editAfterinfoData.groupList.length === 0) {
        getFactoryList().then(response => {
          this.editAfterinfoData.groupList = response.data
        }).catch(() => {
        })
      }
      this.editAfterVisible = true
      this.editAfterLoading = true
      this.editAfterinfoData.afterEditForm.asid = this.afterInfo.after_id
      this.editAfterinfoData.afterEditForm.depts = []
      this.editAfterinfoData.afterEditForm.rson = []
      getAfterSalePageInfo({ afterid: this.afterInfo.after_id }).then(response => {
        this.editAfterinfoData.afterEditForm.ordernum = response.data.order.ordernum
        this.editAfterinfoData.afterEditForm.productnum = response.data.order.beforenum
        this.editAfterinfoData.afterEditForm.factory = response.data.order.product_factory
        this.editAfterinfoData.afterEditForm.delname = response.data.order.all_name
        this.editAfterinfoData.afterEditForm.time = response.data.order.time
        this.editAfterinfoData.afterEditForm.address = response.data.order.address
        this.editAfterinfoData.afterEditForm.content = response.data.afterSale.content
        this.editAfterinfoData.afterEditForm.bid = response.data.order.bid
        // 处理售后原因的多选，责任部门的多选
        const manyReason = response.data.afterSale.reasonList
        const manyDept = response.data.afterSale.deptList
        const reasonArr = []
        for (const reason of manyReason) {
          const reasonItem = []
          reasonItem.push(reason.rtid)
          reasonItem.push(reason.arid)
          reasonArr.push(reasonItem)
        }
        this.editAfterinfoData.afterEditForm.rson = reasonArr
        for (const dept of manyDept) {
          this.editAfterinfoData.afterEditForm.depts.push(dept.groupnum)
        }
        this.editAfterinfoData.afterEditForm.reworkid = ''
        if (response.data.afterSale.reworkid) {
          this.editAfterinfoData.oldFile = [{ name: response.data.afterSale.reworkname, id: response.data.afterSale.reworkid }]
        } else {
          this.editAfterinfoData.oldFile = []
        }
        this.editAfterinfoData.fileLoad = new Date().getTime()
        if (response.data.afterSale.decisionid !== null && response.data.afterSale.decisionid !== '' && response.data.afterSale.decisionid !== undefined) {
          this.editAfterinfoData.afterEditForm.decisionid = { imgid: response.data.afterSale.decisionid, imgurl: response.data.afterSale.decision_url }
          this.editAfterinfoData.oldImg = response.data.afterSale.decision_url
        } else {
          this.editAfterinfoData.afterEditForm.decisionid = null
          this.editAfterinfoData.oldImg = ''
        }
        this.editAfterinfoData.imgLoad = new Date().getTime()
        this.editAfterinfoData.afterEditForm.rtid = response.data.afterSale.rtid
        this.editAfterinfoData.afterEditForm.arid = response.data.afterSale.arid
        if (response.data.afterSale.gourpid !== 0) {
          this.editAfterinfoData.afterEditForm.gourpid = response.data.afterSale.gourpid
        } else {
          this.editAfterinfoData.afterEditForm.gourpid = null
        }
        this.editAfterinfoData.afterEditForm.amount = response.data.afterSale.amount
        this.editAfterinfoData.afterEditForm.remark = response.data.afterSale.remark
        this.editAfterinfoData.afterEditForm.opinions = response.data.afterSale.opinions ? JSON.parse(response.data.afterSale.opinions) : {}
        this.editAfterLoading = false
      }).catch(() => {
        this.editAfterLoading = false
      })
      this.editAfterinfoData.editRules.reworkid[0].required = false
      this.editAfterinfoData.editRules.decisionid[0].required = false
      this.editAfterinfoData.editRules.rson[0].required = true
      this.editAfterinfoData.editRules.gourpid[0].required = true
      this.editAfterinfoData.editRules.depts[0].required = true
      this.editAfterinfoData.editRules.remark[0].required = false
    },
    subAfterEdit(formName) {
      this.editAfterinfoData.editRules.reworkid[0].required = false
      this.editAfterinfoData.editRules.decisionid[0].required = false
      this.editAfterinfoData.editRules.rson[0].required = true
      this.editAfterinfoData.editRules.gourpid[0].required = true
      this.editAfterinfoData.editRules.remark[0].required = false
      let isok = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          isok = true
        }
      })
      if (isok) {
        if (!this.editAfterSubLoading) {
          this.editAfterSubLoading = true
          let imgid = ''
          if (this.editAfterinfoData.afterEditForm.decisionid !== null && this.editAfterinfoData.afterEditForm.decisionid !== undefined) {
            imgid = this.editAfterinfoData.afterEditForm.decisionid.imgid
          }
          // 责任原因多选数组
          const reasonArr = []
          for (let i = 0; i < this.editAfterinfoData.afterEditForm.rson.length; i++) {
            const obj = {
              key: this.editAfterinfoData.afterEditForm.rson[i][0],
              value: this.editAfterinfoData.afterEditForm.rson[i][1]
            }
            reasonArr.push(obj)
          }
          const data = {
            userid: this.user.dUserid,
            afterid: this.editAfterinfoData.afterEditForm.asid,
            fileid: this.editAfterinfoData.afterEditForm.reworkid,
            imgid: imgid,
            remark: this.editAfterinfoData.afterEditForm.remark,
            opinions: JSON.stringify(this.editAfterinfoData.afterEditForm.opinions)
          }
          editAfterSaleFile(data).then(response => {
            this.$message({
              message: '售后处理修改成功',
              type: 'success'
            })
            this.editAfterSubLoading = false
            this.editAfterVisible = false
            this.getOrder()
          }).catch(() => {
            this.editAfterSubLoading = false
          })
        } else {
          return false
        }
      }
    },

    // 供应商-查询字典
    getSupplierList() {
      listDictByType({ type: 'supplier_config' }).then(response => {
        this.supplierList = response.data || []
        if (this.orderProcureForm.supplier && this.supplierList.length == 0) {
          this.orderProcureForm.supplier = ''
        }
      }).catch(() => {})
    },
    // 订单采购列表
    listOrderProcure() {
      this.orderProcureDialog = true
      this.orderProcureLoading = true
      getOrderProcureList({ orderid: this.orderid }).then(response => {
        this.orderProcureList = response.data
        this.orderProcureLoading = false
      }).catch(() => {
        this.orderProcureLoading = false
      })
    },
    // 添加订单采购
    addOrderProcure() {
      this.orderProcureFormVisible = true
      this.orderProcureForm.orderid = this.orderid
      this.orderProcureForm.files = []
      this.orderProcureForm.imgids = []
      this.orderProcureForm.oldFiles = []
      this.orderProcureForm.oldImages = []
      this.getSupplierList()
    },
    // 提交订单采购
    submitOrderProcure(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && !this.orderProcureFormLoading) {
          this.orderProcureFormLoading = true
          const data = {
            userid: this.user.dUserid,
            d_opid: this.orderProcureForm.opid,
            orderid: this.orderProcureForm.orderid,
            supplier: this.orderProcureForm.supplier,
            content: this.orderProcureForm.content,
            money: this.orderProcureForm.money,
            paytime: this.orderProcureForm.paytime,
            paycard: this.orderProcureForm.paycard,
            receivecard: this.orderProcureForm.receivecard,
            remark: this.orderProcureForm.remark,
            imgStr: this.orderProcureForm.imgids.join(','),
            files: this.orderProcureForm.files.join(',')
          }
          saveOrderProcure(data).then(response => {
            this.$message({
              message: '订单采购添加成功',
              type: 'success'
            })
            this.orderProcureFormVisible = false
            this.orderProcureFormLoading = false
            this.orderProcureForm = {}
            this.listOrderProcure()
          }).catch(() => {
            this.orderProcureFormLoading = false
          })
        } else {
          return false
        }
      })
    },
    // 查看订单采购
    seeOrderProcure(row) {
      this.orderProcureViewData = row
      const imgList = []
      for (const img of row.imglst) {
        imgList.push(img.img_path)
      }
      this.orderProcureViewData.imgList = imgList
      this.orderProcureViewData.fileList = row.filelst
      this.orderProcureViewVisible = true
    },
    // 删除订单采购
    delOrderProcure(row) {
      this.$confirm('删除此订单采购, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        deleteOrderProcure({ d_opid: row.opid }).then(response => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.fullscreenLoading = false
          this.listOrderProcure()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },

    exportExcelMaterial() {
      if (this.multipleSelection.length > 0) {
        if (!this.exportMaterialLoading) {
          this.exportMaterialLoading = true
          const packids = []
          for (const p of this.multipleSelection) {
            packids.push(p.packid)
          }
          const data = {
            orderid: this.packForm.orderid,
            packids: packids.join(',')
          }
          exportShippingList(data).then(response => {
            this.exportMaterialLoading = false
            const _this = this
            const xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.file_url, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                const blob = this.response
                const a = document.createElement('a')
                a.download = response.data.dName
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a',
                      { attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }}, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {
                })
              }
            }
            xhr.send()
          }).catch(() => {
            this.exportMaterialLoading = false
          })
        }
      } else {
        this.$message.error('至少选择一个包装进行导出')
      }
    },
    openDetails(row) {
      if (row.bid === 3) {
        this.packTitle = row.ordernum + ' 打包详细'
      } else {
        this.packTitle = row.produnum + ' 打包详细'
      }
      this.packForm.orderid = row.orderid
      this.packForm.packnum = ''
      this.packForm.xuhao = ''
      this.packVisible = true
      this.searchPack(this.packForm)
    },
    checkboxT(row, rowIndex) {
      if (row.imark === 1 && row.omark === 0) {
        return true
      } else {
        return false
      }
    },
    // 出库申请
    applyOut(row) {
      if (row.bid === 3) {
        this.editPackTitle = row.ordernum + ' 包装详细'
      } else {
        this.editPackTitle = row.produnum + ' 包装详细'
      }
      this.editPackForm.orderid = row.orderid
      this.editPackForm.packnum = ''
      this.editPackForm.xuhao = ''
      this.editPackVisible = true
      this.searchPack(this.editPackForm)
    },
    applyPackOut() {
      if (!this.fullscreenLoading) {
        if (this.multipleSelection.length > 0) {
          const packIds = []
          for (const p of this.multipleSelection) {
            packIds.push(p.packid)
          }
          this.$confirm('此操作将申请出库此 ' + packIds.length + ' 个包装, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.fullscreenLoading = true
            const data = {
              orderid: this.editPackForm.orderid,
              packIds: packIds.join(','),
              userid: this.user.dUserid
            }
            applyOutStock(data).then(response => {
              this.fullscreenLoading = false
              this.$message({
                message: '申请出库成功',
                type: 'success'
              })
              this.searchPack(this.editPackForm)
            }).catch(() => {
              this.fullscreenLoading = false
            })
          }).catch(() => {})
        } else {
          this.$message.error('至少选择一个包装进行申请出库')
        }
      }
    },
    // 订单完成
    finish(row) {
      this.finishForm.orderid = row.orderid
      this.finishForm.ordername = row.ordernum + ' / ' + row.address
      this.finishForm.rson = ''
      this.finishVisible = true
    },
    subFinish(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.finishLoading) {
            this.finishLoading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.finishForm.orderid,
              remark: this.finishForm.rson
            }
            orderOver(data).then(response => {
              this.$message({
                message: '订单已完成',
                type: 'success'
              })
              this.finishLoading = false
              this.finishVisible = false
              this.getOrder()
            }).catch(() => {
              this.finishLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    searchPack(info) {
      this.multipleSelection = []
      this.packTableData = []
      this.packloading = true
      const data = {
        orderid: info.orderid,
        packnum: info.packnum,
        xuhao: info.xuhao,
        imark: 1,
        isall: 1,
        iskc: 1
      }
      getErpOrderPackList(data).then(response => {
        this.packTableData = response.data
        this.packloading = false
      }).catch(() => {
        this.packloading = false
      })
    },
    openPackDetails(row) {
      this.$refs.packTable.toggleRowExpansion(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    }

  }
}
</script>

<style lang="scss" scoped>
.orderHomepage-container{
  .mt{
    margin-top: 20px;
  }
  .order-info{
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    .tit{
      color:#99a9bf;
    }
    .price{
      color:#F56C6C;
      font-weight: 500;
    }
    .mf{
      margin-left: 30px
    }
    .link{
      color:#409EFF;
      cursor: pointer;
      font-weight: 500;
      &:hover{
        opacity: 0.8;
      }
    }
    .file-item{
      cursor: pointer;
      background: #f6f7fa;
      color:#909399;
      padding: 10px 10px 10px 44px;
      position: relative;
      width: 100%;
      i{
        position: absolute;
        font-size: 30px;
        left: 10px;
        top:10px;
      }
      .file-name{
        width: 100%;
        height: 30px;
        font-size: 12px;
        line-height: 15px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      &:hover{
        color:#409EFF;
      }
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
  .info-ellipsis{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .order-track{
    overflow-x: auto;
    overflow-y: hidden;
    .order-track-info{
      width: 2240px;
      position: relative;
      .el-steps{
        .el-step{
          flex-basis: 160px!important;
        }
      }
    }
  }
  .order-dynamic-not{
    width: 100%;
    height: 100px;
    line-height: 100px;
    font-size: 12px;
    color:#999;
    text-align: center;
  }
  .order-dynamic-item{
    width: 100%;
    position: relative;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f5f7fa;
    padding-left: 60px;
    padding-right: 60px;
    min-height: 60px;
    .photo{
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
      top:0;
    }
    .info{
      position: relative;
      padding-right: 40px;
      width: 100%;
      .username{
        margin-bottom: 6px;
        span{
          &:first-child{
            font-size: 14px;
            font-weight: 500;
            margin-right: 6px;
          }
        }
      }
      .time{
        font-size: 12px;
        color:#999;
        margin-bottom: 6px;
        position: absolute;
        right: 0;
        top:4px;
      }
      .content{
        margin-bottom: 6px;
      }
      .files{
        position: relative;
        width: 100%;
        .file-item{
          cursor: pointer;
          float: left;
          background: #f6f7fa;
          color:#909399;
          padding: 10px 10px 10px 44px;
          position: relative;
          width: 200px;
          margin-right: 10px;
          margin-bottom: 6px;
          .el-icon-document{
            position: absolute;
            font-size: 30px;
            left: 10px;
            top:10px;
          }
          .file-name{
            width: 100%;
            height: 30px;
            font-size: 12px;
            line-height: 15px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .lessonplay{
            width: 100%;
            height: 100%;
            display: none;
            position: absolute;
            top:0;
            left: 0;
            background: rgba(0,0,0,0.6);
            color:#fff;
            text-align: center;
            line-height: 50px;
            span{
              margin-right: 20px;
              font-weight: bold;
              &:hover{
                color:#94c8fc;
              }
              &:last-child{
                margin-right: 0;
              }
            }
          }
          &:hover{
            .lessonplay{
              display: block;
            }
          }
        }
        .dwg{
          padding: 10px 50px 10px 44px;
          .online-view{
            width: 50px;
            position: absolute;
            right: 0;
            top:0;
          }
        }
        &:after,&:before{
          content: '';
          display: block;
          clear: both;
        }
      }
      .imgs{
        .dynamic-img{
          width:60px;
          height: 60px;
          margin-right: 10px;
          border:1px dashed #f5f7fa;
        }
      }
    }
    &:last-child{
      border-bottom: 0px;
    }
  }
  .user-item{
    color:#99a9bf;
    margin-bottom: 20px;
    font-size: 13px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    span{
      font-weight: 400;
      color: #606266;
    }
    i{
      margin-right: 5px;
    }
  }
  .menu-list{
    width: 100%;
    position: relative;
    .menu-item{
      float: left;
      width: 80px;
      margin: 4px 10px 10px 0;
      padding:10px;
      position: relative;
      border-radius: 2px;
      cursor: pointer;
      .menu-item-img{
        text-align: center;
        width: 100%;
        svg{
          width: 50px!important;
          height: 50px!important;
        }
      }
      .menu-item-name{
        width: 100%;
        text-align: center;
        padding-top: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        font-weight: bold;
      }
      .el-badge__content{
        top: 20px!important;
        right: 30px!important;
      }
      &:hover{
        background: #f5f7fa;
      }
    }
    &:after{
      content: ' ';
      clear: both;
      display: table;
    }
  }
}

.cyj-table {
  tr th {
    width: 92px;
  }
}

.view-info {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .tit {
    color: #606266;
    display: flex;

    span {
      font-weight: bold;
    }
  }
}
</style>
